import React from "react";
import { flushSync } from "react-dom";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
// MDB SHIMS IMPORT
import Button from "../../Component/MDBShim/Button";
import CardHeader from "../../Component/MDBShim/CardHeader";
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import Col from "../../Component/MDBShim/Col";
import Row from "../../Component/MDBShim/Row";
import Container from "../../Component/MDBShim/Container";
import Dropdown from "../../Component/MDBShim/Dropdown";
import DropdownToggle from "../../Component/MDBShim/DropdownToggle";
import DropdownMenu from "../../Component/MDBShim/DropdownMenu";
import DropdownItem from "../../Component/MDBShim/DropdownItem";
import Fa from "../../Component/MDBShim/Fa";
import Input from "../../Component/MDBShim/Input";
import Modal from "../../Component/MDBShim/Modal";
import ModalHeader from "../../Component/MDBShim/ModalHeader";
import ModalBody from "../../Component/MDBShim/ModalBody";
import ModalFooter from "../../Component/MDBShim/ModalFooter";
import Spinner from "../../Component/MDBShim/Spinner";
import TabContent from "../../Component/MDBShim/TabContent";
import TabPane from "../../Component/MDBShim/TabPane";
import ToastContainer from "../../Component/MDBShim/ToastContainer";
import toast from "../../Component/MDBShim/toast";
import MDBModal from "../../Component/MDBShim/MDBModal";
import MDBContainer from "../../Component/MDBShim/MDBContainer";
import MDBSelect from "../../Component/MDBShim/MDBSelect";
import MDBCol from "../../Component/MDBShim/MDBCol";
import MDBRow from "../../Component/MDBShim/MDBRow";
import MDBCard from "../../Component/MDBShim/MDBCard";
import MDBCardHeader from "../../Component/MDBShim/MDBCardHeader";
import MDBCardBody from "../../Component/MDBShim/MDBCardBody";
import MDBIcon from "../../Component/MDBShim/MDBIcon";
import MDBBtn from "../../Component/MDBShim/MDBBtn";
import MDBModalBody from "../../Component/MDBShim/MDBModalBody";
import MDBModalFooter from "../../Component/MDBShim/MDBModalFooter";
import MDBInput from "../../Component/MDBShim/MDBInput";
import MDBModalHeader from "../../Component/MDBShim/MDBModalHeader";
import MDBListGroupItem from "../../Component/MDBShim/MDBListGroupItem";
import MDBSpinner from "../../Component/MDBShim/MDBSpinner";
import MDBTabContent from "../../Component/MDBShim/MDBTabContent";
import MDBTabPane from "../../Component/MDBShim/MDBTabPane";
import MDBBtnGroup from "../../Component/MDBShim/MDBBtnGroup";
import MDBCollapse from "../../Component/MDBShim/MDBCollapse";
import MDBNav from "../../Component/MDBShim/MDBNav";
import MDBNavItem from "../../Component/MDBShim/MDBNavItem";
import MDBNavLink from "../../Component/MDBShim/MDBNavLink";
import Select from "react-select";
import NotesTab from "./PatientViewComponents/notesTab";
import AttachmentsTab from "./PatientViewComponents/attachmentsTab";
import NoteService from "../Security/NoteService/noteService";
import moment from "moment";
import OrderService from "../Security/OrderService/orderService";
import "./patientView.css";
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableRowDetail,
  TableColumnResizing,
} from "@devexpress/dx-react-grid-material-ui";
import {
  PagingState,
  IntegratedPaging,
  RowDetailState,
} from "@devexpress/dx-react-grid";
import ComplaintService from "../Security/ComplaintService/ComplaintService";
import PatientOrders from "../Security/PatientService/patientOrdersService";
import PatientNoteService from "../Security/PatientNoteService/PatientNoteService";
import ReactTooltip from "react-tooltip";
import googleService from "../Security/GoogleService/GoogleService";
import ServiceOrderReasonService from "../Security/ServiceOrderReasonService/ServiceOrderReasonService";
import patientPhoneService from "../Security/PatientService/PatientPhoneService";
import GlobalFunctions from "../Filters/GlobalFunctions";
import PageHeader from "../../Components/Custom/pageHeader";
import CreateQuoteModalFromTicket from "./PatientViewComponents/CreateQuoteModalFromTicket";
import insuranceService from "../Security/InsuranceService/insuranceService";
import partsService from "../Security/ProductService/partsService";
import PverifyModal from "./PatientViewComponents/pverifyModal";
import globalFunctions from "../Filters/GlobalFunctions";
import DialogAddNote from "../../Component/Dialog/DialogAddNote";
import DialogSearchOrderStatusReason from "../../Component/Dialog/Search/DialogSearchOrderStatusReason";

//SP Component Imports
import EmptyState from "../../Component/EmptyState";

//MUI Imports
import MUIAutoComplete from "@mui/material/Autocomplete";
import MUIButton from "@mui/material/Button";
import MUIIconButton from "@mui/material/IconButton";
import MUIButtonGroup from "@mui/material/ButtonGroup";
import MUILoadingButton from "@mui/lab/LoadingButton";
import MUIDialog from "@mui/material/Dialog";
import MUIDialogActions from "@mui/material/DialogActions";
import MUIDialogContent from "@mui/material/DialogContent";
import MUIDialogContentText from "@mui/material/DialogContentText";
import MUIDialogTitle from "@mui/material/DialogTitle";
import MUIAlert from "@mui/material/Alert";
import MUIAlertTitle from "@mui/material/AlertTitle";
import MUIChip from "@mui/material/Chip";
import MUITextField from "@mui/material/TextField";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIGrid from "@mui/material/Grid";
import MUIRadio from "@mui/material/Radio";
import MUICheckbox from "@mui/material/Checkbox";
import MUIFormControl from "@mui/material/FormControl";
import MUIFormLabel from "@mui/material/FormLabel";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUIBox from "@mui/material/Box";
import MUIContainer from "@mui/material/Container";
import MUITypography from "@mui/material/Typography";
import MUIBlueColor from "@mui/material/colors/blue";
import MUILightBlueColor from "@mui/material/colors/lightBlue";
import MUIRedColor from "@mui/material/colors/red";
import MUIArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MUITooltip from "@mui/material/Tooltip";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUICheckCircleIcon from "@mui/icons-material/CheckCircle";
import MUICancelIcon from "@mui/icons-material/Cancel";
import MUIHelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MUISmartphoneIcon from "@mui/icons-material/Smartphone";
import MUIFaxIcon from "@mui/icons-material/Fax";
import MUIPlaceIcon from "@mui/icons-material/Place";
import MUIDivider from "@mui/material/Divider";
import MUIPaper from "@mui/material/Paper";
import MUITableContainer from "@mui/material/TableContainer";
import MUITable from "@mui/material/Table";
import MUITableBody from "@mui/material/TableBody";
import MUITableCell from "@mui/material/TableCell";
import MUITableHead from "@mui/material/TableHead";
import MUITableRow from "@mui/material/TableRow";
import MUIAddIcon from "@mui/icons-material/Add";

import DialogCreateNewOrder from "../../Component/Dialog/DialogCreateNewOrder";
import BtProductService from "../Security/BtProductService/btProductService";
import Security from "../../Utility/Security";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import { closeSnackbar as NotistackCloseSnackbar } from "notistack";
import DialogAddPatientFeedback from "../../Component/Dialog/DialogAddPatientFeedback";
import Progress from "../../Component/Progress";
import Validator from "../../Utility/Validator";
import DialogPatientIssueAlert from "../../Component/Dialog/DialogPatientIssueAlert";
import IssueCategory from "../../Utility/Crud/IssueCategory";
import OrderStatusReason from "../../Utility/Crud/OrderStatusReason";
import LayerLegacy from "../../LayerLegacy";
import ApprovalSummary from "../../Component/ApprovalSummary";
import DialogUpdateBrightreeExternalId from "../../Component/Dialog/DialogUpdateBrightreeExternalId";
import Throttle from "../../Utility/Throttle";
import api from "../Security/api";
import DiagnosisCode from "../../Utility/Crud/DiagnosisCode";
import MainContext from "../../Context/MainContext/MainContext";
import User from "../../Utility/Crud/User";
import MUIThemeProvider from "@mui/material/styles/ThemeProvider";
import MUICreateTheme from "@mui/material/styles/createTheme";
import Format from "../../Utility/Format";

const fixedLightMaterialUITheme = MUICreateTheme({
  palette: { mode: "light" },
});

const apiKey = "AIzaSyAM9_trzKLE1Y2J7eWPSjl3i5jrtgBHe9s"; // google

export default class PatientView extends LayerLegacy {
  legacyContactInfoTooltip =
    "To change Contact Information, please use the new experiance.";
  legacyTicketCreationTooltip =
    "Please use the new experience to create tickets.";
  legacyPatientInfoEditTooltip =
    "Please use the new experience to update patient information.";

  constructor(props) {
    super(props);
    let shouldOpenOrderId = parseInt(props.match.params.orderId) || null;

    let geoCodeClient = {};

    if (window.tg) {
      try {
        geoCodeClient = new window.tg.GeocodingClient(apiKey);
      } catch (e) {
        console.log(e);
      }
    }

    const groupColumns = [{ columnName: "status" }];

    const tOptions = [
      {
        text: "Setup Issue – patient was not setup correctly on initial delivery",
        value:
          "Setup Issue – patient was not setup correctly on initial delivery",
      },
      {
        text: "Misdiagnosed – last part recommendation was incorrect",
        value: "Misdiagnosed – last part recommendation was incorrect",
      },
      {
        text: "Manufacturer Error – vendor sent wrong parts or suggested wrong parts",
        value:
          "Manufacturer Error – vendor sent wrong parts or suggested wrong parts",
      },
      {
        text: "Equipment Fit – ATP recommendations were not correct initially",
        value: "Equipment Fit – ATP recommendations were not correct initially",
      },
      {
        text: "Equipment Abuse – patient is using equipment incorrectly or abusing equipment",
        value:
          "Equipment Abuse – patient is using equipment incorrectly or abusing equipment",
      },
      {
        text: "Quality Issue – equipment is a lemon or has repeat issues on same parts",
        value:
          "Quality Issue – equipment is a lemon or has repeat issues on same parts",
      },
    ];

    const data = {
      columns: [
        {
          title: " ",
          name: "blank",
        },
        {
          title: "Order",
          name: "orderIdLink",
        },
        {
          title: "Status",
          name: "statusChip",
        },
        {
          title: "Equipment",
          name: "category",
        },
        {
          title: "Last Note",
          name: "lastNoteDate",
        },
        {
          title: "Points",
          name: "points",
        },
        // {
        //     title: "Serial",
        //     name: "serialNumber",
        // },
        // {
        //     title: "Setup Date",
        //     name: "setupDate",
        // },
        {
          title: " ",
          name: "feedback",
        },
      ],
      rows: [],
      defaultColumnWidths: [
        { columnName: "blank", width: 60 },
        { columnName: "orderIdLink", width: 70 },
        { columnName: "category", width: 150 },
        { columnName: "status", width: 150 },
        { columnName: "points", width: 60 },
        // { columnName: "serialNumber", width: 140 },
        // { columnName: "setupDate", width: 100 },
        { columnName: "lastNoteDate", width: 100 },
        { columnName: "feedback", width: 50 },
      ],
    };
    const sideCardData = {
      columns: [
        {
          title: "Order",
          name: "orderId",
        },
        {
          title: "Date",
          name: "date",
        },
        {
          title: "Status",
          name: "status",
        },
      ],
      rows: [],
      defaultColumnWidths: [
        { columnName: "orderId", width: 80 },
        { columnName: "date", width: 110 },
        { columnName: "status", width: 125 },
      ],
    };

    const phoneData = {
      columns: [
        {
          title: "Patient ID",
          name: "patientId",
        },
        {
          title: "ID",
          name: "id",
        },
        {
          title: "Contact Name",
          name: "contactName",
        },
        {
          title: "Phone Number",
          name: "phoneNumber",
        },
        {
          title: "Phone Type",
          name: "phoneType",
        },
        {
          title: "Delete",
          name: "delete",
        },
      ],
      defaultHiddenColumnNames: ["patientId"],
      rows: [],
    };
    //get all results to save
    let results = props.location.results;

    let id = props.match.params.id;

    this.state = {
      allServiceParts: null,
      firstLoad: true,
      id: id,
      notes: [],
      orderNotes: [],
      orderNotesLoading: false,
      orderNotesLoaded: false,
      orderApprovalsLoading: false,
      orderApprovalsLoaded: false,
      orderAttachments: [],
      orderAttachmentsLoading: false,
      orderAttachmentsLoaded: false,
      tasks: [],
      accountOwner: {},
      accountRecentSalesRep: null,
      patient: {},
      ePatient: {},
      isLoaded: false,
      patientOrders: [],
      selectedPreviousOrder: {},
      serviceOrderReasons: tOptions,
      openDialogCreateNewOrder: false,
      editLocationInformationModal: false,
      editGeneralInformationModal: false,
      patientIssueDialogOpen: false,
      createPatientNoteModal: false,
      gridData: data,
      sideCardGridData: sideCardData,
      groupColumns: groupColumns,
      patientProducts: [],
      patientProductsLoaded: false,
      patientProductsLoading: false,
      productsAddedList: [],
      allOrdersNotSorted: [],
      nOrder: {
        type: "Order",
        quality: false,
        hasInfectiousDisease: false,
        contacts: [],
        priority: 0,
        startedAt: new Date(),
        lastStatusChange: new Date(),
        account: {},
        approvals: [{}],
        insuranceType: null,
        secondaryInsuranceType: null,
        products: [],
        orderType: "New",
        status: 0,
      },
      nComplaint: {
        issueCategory: {},
        issueReason: {},
      },
      complaints: [],
      orderActivityFull: {},
      complaintNotes: {},
      currentComplaint: {},
      complaintNoteModal: false,
      complaintNoteText: "",
      closeComplaintModal: false,
      cancelTicketModal: false,
      addAdditionalPartsModal: false,
      selectedOrderTypeRadio: 1,
      serviceLocation: null,
      salesLocation: null,
      patientSalesLocation: null,
      orderTypes: [
        { id: 0, name: "New" },
        { id: 1, name: "Pickup" },
        { id: 2, name: "Service" },
        { id: 3, name: "Exchange" },
        { id: 4, name: "Internal Request" },
        { id: 5, name: "Re-Supply" },
      ],
      statuses: [
        "New",
        "In Progress",
        "Ready to Deliver",
        "Setup",
        "Cancelled",
      ],

      orderStatuses: [
        { label: "New", value: 0 },
        { label: "In Process", value: 1 },
        { label: "Ready To Deliver", value: 2 },
        { label: "Set Up", value: 3 },
        { label: "Cancelled", value: 4 },
      ],

      noteText: "",
      results: results,
      geoClient: geoCodeClient,
      searchResults: [],
      currOpenNote: {},
      ptnNoteModal: false,

      preferredContactMethods: [
        { value: "SMS", label: "SMS" },
        { value: "Call", label: "Call" },
        { value: "Email", label: "Email" },
      ],
      phoneTypes: [
        { value: "Cell", label: "Cell" },
        { value: "Home", label: "Home" },
        { value: "EmergencyContact", label: "Emergency Contact" },
        { value: "Other", label: "Other" },
      ],
      newPhoneNumber: {
        patientId: null,
        contactName: null,
        phoneType: null,
        phoneNumber: null,
      },
      patientPhoneNumbers: [], // list of new or modified
      deletedNumbers: [],
      addPhoneModalOpen: false,
      phoneData: phoneData,
      contactTermList: [],

      allUsers: [],
      allLocations: [],
      allSalesReps: [],
      insuranceTypes: [],
      insuranceSubTypes: [],
      complaintCategories: [],
      complaintReasons: [],
      isPediatric: false,

      patientEditTemplate: {
        id: id,
        type: "patient",
        item: {},
      },
      disableCreate: false,
      popUpComplaints: false,
      isCompliment: false,
      options: [],
      filteredOpts: [],
      complimentedUser: null,
      csUsers: [],
      filteredCSUsers: [],
      filteredComplianceUsers: [],
      searchQ: "",
      searchText: "",
      collapseID: "collapse0",
      createServiceTicketModalOpen: false,
      isOrderDetails: false,
      ticketDetailsModalOpen: false,
      radio: {
        pickupTicketAction: { value: "", label: "" },
        serviceTicketAction: "",
        choosePartsAction: "",
        needsDiagnosisAction: "",
        obtainDocAction: "",
        nonBillableAction: "",
        docFollowupAction: "",
        approvalAction: "",
        needsBilledAction: "",
        preAuthFollowUpAction: "",
        preAuthSubmission: "",
        followUpTask: "",
        billingAction: "",
        salesPPWIssue: "",
        setup: "",
        dispatchTechSubType: "",
        newAccessoryAfterSaleSubType: "",
        preAuthAction: "",
        readyToDeliverAction: "",
        rtdEquipmentOrderedAction: "",
        readyToSchedule: "",
        rtdScheduled: "",
        equipmentWriteOff: "",
        rtdNotAbleToDeliverAction: "",
        verification: "",
      },
      createTicketNote: null,
      approvalActive: true,
      notesActive: false,
      attachemntsActive: false,
      canEditBasicInfo: false,
      canEditInsuranceInfo: false,
      canEditClinicalInfo: false,
      curOrderId: null,
      patientAge: null,
      expandedRowID: 2,
      items: {
        rightMenu: "1",
        ticketDetails: "1",
        contentCard: "1",
      },
      patientEquipmentTickets: [],
      createTicketOrderId: null,
      insuranceInfoValidated: false,
      basicInfoValidated: false,
      radioBtnSelected: false,
      highlightedRow: { id: "" },
      expandedRowIds: [],
      insuranceVerification: {
        loading: true,
        insuranceVerified: null,
        verificationInfo: null,
        start: "",
        end: "",
        inDateRange: false,
      },
      quoteItems: {},
      shipToPatient: false,
      patientEquipmentLoaded: false,
      noteModalOpen: false,
      saveProcessStarted: false,

      shouldDisable: false,
      shouldOpenOrderId: shouldOpenOrderId,
      statusOrReasonChange: false,

      lastChartNotes: null,
      chartNotesOpen: false,
      serviceOrderProducts: [],
      orderRetrieved: false,
      servicePartsLoading: false,
      servicePartsLoaded: false,
      orderDetailProducts: [],
      idNames: [],

      attachmentsTabOpen: false,
      feedbackCollapseID: "",
      sortedFeedback: [],
      openOnFeedback:
        props.location.state && props.location.state.openOnFeedback
          ? props.location.state.openOnFeedback
          : false,
      addPartCreateQuoteModal: false,

      hasScrolledToTop: false,

      approvalModalOpen: false,
      approveAgreement: false,
      approveWithoutAuth: false,
      approveAuthNotRequired: false,

      orderProducts: [],
      authNumber: null,

      followupModalOpen: false,
      followUpDays: 5,

      deliveryNoteModalOpen: false,
      deliveryNoteText: null,

      searchOrderStatusReasonDialogOpen: false,

      verificationModalOpen: false,
      verificationResults: [],

      patientInfoRetrieved: false,

      serviceReason: null,
      curServiceOrderReason: {},
      showSubtypeRadioOptions: false,

      thirtyDayFit: false,
      serviceReasonLoaded: false,

      createQuoteSmall: false,

      ticketRecordsLoaded: false,
      ticketRecords: [],
      reopenCancelledTicketModal: false,

      paymentInformationModal: false,
      abnModal: false,

      timelineModalOpen: false,
      parentFlat: {},
      typeOfTicketToCreate: "",
      productsForOrderId: null,

      setDialogOpen: false,

      curOrderIsApproved: false,
      baseUnitLoaded: false,

      submitToPverifyLoading: false,
      initialRoutingInformation: null,
      selectedSubTypeFromQueueRoute: null,
      createNewOrderStatus: {
        id: 0,
        name: "New",
      },
      createNewOrderReason: null,
      patientIssue: {
        issueCategory: null,
        issueReason: null,
        complimentedUserId: null,
        orderId: null,
        complaintDescription: null,
      },
      showAlertPatientIssues: [],
      preventServicePatientIssues: [],

      providers: [],
      currentOrderingProviderSearchId: 0,
      currentDiagnosisCodeSearchId: 0,
      diagnosisCodes: [],
      diagnosisCodeInputs: ["first", "second", "third", "fourth"],
      createPickupFromRoute: null,
      patientChart: null,
      clinicalInformationLoading: false,
      validationIssues: {},
      isSpecialNoteForBilling: false,
    };
    this.unloadedState = JSON.parse(JSON.stringify(this.state));

    this.state.TabsOneActiveItem = "1";

    this.retrievePatient(id);
    this.retrievePatientInsurance(id);
    this.getPatientNotes(id);
    this.retrieveVerificationResults(id);

    this.throttledHandleOrderingProviderSearch = Throttle.throttle(
      this.handleSearchOrderingProviderChange.bind(this),
      100,
      { trailing: true },
    );
    this.throttledHandleDiagnosisCodeSearch = Throttle.throttle(
      this.handleSearchDiagnosisCodeChange.bind(this),
      100,
      { trailing: true },
    );
    this.loadPatientChart(id);
  }
  componentWillReceiveProps(nextProps) {
    let id = nextProps.match.params.id;

    if (id !== this.state.id) {
      this.unloadedState.id = id;
      this.unloadedState.shouldOpenOrderId =
        nextProps.location.state.shouldOpenOrderId;
      this.shouldOpenOrderId = nextProps.location.state.shouldOpenOrderId;

      this.setState(this.unloadedState);
      this.retrievePatient(id);
      this.retrievePatientInsurance(id);
      this.getPatientNotes(id);
      this.retrieveVerificationResults(id);
      this.componentDidMount();
      this.loadPatientChart(id);
    } else if (
      nextProps.location.state &&
      nextProps.location.state.shouldOpenOrderId
    ) {
      this.highlightOrderRow(nextProps.location.state.shouldOpenOrderId);
    }
  }

  static contextType = MainContext; // For legacy class components

  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.getLocations();
    this.getReps();
    this.getInsuranceTypes();
    this.getInsuranceSubTypes();
    this.getComplaintCategories();
    this.getComplaintReasons();
    // this.getPatientProducts();
    this.getAllUsers();
    this.getContactTerms();
  }

  calcMinWidth(screenWidth, colMin, percent, constantVals) {
    //table gets 53% of VW controlled in patientView.css .leftCol .middleCol and .rightCol
    //Subtracting 48 to account for the dropdown caret Col
    let total = 48;
    constantVals.forEach((val) => {
      total += val.width;
    });
    let width = screenWidth * 0.53 - total;
    let colWidth = width * (percent / 100);

    return colWidth;
  }

  getWidths() {
    let width = this.state.width || window.innerWidth;

    let constantVals = [
      { columnName: "blank", width: 90 }, //90 from 60
      { columnName: "orderIdLink", width: 75 },
      { columnName: "feedback", width: 50 },
      { columnName: "points", width: 60 },
    ];
    let calculateVals = [
      {
        columnName: "statusChip",
        width: this.calcMinWidth(width, 150, 34, constantVals),
      }, //35
      {
        columnName: "category",
        width: this.calcMinWidth(width, 150, 50, constantVals),
      }, //35
      // { columnName: "serialNumber", width:  this.calcMinWidth(width,70, 15,constantVals) },
      {
        columnName: "lastNoteDate",
        width: this.calcMinWidth(width, 70, 16, constantVals),
      },
    ];
    let vals = constantVals.concat(calculateVals);
    return vals;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { allUsers } = this.context;

    if (allUsers.length !== this.state.allUsers.length) {
      this.getAllUsers();
    }
    if (
      prevState.showAlertPatientIssues.length !==
        this.state.showAlertPatientIssues.length ||
      prevState.preventServicePatientIssues.length !==
        this.state.preventServicePatientIssues.length
    ) {
      this.getPatientIssueSummaryText();
    }
    if (prevState.eOrder !== this.state.eOrder) {
      this.loadPatientChart(this.state.ePatient.id);
    }
  }

  loadPatientChart(id) {
    this.setState({ clinicalInformationLoading: true });
    OrderService.getPatientChartById(id)
      .then((res) => {
        this.setState(
          {
            patientChart: res,
          },
          () => {
            this.setClinicalInformation();
            this.getPatientLastMedicareRx();
          },
        );
      })
      .catch((err) => {
        console.error("Error loading patient chart:", err);
      });
  }

  getLocations() {
    const { allLocations } = this.context;
    this.setState({
      allLocations: allLocations,
    });
  }

  getContactTerms() {
    const { termsIndexed } = this.context;
    let contactTerms = [];
    Object.values(termsIndexed).forEach((term) => {
      if (term.type === "marketing_preferred_contact_method") {
        contactTerms.push(term);
      }
    });

    this.setState({
      contactTermList: contactTerms,
    });
  }

  getContactTermList() {
    let terms = this.state.contactTermList;

    let a = terms.map((v) => ({
      label: v.name,
      value: v.id,
    }));

    a.sort((x, y) => x.label.localeCompare(y.label));

    return a;
  }

  getReps() {
    const { salesReps } = this.context;
    this.setState({
      allSalesReps: salesReps,
    });
  }

  getStateList() {
    const { stateSalesTax } = this.context;
    let lst = [];
    stateSalesTax.forEach((x) => {
      lst.push({
        label: x.name + " - " + x.abbr,
        value: x.abbr,
      });
    });
    return lst;
  }

  getInsuranceTypes() {
    const { insuranceTypes } = this.context;
    this.setState({
      insuranceTypes: insuranceTypes,
    });
  }

  getInsuranceSubTypes() {
    const { insuranceSubTypes } = this.context;
    this.setState({
      insuranceSubTypes: insuranceSubTypes,
    });
  }

  getComplaintCategories() {
    const { complaintCategories } = this.context;
    this.setState({
      complaintCategories: complaintCategories,
    });
  }

  getComplaintReasons() {
    const { complaintReasons } = this.context;
    this.setState({
      complaintReasons: complaintReasons,
    });
  }

  getPatientLastChartNotes(patientId) {
    OrderService.getPatientLastChartNotes(patientId)
      .then((res) => {
        if (!res.id) {
          return;
        }
        this.setState({
          lastChartNotes: res,
        });
      })
      .catch((ex) => {
        console.log(ex);
      });
  }

  setClinicalInformation() {
    const newState = {};

    const patientOrderingProviderId =
      this.state.patient?.orderingProviderId || null;
    const providers = this.state.patientChart?.data?.provider || {};
    const providerData = patientOrderingProviderId
      ? providers[patientOrderingProviderId]
      : null;

    if (providerData) {
      newState.selectedPatientProvider = {
        ...providerData,
        title: (() => {
          const name = [providerData.firstName, providerData.lastName]
            .filter(Boolean)
            .join(" ");
          const credential = providerData.credential?.trim();
          const nameWithCredential = credential
            ? `${name}, ${credential}`
            : name;

          const location = [providerData.city, providerData.state]
            .filter(Boolean)
            .join(", ");

          const parts = [
            nameWithCredential,
            location || null,
            providerData.npi || null,
          ].filter(Boolean);

          return parts.join(" - ");
        })(),
        value: patientOrderingProviderId,
      };
    } else {
      newState.selectedPatientProvider = null;
    }

    // Diagnosis code inputs (looping through)
    this.state.diagnosisCodeInputs.forEach((inputName) => {
      const diagnosisCodeId =
        this.state.ePatient[`${inputName}DiagnosisCodeId`];
      const diagnosisCodeData = diagnosisCodeId
        ? this.state.patientChart.data.diagnosisCode[diagnosisCodeId]
        : null;

      newState[`${inputName}PatientDiagnosisCodeSelected`] = diagnosisCodeData
        ? {
            title: `${DiagnosisCode.getDisplayName(diagnosisCodeData)} - ${diagnosisCodeData.descriptionShort}`,
            code: `${DiagnosisCode.getDisplayName(diagnosisCodeData)}`,
            descriptionShort: diagnosisCodeData.descriptionShort,
            value: diagnosisCodeData.id,
          }
        : null;
    });

    // Handle selectedTicketProvider (if ticket is open)
    const openTicket = this.state.curOrder ? this.state.eOrder : null;

    const orderActivityOrderingProviderId =
      openTicket?.orderingProviderId || null;
    const orderActivityProviderData = orderActivityOrderingProviderId
      ? providers[orderActivityOrderingProviderId]
      : null;

    if (openTicket) {
      this.state.diagnosisCodeInputs.forEach((inputName) => {
        const diagnosisCodeId = openTicket[`${inputName}DiagnosisCodeId`];

        const diagnosisCodeData = diagnosisCodeId
          ? this.state.patientChart.data.diagnosisCode[diagnosisCodeId]
          : null;

        newState[`${inputName}OrderActivityDiagnosisCodeSelected`] =
          diagnosisCodeData
            ? {
                title: `${DiagnosisCode.getDisplayName(diagnosisCodeData)} - ${diagnosisCodeData.descriptionShort}`,
                code: `${DiagnosisCode.getDisplayName(diagnosisCodeData)}`,
                descriptionShort: diagnosisCodeData.descriptionShort,
                value: diagnosisCodeData.id,
              }
            : null;
      });

      if (orderActivityProviderData) {
        newState.selectedTicketProvider = {
          ...orderActivityProviderData,
          title: (() => {
            const name = [
              orderActivityProviderData.firstName,
              orderActivityProviderData.lastName,
            ]
              .filter(Boolean)
              .join(" ");
            const credential = orderActivityProviderData.credential?.trim();
            const nameWithCredential = credential
              ? `${name}, ${credential}`
              : name;

            const location = [
              orderActivityProviderData.city,
              orderActivityProviderData.state,
            ]
              .filter(Boolean)
              .join(", ");

            const parts = [
              nameWithCredential,
              location || null,
              orderActivityProviderData.npi || null,
            ].filter(Boolean);

            return parts.join(" - ");
          })(),
          value: orderActivityOrderingProviderId,
        };
      } else {
        newState.selectedTicketProvider = null;
      }
    }

    newState.clinicalInformationLoading = false;

    this.setState(newState);
  }

  async getPatientLastMedicareRx() {
    const data = this.state.patientChart?.data;
    if (!data) return;

    // Filter uploaded files to only include files that have an activity file and are not deleted
    const uploadedFiles = Object.values(data.uploadedFile).filter((upload) =>
      Object.values(data.activityFile).some(
        (activityFile) =>
          activityFile.fileId === upload.id && activityFile.deleted !== true,
      ),
    );

    /**
     * There are lots of files named "-signed-rx" already in Sales Pilot, so
     * any uploaded file with this naming scheme needs to be after this date
     * to be considered as this is when we deployed the change.
     */
    const uploadedRxFiles = uploadedFiles.filter(
      (upload) =>
        upload.filename.includes("-signed_rx.") &&
        moment(upload.uploadedAt).isSameOrAfter("2025-08-08", "day"),
    );

    const rxWithOrders = await Promise.all(
      uploadedRxFiles.map(async (rxFile) => {
        const matchingActivityFile = Object.values(
          data.activityFile || {},
        ).find((activityFile) => activityFile.fileId === rxFile.id);

        const orderId = matchingActivityFile?.activityId;
        const orderActivity = orderId ? data.orderActivity[orderId] : null;
        const hasMedicareOrMedicareReplacement =
          orderActivity?.insuranceTypeId === 1 ||
          orderActivity?.insuranceTypeId === 8;

        let newAccessoryAfterSale = false;
        if (orderId) {
          try {
            const serviceOrderReasonData =
              await ServiceOrderReasonService.getServiceOrderReasonByServiceId(
                orderId,
              );
            if (
              serviceOrderReasonData?.serviceReason ===
              "New Accessory After The Sale"
            ) {
              newAccessoryAfterSale = true;
            }
          } catch (err) {
            // console.error(`Error getting service order reason for order ${orderId}:`, err);
          }
        }

        return {
          rxFile: rxFile,
          orderId: orderId,
          uploadedAt: rxFile.uploadedAt,
          hasMedicareOrMedicareReplacement: hasMedicareOrMedicareReplacement,
          newAccessoryAfterSale: newAccessoryAfterSale,
        };
      }),
    );

    // Filter rxs with Medicare insurance and do not have a service order reason of "New Accessory After Sale"
    const medicareRxs = rxWithOrders.filter(
      (rx) =>
        rx.hasMedicareOrMedicareReplacement &&
        rx.newAccessoryAfterSale === false,
    );

    let mostRecentMedicareRx = null;
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);

    for (const rx of medicareRxs) {
      const rxDate = new Date(rx.uploadedAt);

      if (rxDate < twelveMonthsAgo) {
        continue;
      }

      if (
        !mostRecentMedicareRx ||
        rxDate > new Date(mostRecentMedicareRx.uploadedAt)
      ) {
        mostRecentMedicareRx = rx;
      }
    }

    this.setState({
      mostRecentMedicareRx: mostRecentMedicareRx?.rxFile || null,
    });
  }

  toggle = (tabset, tab) => {
    if (this.state.TabsOneActiveItem !== tab) {
      this.setState({
        TabsOneActiveItem: tab,
      });
    }
    if (
      this.state.canEditBasicInfo &&
      (this.state.TabsOneActiveItem !== "2" ||
        this.state.TabsOneActiveItem !== "3")
    ) {
      this.setState({
        canEditBasicInfo: false,
      });
    }
  };

  toggleOrderModal() {
    let p = this.state.patient;

    if (!p.address || !p.city || !p.state || !p.zipCode) {
      toast.error(
        "Patient must have address information set before adding an Order",
      );
      NotistackEnqueueSnackbar(
        "Patient must have address information set before adding an Order",
        { variant: "error" },
      );
    } else if (!p.insuranceType) {
      toast.error(
        "Patient must have a Payor Source set before adding an Order",
      );
      NotistackEnqueueSnackbar(
        "Patient must have a Payor Source set before adding an Order",
        { variant: "error" },
      );
    } else {
      let currentState = this.state.openDialogCreateNewOrder;
      this.setState({ openDialogCreateNewOrder: !currentState });
    }
  }

  toggleCreateTicketModal(order, orderId, ticketType) {
    let curState = this.state.createServiceTicketModalOpen;
    if (!curState) {
      toast.warn(this.legacyTicketCreationTooltip);
      return;
    }
    this.setState({
      createPickupFromRoute: null,
      parentFlat: {},
      typeOfTicketToCreate: ticketType ? ticketType : "",
      createTicketNote: null,
      createServiceTicketModalOpen: !curState,
      radio: {
        serviceTicketAction: "",
        pickupTicketAction: { label: "", value: "" },
      },
      canEditBasicInfo: false,
      canEditInsuranceInfo: false,
      canEditClinicalInfo: false,
      createTicketOrderId: this.state.curOrderId ? null : orderId,
      basicInfoValidated: false,
      insuranceInfoValidated: false,
      radioBtnSelected: false,
      curOrderId: this.state.curOrderId ? null : orderId,
      curOrder: order,
      thirtyDayFit: false,
    });
    if (orderId) {
      this.getParentFlatDemographics(orderId);
    }
  }

  getParentFlatDemographics(orderId) {
    OrderService.getFlatOrderActivity(orderId)
      .then((res) => {
        this.setState({ parentOrderServiceLocationId: res.serviceLocationId });
        this.changeLocation(res.salesLocation, "salesLocation");
        this.changeLocation(res.serviceLocation, "serviceLocation");
      })
      .catch((err) => {});
  }

  toggleAddServicePartsModal() {
    this.setState({
      addPartCreateQuoteModal: !this.state.addPartCreateQuoteModal,
    });
  }

  toggleTicketDetailsModal(curOrder, id) {
    let curState = this.state.ticketDetailsModalOpen;
    let items = this.state.items;
    if (this.state.openOnFeedback === false) {
      items.rightMenu = "1";
    }
    if (this.state.openOnFeedback === true) {
      items.rightMenu = "3";
    }

    this.setState();
    if (curState === false) {
      this.setState({
        highlightedRow: { id: null },
        TabsOneActiveItem: "4",
        curOrder: {},
        curOrderId: null,
        isOrderDetails: curOrder.orderType === "New",
        statusOrReasonChange: false,
        serviceOrderProducts: [],
        orderRetrieved: false,
        servicePartsLoading: false,
        servicePartsLoaded: false,
        orderDetailProducts: [],
        canSelectChoosePartsAction: false,
        canSelectNonBillableAction: false,
        canSelectNeedsDiagnosisAction: false,
        canSelectObtainDocAction: false,
        canSelectDocFollowupAction: false,
        canSelectApprovalAction: false,
        canSelectNeedsBilledAction: false,
        canSelectPreAuthFollowUpAction: false,
        canSelectPreAuthSubmission: false,
        canSelectFollowUpTask: false,
        canSelectSalesPPWIssueAction: false,
        canSelectSetupAction: false,
        canSelectBillingAction: false,
        canSelectReadyToDeliverAction: false,
        canSelectTechNotRequired: false,
        canSelectEquipmentOrderedAction: false,
        canSelectReadyToScheduleAction: false,
        canSelectScheduledAction: false,
        canSelectWriteOffAction: false,
        canSelectNotAbleToDeliverAction: false,
        canSelectVerificationAction: false,
        feedbackCollapseID: "",
        openOnFeedback: false,
        loadingParentProducts: null,
        loadingServiceOrderReason: null,
        loadingOrderTimeline: null,
        radio: {
          pickupTicketAction: { label: "", value: "" },
          serviceTicketAction: "",
          choosePartsAction: "",
          needsDiagnosisAction: "",
          obtainDocAction: "",
          docFollowupAction: "",
          approvalAction: "",
          needsBilledAction: "",
          preAuthFollowUpAction: "",
          preAuthSubmission: "",
          followUpTask: "",
          billingAction: "",
          salesPPWIssue: "",
          setup: "",
          dispatchTechSubType: "",
          newAccessoryAfterSaleSubType: "",
          readyToDeliverAction: "",
          rtdEquipmentOrderedAction: "",
          readyToSchedule: "",
          rtdScheduled: "",
          equipmentWriteOff: "",
          rtdNotAbleToDeliverAction: "",
          verification: "",
        },
        eOrder: null,
        curServiceOrderReason: {},
        currentBaseUnit: null,
        currentVendor: null,
        baseUnitSerial: null,
        baseUnitHCPCS: null,
        serviceReason: null,

        curOrderIsApproved: false,
        baseUnitLoaded: false,
        productsAddedList: [],
        productsForOrder: [],
        nOrder: {
          type: "Order",
          quality: false,
          hasInfectiousDisease: false,
          contacts: [],
          priority: 0,
          startedAt: new Date(),
          lastStatusChange: new Date(),
          account: {},
          approvals: [{}],
          insuranceType: null,
          secondaryInsuranceType: null,
          products: [],
          orderType: "New",
          status: 0,
        },
      });
      setTimeout(() => {
        let elem = document.getElementById("orderDetailsContainer");
        if (elem) {
          elem.scrollIntoView();
        } else {
          setTimeout(() => {
            let elem2 = document.getElementById("orderDetailsContainer");
            if (elem2) {
              elem2.scrollIntoView();
            }
          }, 1);
        }
      }, 1);
    } else {
      this.setState({
        TabsOneActiveItem: "1",
      });
    }

    items.ticketDetails = "1";

    this.setState((prev) => ({
      // PATCH: Instead of reading this.state.curOrderId immediately after setting it above to null, computer the new value from previous state
      ticketDetailsModalOpen: !curState,
      orderNotesLoading: false,
      orderNotesLoaded: false,
      orderNotes: [],
      orderApprovalsLoading: false,
      orderApprovalsLoaded: false,
      orderAttachmentsLoading: false,
      orderAttachmentsLoaded: false,
      orderAttachments: [],
      curOrderId: prev.curOrderId ? null : id, // PATCH
      curOrder: curOrder,
      notesActive: true,
      attachmentsActive: false,
      items: items,
      serviceReasonLoaded: false,
      ticketRecordsLoaded: false,
    }));

    if (id) {
      window.history.replaceState(
        null,
        null,
        "/patientInformation/" + this.state.id + "/" + id,
      );
    } else {
      window.history.replaceState(
        null,
        null,
        "/patientInformation/" + this.state.id,
      );
    }
  }

  getPatientShowAlertAndPreventServiceIssues() {
    const hasCollectionsBalance =
      this.state.patient.collectionsBalance > 0
        ? this.state.patient.collectionsBalance
        : false;

    const patientIssue = this.state.patient.patientIssue || [];

    const showAlertPatientIssues = patientIssue
      .filter((issue) => {
        const issueReason =
          this.context.issueReasonsIndexed[issue.issueReasonId];
        return issue.issueStatus === 0 && issueReason && issueReason.showAlert;
      })
      .sort((a, b) => new Date(a.issueLoggedOn) - new Date(b.issueLoggedOn)); // Sort by issueLoggedOn from oldest to newest

    const preventServicePatientIssues = patientIssue.filter((issue) => {
      const issueReason = this.context.issueReasonsIndexed[issue.issueReasonId];
      return (
        issue.issueStatus === 0 && issueReason && issueReason.preventService
      );
    });

    if (hasCollectionsBalance) {
      showAlertPatientIssues.push({
        collectionsBalance: this.state.patient.collectionsBalance,
        description: "Collections Balance",
      });
      preventServicePatientIssues.push({
        collectionsBalance: this.state.patient.collectionsBalance,
        description: "Collections Balance",
      });
    }

    this.setState({
      showAlertPatientIssues: showAlertPatientIssues,
      preventServicePatientIssues: preventServicePatientIssues,
    });
  }

  /**
   * The summary text for each category is generated using the helper function
   * `generateSummaryText`, which counts the occurrences of each issue category
   * and formats the output accordingly.
   */
  getPatientIssueSummaryText() {
    const generateSummaryText = (issues) => {
      const categoryCount = issues.reduce((categoryCountMap, patientIssue) => {
        let category = IssueCategory.getDisplayName(patientIssue.issueCategory);
        if (!category && patientIssue.collectionsBalance) {
          category = patientIssue.description;
          categoryCountMap[category] = patientIssue.collectionsBalance;
        } else {
          categoryCountMap[category] = (categoryCountMap[category] || 0) + 1;
        }
        return categoryCountMap;
      }, {});

      const issueSummary = Object.entries(categoryCount)
        .map(([category, count]) => {
          if (category === "Collections Balance") {
            let USDollar = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            });

            return `${category} ${USDollar.format(count)}`;
          }
          return count > 1 ? `${category} (${count})` : category;
        })
        .join(" • ");

      return issueSummary;
    };

    const showAlertPatientIssueSummaryText = generateSummaryText(
      this.state.showAlertPatientIssues,
    );
    const preventServicePatientIssueSummaryText = generateSummaryText(
      this.state.preventServicePatientIssues,
    );

    this.setState({
      showAlertPatientIssueSummaryText,
      preventServicePatientIssueSummaryText,
    });
  }

  renderPatientIssueSummaryAlert() {
    if (
      !this.state.showAlertPatientIssues ||
      this.state.showAlertPatientIssues.length === 0
    ) {
      return null;
    }

    return (
      <MUIAlert
        severity="error"
        variant="filled"
        sx={{ cursor: "pointer" }}
        onClick={() =>
          this.setState({ showAlertFeedbackIssueDialogOpen: true })
        }
      >
        {this.state.showAlertPatientIssueSummaryText}
      </MUIAlert>
    );
  }

  renderDialogPatientIssueAlert() {
    return (
      <DialogPatientIssueAlert
        open={this.state.showAlertFeedbackIssueDialogOpen}
        onClose={() =>
          this.setState({ showAlertFeedbackIssueDialogOpen: false })
        }
        onClick={(patientIssue) => {
          this.setState(
            {
              showAlertFeedbackIssueDialogOpen: false,
              openOnFeedback: true,
              shouldOpenOrderId: patientIssue.orderId,
            },
            () => {
              this.openOrder();
            },
          );
        }}
        patientIssues={this.state.showAlertPatientIssues}
      />
    );
  }

  addressTextChanged(e) {
    let val = e.target.value;
    const nPatient = this.state.ePatient,
      tplt = this.state.patientEditTemplate;
    nPatient["address"] = val;
    tplt.item["address"] = val;
    this.setState({ ePatient: nPatient, patientEditTemplate: tplt });
    let geocoderResultNode = document.getElementById("geocoderResult");
    if (val) {
      this.geoGoogle(val);
    } else {
      this.setState({ searchResults: [] });
      if (geocoderResultNode) {
        geocoderResultNode.innerHTML = "";
      }
    }
  }

  addPatientComplaint() {
    this.setState({ createPatientFeedbackLoading: true });
    let patientIssue = this.state.patientIssue;

    patientIssue.patientId = this.state.patient.id;
    patientIssue.issueLoggedBy = {
      firstname: this.context.currentUser.firstname,
      lastname: this.context.currentUser.lastname,
      id: this.context.currentUser.id,
    };
    patientIssue.issueLoggedById = this.context.currentUser.id;
    patientIssue.issueLoggedOn = new Date().toISOString();
    patientIssue.issueStatus = 0;
    patientIssue.issueCategoryId = patientIssue.issueCategory.id;
    patientIssue.issueReasonId = patientIssue.issueReason.id;

    if (this.state.curOrderId) {
      patientIssue.orderId = this.state.curOrderId;
    }

    return ComplaintService.createPatientIssue(patientIssue)
      .then((res) => {
        NotistackEnqueueSnackbar("Patient feedback added successfully!", {
          variant: "success",
        });

        let allPatientIssues = this.state.complaints;
        allPatientIssues.push(res);

        this.setState({
          patientIssueDialogOpen: false,
          complaints: allPatientIssues,
          patientIssue: {
            issueCategory: null,
            issueReason: null,
            complimentedUserId: null,
            orderId: null,
            complaintDescription: null,
          },
          createPatientFeedbackLoading: false,
        });
        this.getPatientShowAlertAndPreventServiceIssues();
        this.retrievePatientEquipment(this.state.id);
      })
      .catch((e) => {
        console.log(e);
        this.setState({ createPatientFeedbackLoading: false });
        NotistackEnqueueSnackbar(
          "Oh no! There was an error adding patient feedback.",
          { variant: "error" },
        );
      });
  }

  calculateAutofocus = (a) => {
    if (this.state["formActivePanel" + a + "Changed"]) {
      return true;
    }
  };

  sortIssues(issues) {
    let sorted = issues.sort((a, b) => {
      let da = new Date(a.issueLoggedOn).getTime(),
        db = new Date(b.issueLoggedOn).getTime();

      return da > db ? -1 : 1;
    });
    return sorted;
  }

  retrievePatient(id) {
    return OrderService.getPatientById(id).then((data) => {
      data.patientIssue = this.sortIssues(data.patientIssue);

      let nOrder = this.state.nOrder;
      nOrder.account = data.account;
      let st = this.state,
        // orders = [],
        complaintNotes = st.complaintNotes;

      // data.orderActivity.forEach(d => {
      //     let l = d.id
      //         .toString()
      //         .concat(d.orderType ? " - " + d.orderType : " - Blank Type")
      //         .concat(d.status ? " - " + d.status : " - Blank Status");
      //     orders.push({ label: l, value: d.id });
      // });

      // this.createOrderList(data.orderActivity);

      data.patientIssue.forEach((p) => {
        complaintNotes["notes" + p.id] = p.issueNotes;
      });

      this.setState(
        {
          patientAge: moment(
            data.deceased && data.dateOfDeath ? data.dateOfDeath : undefined,
          ).diff(data.dateOfBirth, "years", false),
          patient: data,
          accountOwner: data.account.owner,
          ePatient: JSON.parse(JSON.stringify(data)),
          isLoaded: true,
          // patientOrders: orders,
          complaints: data.patientIssue,
          complaintNotes: complaintNotes,
          TabsOneActiveItem: "1",
          canEditBasicInfo: false,
          patientInfoRetrieved: true,
          previousMbi: data.mbi,
        },
        () => {
          this.getPatientShowAlertAndPreventServiceIssues();
        },
      );

      this.retrievePatientEquipment(id);
      this.getPatientLastChartNotes(id);
    });
  }

  retrieveTicketRecords(o) {
    if (this.state.ticketRecordsLoaded === true) {
      return;
    }
    if (!(
      this.state.loadingOrderTimeline &&
      this.state.loadingOrderTimeline === o.id
    )) {
      this.setState({ loadingOrderTimeline: o.id });
      return OrderService.getOrderTimeline(o)
        .then((records) => {
          let sorted = records.sort((a, b) => {
            if (a.id > b.id) {
              return -1;
            } else if (a.id < b.id) {
              return 1;
            } else {
              return 0;
            }
          });

          this.setState({
            ticketRecordsLoaded: true,
            ticketRecords: sorted,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  retrieveServiceOrderReasonByTicketId(id) {
    if (this.state.serviceReasonLoaded === true) {
      return;
    }
    if (!(
      this.state.loadingServiceOrderReason &&
      this.state.loadingServiceOrderReason === id
    )) {
      this.setState({ loadingServiceOrderReason: id });
      return ServiceOrderReasonService.getServiceOrderReasonByServiceId(id)
        .then((res) => {
          this.setState({
            serviceReasonLoaded: true,
            curServiceOrderReason: res,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  updateServiceOrderReasonRecord(prop, val) {
    let obj = this.state.curServiceOrderReason;
    obj[prop] = val;

    return ServiceOrderReasonService.updateServiceOrderReason(obj)
      .then((data) => {})

      .catch((err) => {
        console.log(err);
      });
  }

  retrievePatientInsurance(id) {
    id = parseInt(id);

    return insuranceService
      .findPatientVerification(id)
      .then((data) => {
        if (data.verificationInfo) {
          let parsed = JSON.parse(data.verificationInfo),
            start = "",
            end = "";
          if (parsed.PlanCoverageSummary) {
            if (parsed.PlanCoverageSummary.EffectiveDate) {
              start = parsed.PlanCoverageSummary.EffectiveDate;
            }
            if (parsed.PlanCoverageSummary.ExpiryDate) {
              end = parsed.PlanCoverageSummary.ExpiryDate;
            }
          }
          data.start = start;
          data.end = end;
          let inDateRange = false;
          if (!end) {
            inDateRange = true;
          } else {
            inDateRange =
              new Date(start).getTime() < new Date().getTime() &&
              new Date().getTime() < new Date(end).getTime();
          }
          data.inDateRange = inDateRange;
        }
        this.setState({
          insuranceVerification: data,
        });
      })
      .catch((err) => {
        this.setState({
          insuranceVerification: {},
        });
        console.log(err);
      });
  }

  sortParentsAndChildren(data) {
    let newParentOrders = [];
    let childOrders = [];
    function findParent(parentId) {
      return data.find((x) => x.id === parentId);
    }
    data.forEach((order) => {
      if (!order.parentOrder) {
        let orderWithChild = order;
        orderWithChild.children = [];
        newParentOrders.push(orderWithChild);
      } else if (
        order.parentOrder &&
        data.filter(
          (x) =>
            (x.id === order.parentOrder && x.orderType === "Service") ||
            (x.id === order.parentOrder && x.orderType === "Pickup") ||
            (x.id === order.parentOrder && x.orderType === "Billing Issue"),
        ).length > 0
      ) {
        var temp = data.find((x) => x.id === order.parentOrder);
        while (
          temp &&
          temp.parentOrder &&
          (temp.orderType === "Service" ||
            temp.orderType === "Pickup" ||
            temp.orderType === "Billing Issue")
        ) {
          let temp2 = findParent(temp.parentOrder);
          temp = temp2;
        }
        if (temp) {
          order["parentOrder"] = temp.orderId;
          order["currentModel"] = temp.currentModel;
          order["serialNumber"] = temp.serialNumber;
          childOrders.push(order);
        } else if (newParentOrders.length > 0) {
          order["parentOrder"] = newParentOrders[0].orderId;
          childOrders.push(order);
        } else {
          let orderWithChild = order;
          orderWithChild.children = [];
          newParentOrders.push(orderWithChild);
          // add to the new orders list?
        }
      } else {
        childOrders.push(order);
      }
    });

    childOrders.forEach((childOrder) => {
      newParentOrders.forEach((parOrder) => {
        if (parOrder.orderId === childOrder.parentOrder) {
          parOrder.children.push(childOrder);
        }
      });
    });

    return newParentOrders;
  }

  renderFeedbackChip(d, type) {
    const feedbackForId = this.state.complaints.filter(
      (fb) => fb.orderId === d.id,
    );
    const isTicket = type === "ticket";
    let feedbackIsClosed = true;
    let openFeedback = [];

    // Define the custom order for issue categories
    const categoryOrder = [
      "Compliance",
      "Collections",
      "Complaint",
      "Compliment",
    ];

    // Sort feedback based on the custom order
    if (feedbackForId.length > 1) {
      feedbackForId.sort((a, b) => {
        const indexA = categoryOrder.indexOf(a.issueCategory.name);
        const indexB = categoryOrder.indexOf(b.issueCategory.name);
        return indexA - indexB;
      });
    }

    // Identify open feedback
    openFeedback = feedbackForId.filter((f) => f.issueClosedOn === null);
    if (openFeedback.length > 0) {
      feedbackIsClosed = false;
    }

    if (feedbackForId.length > 0) {
      const categoryName = feedbackForId[0].issueCategory.name;
      const styles = {
        Compliance: {
          margin: ".2rem",
          backgroundColor: "#FFB8B8",
          border: "1px solid #FF7089",
          color: "#75570D",
        },
        Collections: {
          margin: ".2rem",
          backgroundColor: "#FFB8B8",
          border: "1px solid #FF7089",
          color: "#75570D",
        }, // Same as Compliance
        Complaint: {
          margin: ".2rem",
          backgroundColor: "#FFEBBC",
          border: "1px solid #FBC02D",
          color: "#881A2D",
        },
        Compliment: {
          margin: ".2rem",
          backgroundColor: "#C1F5BF",
          border: "1px solid #52B48F",
          color: "#195D17",
        },
      };

      // Use a default style if the category is not recognized
      const selectedStyle = styles[categoryName] || {
        margin: ".2rem",
        backgroundColor: "#D1D1D1", // Default gray color
        border: "1px solid #A1A1A1",
        color: "#000000",
      };

      // Add a slash effect if feedback is closed
      const slashStyle = feedbackIsClosed
        ? {
            position: "relative",
            overflow: "hidden",
          }
        : {};

      const slashElement = feedbackIsClosed ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "150%",
            height: "2px",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            transform: "translate(-50%, -50%) rotate(-45deg)",
            transformOrigin: "center",
          }}
        />
      ) : null;

      return (
        <>
          <div
            size={"small"}
            data-tip={
              feedbackIsClosed
                ? feedbackForId[0].issueCategory.name + " (Closed)"
                : feedbackForId[0].issueCategory.name
            }
            style={{ ...selectedStyle, ...slashStyle }}
            className="clickableChip gridFeedbackChip"
            onClick={(e) => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
              this.setState({ openOnFeedback: true }, () => {
                this.toggleTicketDetailsModal(d, d.id);
                this.setState({ isOrderDetails: !isTicket });
              });
            }}
          >
            {slashElement}
          </div>
          <ReactTooltip />
        </>
      );
    }
  }

  setAccountRecentSalesRep(order) {
    if (!order) {
      this.setState({
        accountRecentSalesRep: this.state.accountOwner,
      });
      return;
    }
    let accountRecentSalesRep = null;
    OrderService.getFlatOrderActivity(order.id)
      .then((res) => {
        accountRecentSalesRep = res.activity.owner;
        this.setState({
          accountRecentSalesRep: accountRecentSalesRep,
        });
      })
      .catch((err) => {});
  }
  retrievePatientEquipment(id) {
    this.setState({ patientEquipmentLoaded: false });
    return OrderService.getPatientEquipment(id)
      .then((patientEquipmentData) => {
        if (patientEquipmentData && patientEquipmentData.length > 0) {
          let ordersFull = [];
          patientEquipmentData.forEach((data) => {
            let label = data.id
              .toString()
              .concat(data.orderType ? " - " + data.orderType : " - Blank Type")
              .concat(data.status ? " - " + data.status : " - Blank Status");
            ordersFull.push({ label: label, value: data.id });
          });
          this.setState({ allOrdersNotSorted: ordersFull });
          const { allLocations } = this.context;
          let ary = allLocations;
          let parentOrders = patientEquipmentData.filter(
            (f) => f.orderType === "New",
          );

          let index = ary.find((loc) => {
            if (!parentOrders || parentOrders.length === 0) {
              return loc.name === patientEquipmentData[0].salesLocation;
            } else {
              return loc.name === parentOrders[0].salesLocation;
            }
          });
          this.setState({
            salesLocation: index,
            patientSalesLocation: index,
          });
          let gridData = this.state.gridData,
            o = [],
            sideCardGridData = this.state.sideCardGridData,
            sideCardOrders = [];

          patientEquipmentData.sort((a, b) => {
            const statusA = a.status.toLowerCase();
            const statusB = b.status.toLowerCase();
            if (statusA === "cancelled" && statusB !== "cancelled") {
              return 1;
            }
            if (statusA !== "cancelled" && statusB === "cancelled") {
              return -1;
            }

            return 0;
          });

          let firstNewOrder = patientEquipmentData.find((order) => {
            return order.orderType.toLowerCase() === "new";
          });

          this.setAccountRecentSalesRep(firstNewOrder);

          patientEquipmentData.forEach((d) => {
            if (
              d.status.toLowerCase() !== "setup" &&
              d.status.toLowerCase() !== "cancelled"
            ) {
              if (d.parentOrder) {
                let i = patientEquipmentData.findIndex(
                  (x) => x.orderId === d.parentOrder,
                );
                if (
                  patientEquipmentData[i].status.toLowerCase() === "cancelled"
                ) {
                  return;
                }
              }
              sideCardOrders.push({
                orderId: this.renderSideCardId(d),
                id: d.orderId,
                date: moment(d.createdAt).format("MM/DD/YYYY"),
                reason: d.reason,
                status: this.renderSideCardStatus(d),
                orderType: d.orderType,
                isApproved: d.isApproved,
              });
            }
          });
          let parentsWithKids =
            this.sortParentsAndChildren(patientEquipmentData);
          parentsWithKids.forEach((d) => {
            o.push({
              blank: this.renderCreateTicketButton(d, d.id),
              orderIdLink: this.renderOrderLink(d.id),
              orderId: d.id,
              statusChip: this.renderStatusChip(d),
              category: this.renderProductInformation(d),
              points: d.points,
              serialNumber: d.serial,
              setupDate:
                d.setupDate && d.setupDate !== null
                  ? globalFunctions.format(d.setupDate, {
                      month: "2-digit",
                      day: "2-digit",
                      year: "2-digit",
                    })
                  : null,
              lastNoteDate:
                d && d.lastNoteDate && d.lastNoteDate !== null
                  ? moment(d.lastNoteDate).format("MM/DD/YY")
                  : null,
              feedback: this.renderFeedbackChip(d, "order"),
              tickets: d.children,
              status: d.status,
              reason: d.reason,
              ticketRows: d.children
                ? this.createTicketRowData(d, d.children)
                : null,
              orderType: d.orderType,
              isApproved: d.isApproved,
              orderStatusReasonId: d.orderStatusReasonId,
              routingInformation: null,
            });
          });
          gridData.rows = o;
          sideCardGridData.rows = sideCardOrders;
          let openAndNotApproved = this.state.sideCardGridData.rows.filter(
            (d) => d.isApproved !== true,
          );

          this.setState({
            gridData: gridData,
            sideCardGridData: sideCardGridData,
            patientEquipmentTickets: patientEquipmentData,
            openAndNotApproved: openAndNotApproved,
          });

          if (this.state.shouldOpenOrderId) {
            setTimeout(() => {
              this.setState(
                {
                  patientEquipmentLoaded: true,
                },
                () => {
                  this.highlightOrderRow(
                    this.state.shouldOpenOrderId,
                    "service",
                  );
                  this.setState({ shouldOpenOrderId: null });
                },
              );
            }, 1);
          } else {
            setTimeout(() => {
              this.setState({
                patientEquipmentLoaded: true,
              });
            }, 1);
          }
        } else {
          this.setState({
            accountRecentSalesRep: this.state.accountOwner,
            gridData: this.state.gridData,
            sideCardGridData: this.state.sideCardGridData,
            patientEquipmentTickets: [],
            patientEquipmentLoaded: true,
          });
        }
      })

      .catch((err) => {
        console.log(err);
        toast.error(
          "Oh no! An error occurred while retrieving patient orders.",
        );
        NotistackEnqueueSnackbar(
          "Oh no! An error occurred while retrieving patient orders.",
          { variant: "error" },
        );
      });
  }

  renderProductInformation(p) {
    if (p.product && p.product !== null) {
      if (
        p.orderType &&
        p.orderType.toLowerCase() === "new" &&
        p.equipmentDisplayName
      ) {
        return <div>{p.equipmentDisplayName}</div>;
      } else {
        return (
          <div>
            {p.category}
            <br />
            {`(${p.qty}) ${p.product}`}
          </div>
        );
      }
    } else {
      return (
        <div>
          No Equipment Added
          <br />
        </div>
      );
    }
  }

  renderOrderLink(id) {
    return <div className={"orderIdText"}>{id}</div>;
  }

  renderSideCardId(order) {
    return (
      <div>
        <p className="openOrdersRowLabel" style={{ marginBottom: 0 }}>
          {order.orderType.toLowerCase() === "service" ? "Service" : "Sales"}
        </p>
        <p
          className=""
          style={{
            marginBottom: 0,
            color: "#5881C1",
            fontWeight: 500,
          }}
        >
          {order.id}
        </p>
      </div>
    );
  }

  renderSideCardStatus(order) {
    if (order.status.toLowerCase() === "in process") {
      var chipColor = "#FFF5DE";
      var chipBorderColor = "#FBC02D51";
      var chipFontColor = "#75570D";
    } else if (order.status.toLowerCase() === "ready to deliver") {
      chipColor = "#E5F9E4";
      chipBorderColor = "#52B48F32";
      chipFontColor = "#195D17";
    } else if (order.status.toLowerCase() === "new") {
      chipColor = "#E3EBFA";
      chipBorderColor = "#316BCF32";
      chipFontColor = "#316BCF";
    } else {
      chipColor = "#FFF";
      chipBorderColor = "#00032";
      chipFontColor = "#000";
    }

    return (
      <MUIChip
        label={order.status}
        variant={"outlined"}
        size={"small"}
        style={{
          color: chipFontColor,
          backgroundColor: chipColor,
          border: `1px solid ${chipBorderColor}`,
        }}
      />
    );
  }

  highlightOrderRow(id, openModalOfType) {
    if (this.state.TabsOneActiveItem !== "1") {
      this.toggleTicketDetailsModal();
    }
    this.setState({ TabsOneActiveItem: "1" });
    if (
      this.state.highlightedRow.id === id ||
      this.state.highlightedRow.orderId === id
    ) {
      return;
    }
    let rows = this.state.gridData.rows;
    let expanded = this.state.expandedRowIds;

    let index = rows.findIndex((x) => x.orderId === id);
    let order = {};
    if (index < 0) {
      rows.forEach((row, idx) => {
        let tempIndex = row.tickets.findIndex((x) => x.orderId === id);
        if (tempIndex > -1) {
          order = row.tickets[tempIndex];
          if (!expanded.includes(idx)) {
            expanded.push(idx);
            this.setExpandedRowIds(expanded);
          }
        }
      });
    } else {
      order = rows[index];
    }

    this.setState({ highlightedRow: order });
    setTimeout(() => {
      this.scrollToOrder(order);
    }, 1);

    if (openModalOfType === "service") {
      setTimeout(() => {
        this.toggleTicketDetailsModal(order, order.id || order.orderId);
      }, 1);
    }
    setTimeout(() => {
      this.removeHighlightRow(id);
    }, 6000);
  }
  scrollToOrder(order) {
    let id = order.orderId || order.id;
    if (!id) {
      return;
    } else {
      let elem = document.getElementById(id.toString());
      if (elem) {
        elem.scrollIntoView();
      }
    }
  }

  removeHighlightRow(id) {
    let currHighlight = this.state.highlightedRow.id
      ? this.state.highlightedRow.id
      : this.state.highlightedRow.orderId;
    if (currHighlight === id) {
      this.setState({ highlightedRow: { id: null } });
    }
  }

  handleCreateTicketDropDown = (e) => {
    if (e && e.value && e.value.toLowerCase() === "service") {
      this.toggleCreateTicketModal(e.order, e.orderId, "Service");
    } else if (e && e.value && e.value.toLowerCase() === "pickup") {
      this.toggleCreateTicketModal(e.order, e.orderId, "Pickup");
    } else if (e && e.value && e.value.toLowerCase() === "billing issue") {
      this.toggleCreateTicketModal(e.order, e.orderId, "Billing Issue");
    }
  };

  renderCreateTicketButton(order, orderId) {
    const customStyles = {
      option: (styles) => ({
        ...styles,
        cursor: "pointer",
        whiteSpace: "nowrap",
      }),
      control: (base) => ({
        ...base,
        boxShadow: "none",
      }),
      menu: (provided) => ({
        ...provided,
        width: "100px",
      }),
    };

    if (
      order.orderType.toLowerCase() === "new" &&
      order.status.toLowerCase() !== "cancelled"
    ) {
      return (
        <div
          className={"test1"}
          title={this.legacyTicketCreationTooltip}
          onClick={(e) => {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            if (disableCreate) {
              toast.warn(
                "Cannot Create a New Ticket on an Order That Has a Completed Pickup",
              );
              NotistackEnqueueSnackbar(
                "Cannot Create a New Ticket on an Order That Has a Completed Pickup",
                { variant: "error" },
              );
            }
          }}
        >
          <Select
            styles={customStyles}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            className={"createTicketDropDown"}
            isDisabled
            isSearchable={false}
            placeholder={"Create Ticket"}
            value={{
              label: "Create Ticket",
              value: "Create Ticket",
            }}
            options={[
              {
                label: (
                  <MUITooltip
                    title={
                      this.state.preventServicePatientIssues &&
                      this.state.preventServicePatientIssues.length > 0
                        ? this.state.preventServicePatientIssueSummaryText
                        : ""
                    }
                    placement="right"
                    PopperProps={{
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, 35], // Solution for positioning tooltip to the right of the menu and not being covered by the menu (zIndex issue)
                          },
                        },
                      ],
                    }}
                  >
                    <span>Service</span>
                  </MUITooltip>
                ),
                value: "service",
                order: order,
                orderId: orderId,
                isDisabled:
                  this.state.preventServicePatientIssues &&
                  this.state.preventServicePatientIssues.length > 0, // Disable "Service" if patient is in Collections
              },
              {
                label: "Pickup",
                value: "pickup",
                order: order,
                orderId: orderId,
              },
              {
                label: "Billing Issue",
                value: "billing issue",
                order: order,
                orderId: orderId,
              },
            ]}
            onChange={(e) => this.handleCreateTicketDropDown(e)}
          />
        </div>
      );
    }
    if (order.orderType.toLowerCase() === "service") {
      return "Service - No Parent Found";
    }
  }

  getAllUsers() {
    const { allUsers } = this.context;
    let customerServiceUsers = [];
    let complianceUsers = [];

    const o = allUsers
      .filter((user) => user.active)
      .map((user) => ({
        name: `${user.firstname} ${user.lastname}`,
        id: user.id,
      }))
      .sort((a, b) => a.name.localeCompare(b.name));

    let customerExperienceTeam = Object.values(this.context.teamsIndexed).find(
      (team) => team.id === 6,
    );
    let customerExperienceTeamUsers = Object.values(
      this.context.teamUsersIndexed,
    ).filter((teamUser) => teamUser.teamId === 6);
    let complianceTeam = Object.values(this.context.teamsIndexed).find(
      (team) => team.id === 25,
    );
    let complianceTeamUsers = Object.values(
      this.context.teamUsersIndexed,
    ).filter((teamUser) => teamUser.teamId === 25);

    customerExperienceTeamUsers.forEach((teamUser) => {
      let user = this.context.usersIndexed[teamUser.userId];
      let manager = this.context.usersIndexed[customerExperienceTeam.managerId];

      if (user) {
        customerServiceUsers.push({
          name: `${user.firstname} ${user.lastname}`,
          id: user.id,
          active: user.active,
        });
      }

      if (manager && !customerServiceUsers.some((u) => u.id === manager.id)) {
        customerServiceUsers.push({
          name: `${manager.firstname} ${manager.lastname}`,
          id: manager.id,
          active: user.active,
        });
      }
    });

    complianceTeamUsers.forEach((teamUser) => {
      let user = this.context.usersIndexed[teamUser.userId];
      let manager = this.context.usersIndexed[complianceTeam.managerId];

      if (user) {
        complianceUsers.push({
          name: `${user.firstname} ${user.lastname}`,
          id: user.id,
          active: user.active,
        });
      }

      if (manager && !complianceUsers.some((u) => u.id === manager.id)) {
        complianceUsers.push({
          name: `${manager.firstname} ${manager.lastname}`,
          id: manager.id,
          active: user.active,
        });
      }
    });

    customerServiceUsers.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;

      return 0;
    });

    complianceUsers.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;

      return 0;
    });

    this.setState({
      allUsers: allUsers,
      options: o,
      filteredOpts: o,
      csUsers: customerServiceUsers,
      filteredCSUsers: customerServiceUsers,
      filteredComplianceUsers: complianceUsers,
    });
  }

  getPatientPhones(id) {
    patientPhoneService.getPatientPhones(id).then((res) => {
      let rows = [],
        data = this.state.phoneData;
      res.forEach((val, idx) => {
        var row = {
          id: val.id,
          patientId: val.patientId,
          contactName: val.contactName,
          phoneType: val.phoneType,
          phoneNumber: val.phoneNumber,
        };
        row.delete = this.renderDeletePhoneButton(row);
        rows.push(row);
      });
      data.rows = rows;
      this.setState({ phoneData: data });
    });
  }

  getPatientNotes(id) {
    return PatientNoteService.getNotesByPatient(id)
      .then((res) => {
        let sorted = res.sort((a, b) => {
          let da = new Date(a.noteAddedOn).getTime(),
            db = new Date(b.noteAddedOn).getTime();

          return da > db ? -1 : 1;
        });
        this.setState({
          notes: sorted,
        });
      })
      .catch((e) => {
        toast.error(e);
        NotistackEnqueueSnackbar(String(e), { variant: "error" });
      });
  }

  createComplaintNote(callback) {
    const { currentUser } = this.context;

    let issueId = this.state.currentComplaint.id,
      text = this.state.complaintNoteText,
      obj = {};

    if (text === "") {
      toast.warn("You must enter note text");
      NotistackEnqueueSnackbar("You must enter note text", {
        variant: "error",
      });
      return;
    }

    obj.patientIssueId = issueId;
    obj.noteText = text;
    obj.noteAddedOn = new Date().toISOString();
    obj.noteAddedBy = currentUser.username;

    ComplaintService.createPatientIssueNote(obj)
      .then((res) => {
        toast.success("Note created successfully");
        NotistackEnqueueSnackbar("Note created successfully", {
          variant: "success",
        });
        let notes = this.state.complaintNotes;

        if (notes["notes" + issueId]) {
          notes["notes" + issueId].push(res);
        } else {
          notes["notes" + issueId] = [res];
        }
        this.setState({
          complaintNoteModal: false,
          complaintNotes: notes,
          complaintNoteText: "",
        });

        if (callback) {
          callback();
        }
      })
      .catch((e) => {
        toast.error(e);
        NotistackEnqueueSnackbar(String(e), { variant: "error" });
      });
  }

  createPatientNote() {
    const { currentUser } = this.context;

    let notes = this.state.notes,
      note = {
        patientId: parseInt(this.state.id),
        note: this.state.noteText,
        noteAddedBy: currentUser.username,
        noteAddedOn: globalFunctions.getUTCMoment(),
      };

    PatientNoteService.createPatientNote(note)
      .then((res) => {
        if (res.noteAddedOn.indexOf("Z") > 0) {
          res.noteAddedOn = res.noteAddedOn.split("Z")[0];
        }

        notes.reverse();
        notes.push(res);
        notes.reverse();
        this.setState({
          notes: notes,
          createPatientNoteModal: false,
          noteText: "",
        });
        toast.success("Patient Note Saved Successfully!");
        NotistackEnqueueSnackbar("Patient Note Saved Successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        toast.error(err.toString());
        NotistackEnqueueSnackbar(err.toString(), { variant: "error" });
      });
  }

  closeComplaint() {
    const { currentUser } = this.context;

    let c = this.state.currentComplaint,
      idx = this.state.complaints.findIndex((v) => {
        return v.id === c.id;
      });

    c.issueClosedBy = currentUser;
    c.issueClosedById = currentUser.id;
    c.issueClosedOn = new Date().toISOString();
    c.issueStatus = 1;
    return ComplaintService.updatePatientIssue(c)
      .then((res) => {
        toast.success("Customer feedback closed successfully");
        NotistackEnqueueSnackbar("Customer feedback closed successfully", {
          variant: "success",
        });

        let com = this.state.complaints;
        res.issueClosedBy = currentUser;
        com.splice(idx, 1, res);

        this.setState({
          closeComplaintModal: false,
          complaints: com,
        });
        this.getPatientShowAlertAndPreventServiceIssues();
        this.retrievePatientEquipment(this.state.id);
      })
      .catch((e) => {
        console.log(e);
        toast.error(e);
        NotistackEnqueueSnackbar(String(e), { variant: "error" });
      });
  }

  cancelTicket() {
    let ticket = this.state.curOrder;
    if (!ticket) {
      this.setState({
        cancelTicketModal: false,
      });
      return;
    }

    this.statusChanged(4);
    this.updateReason();

    this.saveStatusReasonChange();
    this.setState({
      cancelTicketModal: false,
    });
  }
  addAdditionalPArtsToTicket() {
    let ticket = this.state.curOrder;
    if (!ticket) {
      this.setState({
        addAdditionalPartsModal: false,
      });
      return;
    }

    this.statusChanged(1);
    this.updateReason(72);

    this.saveStatusReasonChange();
    this.setState({
      addAdditionalPartsModal: false,
    });
  }

  getOrderType = (orderType) => {
    const nOrder = this.state.nOrder;
    nOrder.orderType = orderType.name;

    if (orderType.id !== 1) {
      if (
        nOrder.orderActivityProducts &&
        nOrder.orderActivityProducts.length > 0
      ) {
        nOrder.orderActivityProducts = [];
        this.setState({
          nOrder: nOrder,
        });
      }
      this.setState({
        chosenCategory: null,
      });
    }

    this.setState({
      nOrder: nOrder,
      selectedOrderTypeRadio: orderType.id,
    });
  };

  handleChange(property, event) {
    //update the property that the user has edited in the order...BC
    let nPatient = this.state.ePatient;

    if (
      property === "height" ||
      property === "weight" ||
      property === "btPId"
    ) {
      nPatient[property] = event.target.value
        ? parseInt(event.target.value)
        : null;
    } else if (
      property === "state" ||
      property === "orderingProviderId" ||
      property === "firstDiagnosisCodeId" ||
      property === "secondDiagnosisCodeId" ||
      property === "thirdDiagnosisCodeId" ||
      property === "fourthDiagnosisCodeId"
    ) {
      nPatient[property] = event ? event.value : null;
    } else if (property === "mbi") {
      nPatient[property] = event.target.value.toUpperCase();
    } else if (property === "phone") {
      // Remove all non-digit characters
      const cleaned = event.target.value.replace(/\D/g, "");

      // Format the cleaned number
      let formattedNumber = "";

      if (cleaned.length > 0) {
        formattedNumber = `(${cleaned.slice(0, 3)}`;
      }
      if (cleaned.length > 3) {
        formattedNumber += `) ${cleaned.slice(3, 6)}`;
      }
      if (cleaned.length > 6) {
        formattedNumber += `-${cleaned.slice(6, 10)}`;
      }
      if (cleaned.length > 10) {
        formattedNumber += ` ${cleaned.slice(10)}`; // Allow additional digits after 10
      }

      // Update the phone number in state
      nPatient[property] = formattedNumber;
    } else {
      nPatient[property] = event.target.value;
    }
    this.setState({ ePatient: nPatient });
  }

  geocoder(val) {
    let geocodingClient = this.state.geoClient;
    let opts = {
      MaxResults: 5,
      LocationType: "Street,Address",
      Countries: "us",
      AutoComplete: true,
      VerboseResults: true,
    };
    const callback = (status, res) => {
      if (status !== 200) {
        alert(res.error);
      } else {
        let locations = res.data.locations;
        this.setState({ searchResults: locations });
      }
    };

    if (geocodingClient && geocodingClient.searchByPoint) {
      // Call the searchByPoint API to search the points by the input address.
      geocodingClient.searchByPoint(val, callback, opts);
    }
  }

  geoGoogle(val) {
    if (val) {
      googleService.searchAddress(val).then((res) => {
        this.setState({ searchResults: res.results });
      });
    }
  }

  renderSearchResult() {
    let results = this.state.searchResults;
    if (results.length > 0) {
      return (
        <div className="resultWrap">
          <div style={{ width: "100%" }}>
            <button
              id="popup-closer"
              className="ol-popup-closer"
              onClick={this.clearSearch.bind(this)}
            />
          </div>
          <br />
          <ul id="geocoderResult">
            {results.map((item) => {
              return (
                <li key={results.indexOf(item)}>
                  <button
                    style={{
                      border: "0",
                      backgroundColor: "transparent",
                      color: "#3887BE",
                    }}
                    onClick={this.setAddress.bind(this, item)}
                  >
                    {" "}
                    {item.address}{" "}
                  </button>
                </li>
              );
            })}
          </ul>
          <div className="loading hidden">
            <Spinner small />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderGoogleSearchResult() {
    let results = this.state.searchResults;
    if (results.length > 0) {
      return (
        <div className="resultWrap">
          <div style={{ width: "100%" }}>
            <button
              id="popup-closer"
              className="ol-popup-closer"
              onClick={this.clearSearch.bind(this)}
            />
          </div>
          <br />
          <ul id="geocoderResult">
            {results.map((item, index) => {
              if (
                index < 4 &&
                item.formatted_address &&
                item.formatted_address.length > 0
              ) {
                return (
                  <li key={results.indexOf(item)}>
                    <button
                      style={{
                        border: "0",
                        backgroundColor: "transparent",
                        color: "#3887BE",
                      }}
                      onClick={this.setGoogleAddress.bind(this, item)}
                    >
                      {" "}
                      {item.formatted_address}{" "}
                    </button>
                  </li>
                );
              }
              return null;
            })}
          </ul>
          <div className="loading hidden">
            <Spinner small />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  clearSearch() {
    this.setState({ searchResults: [] });
  }

  setAddress = (location) => {
    const nPatient = this.state.ePatient;
    let addr = location.address.split(",");

    let street = addr[0],
      city = addr[1],
      county = addr[2],
      state = addr[3],
      zip = addr[4];

    nPatient.address = street ? street.trim() : "";
    nPatient.city =
      city && city.toLowerCase().indexOf("county") < 0 ? city.trim() : "";
    nPatient.state =
      state && city.toLowerCase().indexOf("county") < 0
        ? state.trim()
        : county
          ? county.trim()
          : "";
    nPatient.zipCode =
      zip && parseInt(zip) ? zip.trim() : parseInt(state) ? state : "";
    nPatient.latitude = location.locationPoint.x;
    nPatient.longitude = location.locationPoint.y;
    this.setState({ ePatient: nPatient, searchResults: [] });
  };

  setGoogleAddress = (location) => {
    const nPatient = this.state.ePatient;

    let addr = location.address_components;
    let numComp = "",
      streetComp = "",
      city = "",
      state = "",
      zip = "";
    addr.forEach((item) => {
      if (item.types.includes("street_number")) {
        numComp = item.long_name;
      } else if (item.types.includes("route")) {
        streetComp = item.long_name;
      } else if (
        item.types.includes("neighborhood") ||
        item.types.includes("locality")
      ) {
        city = item.long_name;
      } else if (item.types.includes("administrative_area_level_1")) {
        state = item.long_name;
      } else if (item.types.includes("postal_code")) {
        zip = item.long_name;
      }
    });

    nPatient.address = numComp + " " + streetComp;
    nPatient.city = city;
    nPatient.state = state;
    nPatient.zipCode = zip;
    nPatient.latitude = location.geometry.location.lat || null;
    nPatient.longitude = location.geometry.location.lng || null;
    this.setState({ ePatient: nPatient, searchResults: [] });
  };

  handleDatePickerChange = (property, value) => {
    //update the date property on the object that the user has edited in the order...BC
    if (property === "dateOfDeath") {
      const nPatient = this.state.ePatient;
      nPatient[property] = value;
      this.setState({ ePatient: nPatient });
    } else {
      const nPatient = this.state.ePatient;
      value = moment(value).format("MM/DD/YYYY");
      nPatient[property] = value;
      this.setState({ ePatient: nPatient });
    }
  };

  handleCheckboxChange = (property, event) => {
    //update the property that the user has edited in the order...BC
    const nPatient = this.state.ePatient;
    nPatient[property] = event.target.checked;
    this.setState({ ePatient: nPatient });
  };

  handleComplaintCheckboxChange = (property, event) => {
    const complaint = this.state.nComplaint;
    complaint[property] = event.target.checked;
    this.setState({
      nComplaint: complaint,
    });
  };

  handleNoteChange(ev) {
    this.setState({ noteText: ev.target.value });
  }

  completedChange = (event) => {
    this.setState({ completed: event.target.checked });
  };

  changeInsuranceType(type, secondary) {
    let ePatient = this.state.ePatient,
      tplt = this.state.patientEditTemplate;
    if (secondary === true) {
      ePatient.secondaryInsuranceType = type;
      ePatient.secondaryInsuranceTypeId = type.id;
      ePatient.secondaryInsuranceSubType = null;
      ePatient.secondaryInsuranceSubTypeId = null;
      tplt.item.secondaryInsuranceTypeId = type.id;
      tplt.item.secondaryInsuranceSubTypeId = null;
    } else {
      ePatient.insuranceType = type;
      ePatient.insuranceTypeId = type.id;
      ePatient.insuranceSubType = null;
      ePatient.insuranceSubTypeId = null;
      tplt.item.insuranceTypeId = type.id;
      tplt.item.insuranceSubTypeId = null;
    }
    this.setState({ ePatient: ePatient, patientEditTemplate: tplt });
  }

  changeInsuranceSubType(type, secondary) {
    if (type != null) {
      delete type.deleted;
      delete type.deletedAt;
      delete type.deletedById;
    }
    let ePatient = this.state.ePatient,
      tplt = this.state.patientEditTemplate;
    if (secondary === true) {
      ePatient.secondaryInsuranceSubType = type;
      ePatient.secondaryInsuranceSubTypeId = type.id;
      tplt.item.secondaryInsuranceSubTypeId = type.id;
    } else {
      ePatient.insuranceSubType = type;
      ePatient.insuranceSubTypeId = type.id;
      tplt.item.insuranceSubTypeId = type.id;
    }
    this.setState({ ePatient: ePatient });
  }

  changeContactRelationship(rel) {
    let ePatient = this.state.ePatient;

    ePatient.emergencyRelationship = rel;

    this.setState({ ePatient: ePatient });
  }

  changeContactMethod(rel) {
    let ePatient = this.state.ePatient;

    ePatient.preferredContactMethod = rel;

    this.setState({ ePatient: ePatient });
  }

  renderDialog() {
    let openOrders = [];
    if (
      this.state.patientEquipmentLoaded &&
      this.state.openAndNotApproved &&
      this.state.openAndNotApproved !== null
    ) {
      this.state.openAndNotApproved.forEach((o) => openOrders.push(o));
      const sortByCurOrder = (open) => {
        const sorter = (a, b) => {
          if (
            a.id !== this.state.curOrderId &&
            b.id === this.state.curOrderId
          ) {
            return 1;
          }
          if (
            a.id === this.state.curOrderId &&
            b.id !== this.state.curOrderId
          ) {
            return -1;
          }
          return b["id"] - a["id"];
        };
        open.sort(sorter);
      };
      sortByCurOrder(openOrders);
    }

    return (
      <React.Fragment>
        <MUIDialog
          maxWidth="md"
          open={this.state.setDialogOpen}
          onClose={() => this.setState({ setDialogOpen: false })}
        >
          <MUIDialogTitle variant="h6" color="textPrimary">
            {"Update Insurance?"}
          </MUIDialogTitle>
          <MUIDialogContent>
            <MUIDialogContentText variant="body1" color="textPrimary">
              <span style={{ display: "inline-block", paddingBottom: ".5rem" }}>
                Changes to the insurance will affect the following open tickets:
              </span>
              <br />
              {openOrders.map((o) => (
                <span
                  style={
                    this.state.curOrderId && this.state.curOrderId === o.id
                      ? { color: MUIBlueColor[700] }
                      : {}
                  }
                >
                  #{o.id} ({o.orderType}) {o.status.props.label}
                  {o.reason ? ": " + o.reason : null}{" "}
                  {this.state.curOrderId && this.state.curOrderId === o.id ? (
                    <b>(Current Ticket)</b>
                  ) : (
                    ""
                  )}{" "}
                  <br />
                </span>
              ))}
              <span style={{ display: "inline-block", paddingTop: "1rem" }}>
                Do you wish to continue with these changes?
              </span>
            </MUIDialogContentText>
          </MUIDialogContent>
          <MUIDialogActions>
            <MUIButton
              variant="text"
              onClick={() => this.setState({ setDialogOpen: false })}
            >
              Cancel
            </MUIButton>
            <MUIButton
              variant="contained"
              onClick={() => {
                this.savePatient(true);
                this.setState({
                  setDialogOpen: false,
                });
              }}
              autoFocus
            >
              Confirm
            </MUIButton>
          </MUIDialogActions>
        </MUIDialog>
      </React.Fragment>
    );
  }

  shiftDiagnosisCodes = () => {
    const { curOrder, eOrder, ePatient } = this.state;

    const isTicketOpen = curOrder && curOrder.id === eOrder.id;

    const target = isTicketOpen ? eOrder : ePatient;

    const diagnosisCodes = [
      target.firstDiagnosisCodeId || null,
      target.secondDiagnosisCodeId || null,
      target.thirdDiagnosisCodeId || null,
      target.fourthDiagnosisCodeId || null,
    ];

    const shiftedCodes = diagnosisCodes.filter((code) => code !== null);
    const updatedCodes = [...shiftedCodes, null, null, null, null].slice(0, 4);

    target.firstDiagnosisCodeId = updatedCodes[0];
    target.secondDiagnosisCodeId = updatedCodes[1];
    target.thirdDiagnosisCodeId = updatedCodes[2];
    target.fourthDiagnosisCodeId = updatedCodes[3];

    if (isTicketOpen) {
      this.setState({ eOrder: target });
    } else {
      this.setState({ ePatient: target });
    }
  };

  savePatient(fromInsurance, lastAorDate) {
    let t = this,
      st = this.state,
      ph = st.patientPhoneNumbers;

    // if (st.ePatient.mbi !== st.previousMbi && st.ePatient.mbi && st.ePatient.mbi.length !== 11) {
    //     toast.error("Please enter a valid MBI.");
    //     return;
    // }

    // Shift diagnosis codes before saving
    this.shiftDiagnosisCodes();

    if (this.state.canEditInsuranceInfo) {
      if (st.ePatient.mbi) {
        // Check if the MBI is exactly 11 characters
        if (st.ePatient.mbi.length !== 11) {
          return (
            toast.error("MBI must be 11 characters.") +
            this.setState({ saveProcessStarted: false })
          );
        }

        // Check if the MBI contains any of the forbidden letters
        if (/S|L|O|I|B|Z/.test(st.ePatient.mbi.toUpperCase())) {
          return (
            toast.error(
              "MBI can't contain any of the following letters: S, L, O, I, B, Z.",
            ) + this.setState({ saveProcessStarted: false })
          );
        }

        // Check MBI format
        if (
          !/^[1-9][A-z][\dA-z]\d[A-z][\dA-z]\d[A-z][A-z]\d\d$/.test(
            st.ePatient.mbi,
          )
        ) {
          return (
            toast.error(`Invalid MBI format.`) +
            this.setState({ saveProcessStarted: false })
          );
        }
      }
    }

    if (this.state.canEditBasicInfo && st.ePatient.phone) {
      // Remove all non-digit characters to get the 10 digits
      const cleanedPhone = st.ePatient.phone.replace(/\D/g, "");

      // Check if the cleaned phone number contains exactly 10 digits
      if (cleanedPhone.length !== 10) {
        toast.warning(
          "Invalid phone number. It must contain exactly 10 digits.",
        );
        return;
      }
    }

    if (lastAorDate && lastAorDate !== null && lastAorDate === true) {
      st.ePatient.lastAorDate = new Date();
    }

    if (st.patient.dateOfBirth !== st.ePatient.dateOfBirth) {
      st.ePatient.dateOfBirth = moment(st.ePatient.dateOfBirth).format(
        "MM/DD/YYYY",
      );
    }

    let phs = ph.filter((x) => x.id === null);
    if (phs && phs.length > 0) {
      patientPhoneService
        .addPatientPhones(st.ePatient.id, phs)
        .then((res) => {
          this.getPatientPhones(this.state.id);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    return OrderService.updatePatient(t.state.ePatient, fromInsurance)
      .then((data) => {
        if (
          this.state.TabsOneActiveItem === "2" ||
          this.state.TabsOneActiveItem === "3" ||
          this.state.TabsOneActiveItem === "5"
        ) {
          this.setState({
            TabsOneActiveItem: "1",
          });
        }

        this.setState(
          {
            patient: data,
            ePatient: JSON.parse(JSON.stringify(data)),
            canEditBasicInfo: false,
            canEditInsuranceInfo: false,
            canEditClinicalInfo: false,
            radioBtnSelected: false,
            radio: {
              serviceTicketAction: "",
              pickupTicketAction: { label: "", value: "" },
            },
            createTicketNote: null,
          },
          () => {
            this.openOrder();
            this.loadPatientChart(this.state.ePatient.id);
          },
        );

        toast.success("Saved Successfully!");
      })

      .catch((err) => {
        toast.error("Oh no! An error occurred while saving.");
      });
  }

  retrieveVerificationResults(id) {
    insuranceService
      .getPatientVerifications(id)
      .then((res) => {
        this.setState({
          verificationResults: res && res.length > 0 ? res.reverse() : [],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  submitChangesToPverify() {
    //uncomment ifyou want to test the routing after verification
    // var o = this.state.eOrder;
    // o.status = 1;
    // o.orderStatusReasonId = 15;
    // this.updateOrder(o);
    // this.setState({
    //     verificationModalOpen: !this.state.verificationModalOpen,
    // });

    // return
    var item = this.state.ePatient,
      ticks = this.state.eOrder; // || this.state.patientEquipmentTickets.filter(x => x.status.toLowerCase() !== "cancelled");

    if (item.insuranceSubTypeId || item.secondaryInsuranceSubTypeId) {
      if (
        !item.insurancePolicy &&
        !item.mbi &&
        !item.secondaryInsurancePolicy
      ) {
        toast.error("Policy # is required to submit verification.");
        return;
      }
    }

    if (item.insuranceSubTypeId && item.secondaryInsuranceSubTypeId) {
      if (!item.insurancePolicy && !item.mbi && item.secondaryInsurancePolicy) {
        toast.warning("Policy # is missing on primary insurance.");
      }
      if (
        (item.insurancePolicy || item.mbi) &&
        !item.secondaryInsurancePolicy
      ) {
        toast.warning("Policy # is missing on secondary insurance.");
      }
    }

    if (ticks) {
      this.setState({
        submitToPverifyLoading: true,
      });
      var model = {
        orderId: ticks.id,
        insuranceSubTypeId: item.insuranceSubTypeId,
        secondaryInsuranceSubTypeId: item.secondaryInsuranceSubTypeId,
        insuranceGroup: item.insuranceGroup,
        secondaryInsuranceGroup: item.secondaryInsuranceGroup,
        insurancePolicy: item.insurancePolicy,
        secondaryInsurancePolicy: item.secondaryInsurancePolicy,
      };

      insuranceService
        .verifyPatient(model)
        .then((res) => {
          if (res && res.length > 0) {
            toast.success("Verification requested!");
            this.retrievePatientInsurance(this.state.id);
            this.retrieveVerificationResults(this.state.id);
            this.setState({
              verificationModalOpen: true,
              submitToPverifyLoading: false,
            });
          } else {
            this.setState({
              submitToPverifyLoading: false,
            });
            toast.warn("There was an issue submitting the request.");
          }
        })
        .catch((e) => {
          this.setState({
            submitToPverifyLoading: false,
          });
          console.log(e);
          toast.error("Something went wrong with the request.");
        });
    } else toast.warn("No open tickets to verify insurance.");
  }

  toggleNewOrdersModal(order) {
    this.setState({ shouldOpenOrderId: order.id });
    this.retrievePatientEquipment(this.state.id).then((res) => {});
  }

  addNewNote(id, note) {
    if (this.state.saving) {
      return;
    }
    this.setState({
      saving: true,
    });
    this.toggleProcessing();

    return NoteService.createActivityNote(id, note)
      .then((res) => {
        if (res) {
          //need to set the last note date because otherwise the save overrides it...BC
          //let ord = this.state.eOrder;
          //ord.activity.lastNoteDate = new Date();

          if (res.createdAt.indexOf("Z") > 0) {
            res.createdAt = res.createdAt.split("Z")[0];
          }

          this.setState({ saving: false, createTicketNote: null });
          this.retrieveNotes(id);
        }
      })
      .catch((err) => {
        console.log(err);
        //Maybe send an error to the user?...BC
      });
  }

  createOrder(ticket, quoteItems) {
    if (this.state.disableCreate) {
      return;
    }
    this.setState({
      disableCreate: true,
    });
    const { currentUser, companyName } = this.context;
    let cb = currentUser;
    let st = this.state;
    let order = st.nOrder,
      patient = st.ePatient,
      // owner = st.accountOwner,
      owner = st.accountRecentSalesRep || st.accountOwner,
      productsAdded = st.productsAddedList;

    //account owner is the owner of hte patient
    //accountRecentSalesRep is sales rep on order?

    let activity = {
      type: "Order",
      accountId: patient.accountId,
      startedAt: new Date().toISOString(),
      endedAt: new Date().toISOString(),
      quality: false,
      modified: new Date().toISOString(),
      priority: 0,
      isExpense: false,
    };
    if (ticket) {
      order.orderType = ticket.orderActivityType.name;
      order.orderStatusReasonId = ticket.orderStatusReason.id;
      order.status = ticket.orderStatusReason.orderStatus;
      order.type = ticket.orderActivityType.name;
      activity.type = ticket.orderActivityType.activityType;
    }

    // if (!this.state.patientProductsLoaded) {
    //     return <div style={ { display: 'flex', justifyContent: 'center', alignItems: 'center' } }><MDBSpinner></MDBSpinner></div>
    // }
    //default sales and service location to owner of account...BC
    const { userprofileLocationsIndexed } = this.context;

    const ownerUserprofileLocation = Object.values(
      userprofileLocationsIndexed,
    ).find((userprofileLocation) => {
      return userprofileLocation.userprofileId === owner.id;
    });

    // default sales and service location to owner of account
    if (ownerUserprofileLocation) {
      order.serviceLocationId = ownerUserprofileLocation.locationsId;
      order.salesLocationId = ownerUserprofileLocation.locationsId;
    }

    //if the type is new, this works just fine...BC

    if (
      order.orderType === "New" ||
      (ticket && ticket.orderActivityType.name.toLowerCase() !== "service")
    ) {
      activity.ownerId = owner.id;
    } else if (companyName === "corkmedical") {
      //otherwise, the owner is the current logged in user...BC
      activity.ownerId = currentUser.id;
    } else {
      activity.ownerId = 211;
    }

    let er = [];
    //in this case, they must set the service location themselves from the box...BC
    if (this.state.serviceLocation != null) {
      if (
        companyName === "corkmedical" ||
        !ticket ||
        (ticket.type && ticket.type.toLowerCase() !== "service")
      ) {
        order.serviceLocationId = this.state.serviceLocation.id;
      } else {
        order.serviceLocationId = 45;
      }
    } else {
      er.push("You must select a service location.");
    }
    if (this.state.salesLocation != null) {
      order.billingLocationId = this.state.salesLocation.billingLocationId
        ? this.state.salesLocation.billingLocationId
        : this.state.salesLocation.id;
      if (
        companyName === "corkmedical" ||
        !ticket ||
        (ticket.orderActivityType &&
          ticket.orderActivityType.name.toLowerCase() !== "service")
      ) {
        order.salesLocationId = this.state.salesLocation.id;
      } else {
        order.salesLocationId = 45;
      }
    } else {
      er.push("You must select a sales location.");
    }

    if (ticket && ticket.orderActivityType.name.toLowerCase() === "pickup") {
      order.serviceLocationId = this.state.parentOrderServiceLocationId || 45;
    }

    if (
      order.orderType === "Service" &&
      (!productsAdded || productsAdded.length === 0) &&
      !ticket
    ) {
      er.push(
        "At least one product is required for a Service order. Please select a product and try again.",
      );
    }
    if (!ticket && this.state.selectedOrderTypeRadio !== 1) {
      if (order.type === "Order" && this.state.createNewOrderStatus !== null) {
        order.status = this.state.createNewOrderStatus.id;
      } else if (order.type === "Order" && !this.state.createNewOrderStatus) {
        er.push("You must select an order status.");
      }
      if (order.type === "Order" && this.state.createNewOrderReason !== null) {
        order.orderStatusReason = this.state.createNewOrderReason;
        order.orderStatusReasonId = this.state.createNewOrderReason.id;
      } else if (order.type === "Order" && !this.state.createNewOrderReason) {
        er.push("You must select an order reason.");
      }
    } else if (!ticket && this.state.selectedOrderTypeRadio === 1) {
      order.status = 0;
      order.orderStatusReason = this.context.orderStatusReasonsIndexed[11];
      order.orderStatusReasonId = 11;
    }
    if (er.length > 0) {
      er.forEach((e) => toast.error(e));
      this.setState({
        disableCreate: false,
      });
      return;
    }

    order.insuranceTypeId = patient.insuranceTypeId;
    order.insuranceSubTypeId = patient.insuranceSubTypeId;
    order.insurancePolicy = patient.insurancePolicy;
    order.insuranceGroup = patient.insuranceGroup;

    order.secondaryInsuranceTypeId = patient.secondaryInsuranceTypeId;
    order.secondaryInsuranceSubTypeId = patient.secondaryInsuranceSubTypeId;
    order.secondaryInsurancePolicy = patient.secondaryInsurancePolicy;
    order.secondaryInsuranceGroup = patient.secondaryInsuranceGroup;

    order.lastUpdatedOn = new Date();
    order.lastUpdatedById = currentUser.id;
    order.patientId = patient.id;
    order.patientName = patient.firstName + " " + patient.lastName;
    order.lastStatusChange = new Date().toISOString();

    order.phone = patient.phone;
    order.address = patient.address;
    order.city = patient.city;
    order.state = patient.state;
    order.zipCode = patient.zipCode;
    order.dateOfBirth = patient.dateOfBirth;
    order.weight = patient.weight;
    order.gender = patient.gender;
    order.email = patient.email;
    order.firstDiagnosisCodeId = patient.firstDiagnosisCodeId;
    order.secondDiagnosisCodeId = patient.secondDiagnosisCodeId;
    order.thirdDiagnosisCodeId = patient.thirdDiagnosisCodeId;
    order.fourthDiagnosisCodeId = patient.fourthDiagnosisCodeId;
    order.orderingProviderId = patient.orderingProviderId;
    order.orderingProviderNotFound = patient.orderingProviderNotFound;
    order.jsonOrderingProviderNotFoundData =
      patient.jsonOrderingProviderNotFoundData;
    order.hasInfectiousDisease = patient.hasInfectiousDisease;
    order.diseaseNotes = patient.diseaseNotes;

    if (
      (order.orderType === "Pickup" ||
        order.orderType === "Exchange" ||
        order.orderType === "Service") &&
      productsAdded.length > 0 &&
      (!ticket.type || ticket.type.toLowerCase() !== "service")
    ) {
      order.orderActivityProducts = [];
      for (let product of productsAdded) {
        order.orderActivityProducts.push({
          products: {
            abnRequired: false,
            amount: 0,
            approved: false,
            hcpcs: product.hcpcs || "",
            points: 0,
            productSubType: {
              id: product.productSubType.id,
              name: product.productSubType.name,
              hcpcs: product.hcpcs || "",
              productType: {
                id: product.productType.id,
                name: product.productType.name,
              },
            },
            productSubTypeId: product.productSubType.id,
            productTypeId: product.productType.id,
            productType: {
              id: product.productType.id,
              name: product.productType.name,
            },
            qty: 1,
            serial: product.serial || "",
          },
        });
      }
    }

    let po = this.state.selectedPreviousOrder;
    activity.orderActivity = order;

    this.setState({ createNewOrderProcessing: true });

    return OrderService.createOrder(activity)
      .then((res) => {
        if (po.previousOrderId) {
          po.currentOrderId = res.id;
          this.createServiceOrderReasonRecord(po);
        } else if (ticket) {
          let o = {
            previousOrderId:
              this.state.curOrder.id || this.state.curOrder.orderId,
            name:
              this.state.patient.firstName + " " + this.state.patient.lastName,
            technician: order.technician
              ? order.technician.name
              : "No Technician",
            salesRep: this.state.accountRecentSalesRep
              ? this.state.accountRecentSalesRep.name
              : "No Sales Rep",
            atp: order.atp ? order.atp.name : "No ATP",
            serviceReason:
              this.state.serviceReason && this.state.serviceReason !== null
                ? this.state.serviceReason
                : "",
            currentOrderId: res.id,
          };
          let note = {
            assignedToId: null,
            createdAt: globalFunctions.getUTCMoment(),
            createdBy: cb,
            createdById: cb.id,
            accountId: res.accountId,
            patientName: order.patientName,
            type: "ActivityNote",
            activityId: o.currentOrderId,
            dueDate: null,
            completed: true,
            task: false,
          };

          note.text = this.state.createTicketNote;
          this.createServiceOrderReasonRecord(o, res);
          this.addNewNote(o.currentOrderId, note);
          if (quoteItems) {
            this.createQuote(quoteItems, quoteItems.shipToPatient, res);
          }
        }

        this.setState({
          disableCreate: false,
          serviceReason: null,
          createNewOrderProcessing: false,
        });
        if (this.state.openDialogCreateNewOrder) {
          this.toggleOrderModal();
        }
      })
      .catch((err) => {
        this.setState({ createNewOrderProcessing: false });
        console.log(err);
      });
  }

  updateOrder(order, noStatusChange, noteToAdd) {
    const { currentUser } = this.context;
    order.lastUpdatedById = currentUser.id;
    if (!noStatusChange) {
      if (this.state.radio.preAuthAction === "approveWithoutAuth") {
        OrderService.createPreAuth(order.id)
          .then((res) => {
            this.setState({
              radio: {
                preAuthAction: "",
                serviceTicketAction: "",
                pickupTicketAction: { label: "", value: "" },
              },
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }

    return OrderService.updateOrder(order)
      .then((res) => {
        if (res.id == -1) {
          toast.error("Patient gender must be set before saving.");
        } else {
          if (noteToAdd) {
            this.addNewNote(res.id, noteToAdd);
          }
          let shouldOpenOrderId = this.state.createPickupFromRoute
            ? null
            : order.id;
          this.retrievePatientEquipment(this.state.id);
          this.toggleTicketDetailsModal();
          this.setState({
            shouldOpenOrderId: shouldOpenOrderId,
            radio: {
              pickupTicketAction: { label: "", value: "" },
              serviceTicketAction: "",
              choosePartsAction: "",
              needsDiagnosisAction: "",
              needsBilledAction: "",
              obtainDocAction: "",
              docFollowupAction: "",
              approvalAction: "",
              preAuthFollowUpAction: "",
              preAuthSubmission: "",
              followUpTask: "",
              billingAction: "",
              salesPPWIssue: "",
              setup: "",
              dispatchTechSubType: "",
              newAccessoryAfterSaleSubType: "",
              preAuthAction: "",
              readyToDeliverAction: "",
              rtdEquipmentOrderedAction: "",
              readyToSchedule: "",
              rtdScheduled: "",
              rtdNotAbleToDeliverAction: "",
              verification: "",
            },
            deliveryNoteModalOpen: false,
            editLocationInformationModal: false,
            editGeneralInformationModal: false,
            thirtyDayFit: false,
            paymentInformationModal: false,
            isUpdating: false,
            noteModalOpen: false,
            selectedSubTypeFromQueueRoute: null,
            dialogUpdateBrightreeExternalIdOpen: false,
          });
          if (this.state.createPickupFromRoute) {
            this.toggleCreateTicketModal(
              this.state.createPickupFromRoute,
              this.state.createPickupFromRoute.orderId,
              "Pickup",
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  createPatientPhone() {
    const regex = /((|\()\d{3}(|\))-\d{3}-\d{4})/g;
    let phones = this.state.phoneData,
      pt = this.state.ePatient,
      rows = [],
      allPhones = this.state.patientPhoneNumbers,
      newPhone = this.state.newPhoneNumber,
      valid = true;

    if (!newPhone.contactName) {
      toast.error("You must add a contact name.");
      valid = false;
    }

    if (!newPhone.phoneType) {
      toast.error("You must select a phone type.");
      valid = false;
    }

    if (!newPhone.phoneNumber) {
      toast.error("You must add a phone number.");
      valid = false;
    } else if (!regex.test(newPhone.phoneNumber)) {
      toast.error("You must add a valid phone number.");
      valid = false;
    } else if (valid) {
      phones.rows.forEach((val, idx) => {
        rows.push(val);
      });
      allPhones.push({
        contactName: newPhone.contactName,
        phoneNumber: newPhone.phoneNumber,
        phoneType: newPhone.phoneType,
        patientId: pt.id,
        id: null,
      });
      let nPhone = {
        contactName: newPhone.contactName,
        phoneNumber: newPhone.phoneNumber,
        phoneType: newPhone.phoneType,
        patientId: pt.id,
        id: null,
        delete: null,
      };
      nPhone.delete = this.renderDeletePhoneButton(nPhone);
      rows.push(nPhone);
      phones.rows = rows;
      var p = this.state.newPhoneNumber;
      p.phoneNumber = null;
      p.contactName = null;
      p.phoneType = null;
      this.setState({
        newPhoneNumber: p,
        phoneData: phones,
        patientPhoneNumbers: allPhones,
        addPhoneModalOpen: false,
      });
    }
  }

  createServiceOrderReasonRecord(issue, newOrder) {
    ServiceOrderReasonService.createServiceOrderReason(issue)
      .then((res) => {
        this.setState({
          selectedPreviousOrder: {},
        });
        if (newOrder) {
          this.toggleNewOrdersModal(newOrder);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  syncPatientToBT(brightreeId) {
    const syncingSnackbar = NotistackEnqueueSnackbar(
      "Syncing Patient to Brightree...",
      { variant: "info", persist: true },
    );
    PatientOrders.syncPatientToBT(this.state.id)
      .then((res) => {
        if (res.syncPatient) {
          NotistackCloseSnackbar(syncingSnackbar);
          NotistackEnqueueSnackbar("Patient has been created in Brightree.", {
            variant: "success",
          });
          window.location.reload();
        } else if (res === true) {
          NotistackCloseSnackbar(syncingSnackbar);
          NotistackEnqueueSnackbar("Patient has been updated in Brightree.", {
            variant: "success",
          });
          window.location.reload();
        } else {
          NotistackCloseSnackbar(syncingSnackbar);
          NotistackEnqueueSnackbar(
            !brightreeId
              ? "There was an issue creating patient in Brightree."
              : "There was an issue updating patient in Brightree.",
            { variant: "error" },
          );
        }
      })
      .catch((err) => {
        console.log(err);
        NotistackCloseSnackbar(syncingSnackbar);
        NotistackEnqueueSnackbar("Sync failed!", { variant: "error" });
      });
  }

  renderLoadingSpinner() {
    return (
      <Container>
        <div style={{ textAlign: "center", verticalAlign: "center" }}>
          <Spinner multicolor />
        </div>
      </Container>
    );
  }

  renderOrdersCard() {
    if (this.state.TabsOneActiveItem !== "1") {
      return;
    }

    return <div className="patientViewTable">{this.renderTable()}</div>;
  }

  renderComplaintNotes(id) {
    let notes = this.state.complaintNotes["notes" + id];

    if (notes) {
      notes = notes.sort((a, b) => {
        return a.noteAddedOn < b.noteAddedOn ? -1 : 1;
      });

      return notes
        .map((n, idx) => {
          return (
            <tr key={idx}>
              <td>
                {n.noteAddedOn
                  ? new Date(n.noteAddedOn).toLocaleDateString()
                  : ""}
              </td>

              <td>{n.noteAddedBy}</td>

              <td>{n.noteText}</td>
            </tr>
          );
        })
        .reverse();
    }
  }

  getNextFollowUpDate() {
    let t = new moment();
    let y = t.weekday();
    if (y < 4) {
      t.add(2, "days");
    } else {
      t.add(4, "days");
    }

    return t;
  }

  handleSearch(e) {
    let st = this.state,
      search = st.searchQ,
      csUsers = st.csUsers;

    this.setState({
      searchQ: e.target.value,
    });

    let filter = csUsers.filter((f) =>
      f.name.toLowerCase().includes(search.toLowerCase()),
    );

    if (e.target.value !== "") {
      this.setState({
        filteredCSUsers: filter,
      });
    } else {
      this.setState({
        filteredCSUsers: csUsers,
      });
    }
  }

  handleSearchChange(e) {
    let st = this.state,
      opts = st.options,
      search = st.searchText;

    this.setState({
      searchText: e.target.value,
    });

    let filter = opts.filter((f) =>
      f.name.toLowerCase().includes(search.toLowerCase()),
    );

    if (e.target.value !== "") {
      this.setState({
        filteredOpts: filter,
      });
    } else {
      this.setState({
        filteredOpts: opts,
      });
    }
  }

  toggleFeedbackCollapse = (feedbackCollapseID) => () =>
    this.setState((prevState) => ({
      feedbackCollapseID:
        prevState.feedbackCollapseID !== feedbackCollapseID
          ? feedbackCollapseID
          : "",
    }));

  renderPatientComplaintsCard() {
    const { complaintCategories, currentUser, complaintReasons } = this.context;

    let com = this.state.complaints,
      obj = {},
      op = this.state.options;

    let complaintsOnOrder = this.state.complaints.filter(
      (c) => c.orderId === this.state.curOrderId,
    );

    let updateComplaint = (val, item, prop) => {
      item[prop] = val;
      if (prop === "issueCategory") {
        prop = "category";
        item.issueCategoryId = val.id;
        this.setState({ complaints: com });
      }
      if (prop === "issueReason") {
        prop = "reason";
        item.issueReasonId = val.id;
        this.setState({ complaints: com });
      }
      if (prop === "assignedToId") {
        prop = "assigned user";
        item.assignedToId = val.id;
        this.setState({
          complaints: com,
        });
      }
      if (prop === "complimentedUserId") {
        prop = "complimented user";
        item.complimentedUserId = val.id;
        this.setState({ complaints: com });
      }

      if (prop === "nextFollowupDate") {
        prop = "follow up date";
        val.set("hour", 12);
        val.set("minute", 0);
        item.nextFollowupDate = GlobalFunctions.getUTCMoment(val);
      }

      return ComplaintService.updatePatientIssue(item)
        .then((res) => {
          let complaints = com.slice(),
            comIndex = complaints.findIndex((c) => c.id === item.id),
            notes = this.state.complaintNotes;

          complaints[comIndex] = res;
          let info = val.name ? val.name : GlobalFunctions.formatDate(val);
          obj.noteText = "Feedback " + prop + " changed to " + info;
          obj.patientIssueId = res.id;
          // obj.noteAddedOn = new Date();
          obj.noteAddedBy = currentUser.username;

          this.setState({
            complaints: complaints,
          });
          ComplaintService.createPatientIssueNote(obj)
            .then((res) => {
              if (
                notes["notes" + item.id] === null ||
                notes["notes" + item.id] === undefined
              ) {
                notes["notes" + item.id] = [];
              }

              notes["notes" + item.id].push(res);

              this.setState({
                complaints: complaints,
                complaintNotes: notes,
              });

              if (prop === "issueCategory") {
                let d = document
                  .getElementsByClassName("issueReasonDropdown")
                  .item(0);
                let a = d.getElementsByTagName("a").item(0);
                a.click();
              }
              toast.success("Complaint Updated");
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((e) => {
          toast.error(e);
        });
    };
    return (
      <>
        <MDBRow>
          <MUITooltip
            title={"Please use the new experience for feedback."}
            placement="top"
          >
            <span
              style={{ width: "100%", marginTop: "1rem", marginBottom: "1rem" }}
            >
              <MDBBtn size="large" className="addNoteBtnFull" disabled={true}>
                Add Feedback
              </MDBBtn>
            </span>
          </MUITooltip>
        </MDBRow>
        {complaintsOnOrder.map((c, idx) => {
          return (
            <MDBCard
              className="patientFeedbackCard"
              key={idx}
              style={
                this.state.feedbackCollapseID === "collapse" + idx.toString()
                  ? { border: "2px solid #316BCF", borderRadius: "5px" }
                  : { border: "none" }
              }
            >
              <MDBCollapse
                id={"collapse" + idx.toString()}
                isOpen={this.state.feedbackCollapseID}
              >
                <CardHeader className="patientFeedbackCardHeader">
                  <Row style={{ paddingBottom: "5px" }}>
                    <Col size="6" className="feedbackHeaderInfo">
                      Feedback ID: {c.id}
                    </Col>
                    <Col
                      size="6"
                      style={{ textAlign: "right" }}
                      className="feedbackHeaderInfo"
                    >
                      #{c.orderId}
                    </Col>
                  </Row>
                  <MUITooltip
                    title={"Please use the new experience for feedback."}
                    placement="top"
                  >
                    <span style={{ display: "block", width: "100%" }}>
                      <div
                        className="feedbackFormWrapper"
                        style={{ pointerEvents: "none", opacity: 0.8 }}
                      >
                        <Row>
                          <Dropdown className={"feedBackDropDown"}>
                            <DropdownToggle
                              disabled={true}
                              className={"feedBackDropDownToggle"}
                              nav
                            >
                              <span>
                                {" "}
                                {c.issueCategory
                                  ? c.issueCategory.name
                                  : ""}{" "}
                                &nbsp;
                                <Fa icon={"angle-down"} />
                              </span>
                            </DropdownToggle>
                            <DropdownMenu basic style={{ width: "100%" }}>
                              <DropdownItem disabled>
                                Select Feedback Type
                              </DropdownItem>
                              <DropdownItem divider />
                              {complaintCategories.map((type, index) => {
                                return (
                                  <DropdownItem
                                    disabled={true}
                                    key={index}
                                    onClick={undefined}
                                  >
                                    {type.name}
                                  </DropdownItem>
                                );
                              })}
                            </DropdownMenu>
                          </Dropdown>
                        </Row>
                        {c.issueCategory.name === "Compliment" ? (
                          <div>
                            <Row>
                              <Dropdown className={"feedBackDropDown"}>
                                <DropdownToggle
                                  disabled={true}
                                  className={"feedBackDropDownToggle"}
                                  nav
                                >
                                  <span>
                                    {" "}
                                    {c.complimentedUserId
                                      ? op
                                          .filter(
                                            (f) =>
                                              f.id === c.complimentedUserId,
                                          )
                                          .map((m) => m.name)
                                      : "Assign Compliment"}{" "}
                                    &nbsp;
                                    <Fa icon={"angle-down"} />
                                  </span>
                                </DropdownToggle>
                                <DropdownMenu
                                  id="userDropdownMenu"
                                  basic
                                  style={{ width: "100%" }}
                                >
                                  <DropdownItem disabled>
                                    Select User
                                  </DropdownItem>
                                  <DropdownItem divider />
                                  {this.state.filteredOpts.map((u, index) => {
                                    return (
                                      <DropdownItem
                                        disabled={true}
                                        key={index}
                                        onClick={undefined}
                                      >
                                        {u.name}
                                      </DropdownItem>
                                    );
                                  })}
                                </DropdownMenu>
                              </Dropdown>
                            </Row>
                          </div>
                        ) : null}
                        <Row>
                          <Dropdown className={"feedBackDropDown"}>
                            <DropdownToggle
                              disabled={true}
                              className={"feedBackDropDownToggle"}
                              nav
                            >
                              <span>
                                {" "}
                                {c.issueReason
                                  ? c.issueReason.name
                                  : "Select Reason"}{" "}
                                &nbsp;
                                <Fa icon={"angle-down"} />
                              </span>
                            </DropdownToggle>
                            <DropdownMenu basic style={{ width: "100%" }}>
                              <DropdownItem disabled>
                                Select Feedback Reason
                              </DropdownItem>
                              <DropdownItem divider />
                              {complaintReasons
                                .filter((res) => {
                                  return (
                                    res.issueCategory.id === c.issueCategory.id
                                  );
                                })
                                .map((type, index) => {
                                  return (
                                    <DropdownItem
                                      disabled={true}
                                      key={index}
                                      onClick={undefined}
                                    >
                                      {type.name}
                                    </DropdownItem>
                                  );
                                })}
                            </DropdownMenu>
                          </Dropdown>
                        </Row>
                        <Row>
                          <Col size="6">
                            <Row
                              style={{ cursor: "pointer", marginTop: ".2rem" }}
                            >
                              <MUIDatePicker
                                disabled={true}
                                label="Follow Up Date"
                                value={
                                  c.nextFollowupDate
                                    ? moment(c.nextFollowupDate)
                                    : null
                                }
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    variant: "outlined",
                                    InputLabelProps: {
                                      shrink: true,
                                    },
                                    InputProps: {
                                      sx: {
                                        backgroundColor: "#fff",
                                        height: "40px", // Match the height of the Quick Filter Select
                                      },
                                    },
                                  },
                                }}
                                onChange={undefined}
                                views={["year", "month", "day"]}
                              />
                            </Row>
                          </Col>
                          <Col size="6">
                            <Dropdown className={"feedBackDropDown"}>
                              <DropdownToggle
                                disabled={true}
                                className={"feedBackDropDownToggle"}
                                nav
                              >
                                <span>
                                  {" "}
                                  {c.assignedToId
                                    ? this.context.usersIndexed[c.assignedToId]
                                      ? this.context.usersIndexed[
                                          c.assignedToId
                                        ].firstname +
                                        " " +
                                        this.context.usersIndexed[
                                          c.assignedToId
                                        ].lastname
                                      : ""
                                    : "Assign To"}{" "}
                                  &nbsp;
                                  <Fa icon={"angle-down"} />
                                </span>
                              </DropdownToggle>
                              <DropdownMenu basic style={{ width: "100%" }}>
                                {/* <Input className="form-control" placeholder="Search..." onChange={this.handleSearch.bind(this)} value={this.state.searchQ} /> */}
                                <DropdownItem disabled>
                                  Select User
                                </DropdownItem>
                                <DropdownItem divider />
                                {(c.issueCategoryId === 1
                                  ? this.state.filteredComplianceUsers
                                  : this.state.filteredCSUsers
                                ).map((u, index) => (
                                  <DropdownItem
                                    key={index}
                                    disabled={true}
                                    onClick={undefined}
                                  >
                                    {u.name}
                                  </DropdownItem>
                                ))}
                              </DropdownMenu>
                            </Dropdown>
                          </Col>
                        </Row>
                      </div>
                    </span>
                  </MUITooltip>
                </CardHeader>
              </MDBCollapse>
              <CardBody
                className="feedbackCardBody"
                onClick={this.toggleFeedbackCollapse(`collapse${idx}`)}
              >
                <Row className="feedbackCardRow">
                  <Col size="6" className={"noteHeaderDateAndNameText"}>
                    <Row size="12">
                      <div>
                        {new Date(c.issueLoggedOn).toLocaleDateString()}
                      </div>
                    </Row>
                    <Row size="12">
                      <div>
                        {c.issueLoggedBy.firstname +
                          " " +
                          c.issueLoggedBy.lastname}
                      </div>
                    </Row>
                  </Col>
                  <Col
                    size="6"
                    className={"noteHeaderDateText feedbackHeaderText"}
                  >
                    {`${c.issueCategory.name} - ${c.issueReason.name}`}
                  </Col>
                </Row>
                <Row>
                  <Col size="12" className="feedbackNoteDescriptionText">
                    {c.complaintDescription}
                  </Col>
                </Row>
                <Row>
                  <hr></hr>
                </Row>
                <MDBCollapse
                  id={"collapse" + idx.toString()}
                  isOpen={this.state.feedbackCollapseID}
                >
                  <Row>
                    <Col sixe="12">
                      <table
                        className={"complaintNotesTable"}
                        style={{ width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <th style={{ width: "12%" }}>Date</th>

                            <th style={{ width: "12%" }}>Added By</th>

                            <th>Text</th>
                          </tr>
                          {this.renderComplaintNotes(c.id)}
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  {c.issueStatus === 1 ? (
                    <Row className="feedbackCardClosedRow">
                      <Col className="feedbackCardClosedCol" size="6">
                        Closed On:{" "}
                        {c.issueClosedOn
                          ? new Date(c.issueClosedOn).toLocaleDateString()
                          : "Not Closed"}
                      </Col>
                      <Col className="feedbackCardClosedCol" size="6">
                        Closed By:{" "}
                        {c.issueClosedBy
                          ? c.issueClosedBy.firstname +
                            " " +
                            c.issueClosedBy.lastname
                          : "Not Closed"}
                      </Col>
                    </Row>
                  ) : (
                    <Row className="feedbackFooterButtonRow">
                      <Col size="8">
                        <Button
                          className={"footerButtonCol"}
                          size="md"
                          disabled={true}
                          data-tip={"Set Follow Up Date & Note"}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                            updateComplaint(
                              this.getNextFollowUpDate(),
                              c,
                              "nextFollowupDate",
                            );
                            this.setState({
                              currentComplaint: c,
                              complaintNoteModal: true,
                            });
                          }}
                        >
                          {" Set Follow Up Date "}
                        </Button>
                      </Col>
                      <Col size="1" style={{ marginRight: "1rem" }}>
                        <Button
                          color={"secondary"}
                          floating
                          size="sm"
                          disabled={true}
                          data-tip={"Add Feedback Note"}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                            this.setState({
                              currentComplaint: c,
                              complaintNoteModal: true,
                            });
                          }}
                        >
                          <Fa size="2x" icon={"plus"}>
                            {" "}
                          </Fa>
                        </Button>
                      </Col>
                      <Col size="1">
                        <Button
                          disabled={true}
                          color={"red"}
                          floating
                          size="sm"
                          data-tip={"Close Feedback"}
                          onClick={(e) => {
                            e.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                            this.setState({
                              closeComplaintModal: true,
                              currentComplaint: c,
                            });
                          }}
                        >
                          <Fa size="2x" icon={"check-square"}>
                            {" "}
                          </Fa>
                        </Button>
                      </Col>
                      <ReactTooltip />
                    </Row>
                  )}
                </MDBCollapse>
              </CardBody>
            </MDBCard>
          );
        })}
      </>
    );
  }

  clientCSV() {
    let d = this.state.complaints,
      dn = this.state.complaintNotes;

    let outsideHeaders = [
      "id",
      "orderId",
      "patientId",
      "issueStatus",
      "complaintDescription",
      "issueCategory",
      "issueReason",
      "issueLoggedBy",
      "issueLoggedOn",
      "issueClosedBy",
      "issueClosedOn",
    ];

    let legibleOutsideHeaders = [
      "Feedback ID",
      "Order ID",
      "Patient ID",
      "Issue Status",
      "Complaint Description",
      "Issue Category",
      "Issue Reason",
      "Issue Logged By",
      "Issue Logged On",
      "Issue Closed By",
      "Issue Closed On",
    ];

    let insideHeaders = ["id", "noteAddedBy", "noteAddedOn", "noteText"];

    let legibleInsideHeaders = [
      "Note ID",
      "Note Added By",
      "Note Added On",
      "Note Text",
    ];

    let result = "",
      columnDelimiter = ",",
      lineDelimiter = "\n";

    d.forEach(function (item) {
      result += legibleOutsideHeaders.join(columnDelimiter);
      result += lineDelimiter;

      outsideHeaders.forEach((property) => {
        switch (property) {
          case "complaintDescription":
            let n = item[property].replace(/\n/g, " ");
            n = n.replace(/,/g, " ");
            result += n;
            result += columnDelimiter;
            break;
          case "issueLoggedBy":
          case "issueClosedBy":
          case "issueCategory":
          case "issueReason":
            let v = item[property] ? item[property].name : " ";
            result += v;
            result += columnDelimiter;
            break;
          case "issueLoggedOn":
            let y = item[property]
              ? new Date(item[property]).toLocaleDateString()
              : "";
            result += y;
            result += columnDelimiter;
            break;
          case "issueClosedOn":
            let x = item[property]
              ? new Date(item[property]).toLocaleDateString()
              : "";
            result += x;
            result += columnDelimiter;

            //double line delimiter for ease of reading
            result += lineDelimiter;
            result += lineDelimiter;
            break;
          case "issueStatus":
            let z = item[property] === 0 ? "Open" : "Closed";
            result += z;
            result += columnDelimiter;
            break;
          default:
            result += item[property];
            result += columnDelimiter;
            break;
        }
      });
      let nProp = "notes" + item.id;
      let nAry = dn[nProp];

      if (nAry) {
        result += legibleInsideHeaders.join(columnDelimiter);
        result += lineDelimiter;

        nAry.forEach((note) => {
          insideHeaders.forEach((iProp) => {
            switch (iProp) {
              case "id":
              case "noteAddedBy":
                result += note[iProp];
                result += columnDelimiter;
                break;
              case "noteAddedOn":
                let u = note[iProp]
                  ? new Date(note[iProp]).toLocaleDateString()
                  : "";
                result += u;
                result += columnDelimiter;
                break;
              case "noteText":
                let p = note[iProp].replace(/\n/g, " ");
                p = p.replace(/,/g, " ");
                result += p;
                break;
              default:
                break;
            }
          });
          //add a new line after each note
          result += lineDelimiter;
        });
      }
      //add a new line after all the notes are done
      result += lineDelimiter;
      result += lineDelimiter;
    });

    this.downloadBlob(result, "patientFeedback.csv");
  }

  //csv downlaod data here
  downloadBlob(csvData, filename) {
    let blob = new Blob([csvData], {
      type: "application/csv;charset=utf-8;",
    });

    if (window.navigator.msSaveBlob) {
      // FOR IE BROWSER
      navigator.msSaveBlob(blob, filename);
    } else {
      // FOR OTHER BROWSERS
      let link = document.createElement("a"),
        csvUrl = URL.createObjectURL(blob);

      link.href = csvUrl;
      link.style = "visibility:hidden";
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  renderRightCardTabs() {
    return (
      <div>
        <MDBNav className="nav-justified  pills-purple-gradient sideNavWrapper">
          <MDBNavItem>
            <MDBNavLink
              style={{ fontSize: ".8rem" }}
              link
              to="#"
              active={this.state.items.rightMenu === "1"}
              onClick={this.togglePills("rightMenu", "1")}
            >
              NOTES
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink
              style={{ fontSize: ".8rem" }}
              link
              to="#"
              active={this.state.items.rightMenu === "2"}
              onClick={this.togglePills("rightMenu", "2")}
            >
              ATTACHMENTS
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink
              style={{ fontSize: ".8rem" }}
              link
              to="#"
              active={this.state.items.rightMenu === "3"}
              onClick={this.togglePills("rightMenu", "3")}
            >
              FEEDBACK
            </MDBNavLink>
          </MDBNavItem>
        </MDBNav>
        <MDBModalBody style={{ paddingTop: "0" }}>
          <MDBTabContent
            activeItem={this.state.items.rightMenu}
            className={"rightCardTabContent"}
          >
            <MDBTabPane tabId="1">{this.renderOrderDetailsNotes()}</MDBTabPane>
            <MDBTabPane tabId={"2"}>{this.renderAttachments()}</MDBTabPane>
            <MDBTabPane tabId={"3"}>
              {this.renderPatientComplaintsCard()}
            </MDBTabPane>
          </MDBTabContent>
        </MDBModalBody>
      </div>
    );
  }

  renderRightCard() {
    const isEditingPatientInfo =
      this.state.canEditBasicInfo ||
      this.state.canEditInsuranceInfo ||
      this.state.canEditClinicalInfo;
    const showOrderRightSidebar =
      this.state.TabsOneActiveItem === "4" ||
      (isEditingPatientInfo && !!this.state.curOrderId);

    return (
      <div className={"patientInformationCol"}>
        {showOrderRightSidebar
          ? this.renderRightCardTabs()
          : this.renderPatientOrOrderNotesCard()}
      </div>
    );
  }

  renderPatientOrOrderNotesCard() {
    let stateNotes = this.state.notes;

    if (stateNotes.filter((s) => s.type).length > 0) {
      stateNotes.shift();
    }

    if (this.state.TabsOneActiveItem === "4") {
      if (
        !this.state.orderNotesLoading &&
        !this.state.orderNotesLoaded &&
        this.state.curOrderId
      ) {
        this.retrieveNotes();
      }
      if (!this.state.orderNotesLoaded) {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MDBSpinner></MDBSpinner>
          </div>
        );
      }
      stateNotes = this.state.orderNotes;
    }

    return (
      <div>
        {stateNotes.map((note, idx) => {
          return (
            <div key={idx} style={{ paddingBottom: 6 }}>
              <MDBCard className={"patientPageNoteCard"}>
                <MDBCardHeader
                  style={{ backgroundColor: "#5881C1" }}
                  className={"orderNoteHeaderPatientPage"}
                >
                  <MDBRow>
                    <MDBCol size={"6"} className={"noteHeaderDateText"}>
                      {GlobalFunctions.formatDateTime(
                        note.noteAddedOn ? note.noteAddedOn : "",
                      )}
                    </MDBCol>

                    <MDBCol size={"6"} className={"noteHeaderNameText"}>
                      {"Added by: " +
                        (note.noteAddedBy ? note.noteAddedBy : "")}
                    </MDBCol>
                  </MDBRow>
                </MDBCardHeader>
                <MDBCardBody className={"orderNotesCardBodyPatientPage"}>
                  <p style={{ whiteSpace: "pre-line" }}>{note.note}</p>
                </MDBCardBody>
              </MDBCard>
            </div>
          );
        })}
      </div>
    );
  }

  renderTip(note) {
    return note.length > 150
      ? note.substr(0, 150).concat("... (Click to view more)")
      : note;
  }

  patientNoteClicked = (note) => {
    this.setState({
      currOpenNote: note,
    });
    this.togglePatientNoteModal();
  };

  togglePatientNoteModal = () => {
    this.setState({
      ptnNoteModal: !this.state.ptnNoteModal,
    });
  };

  renderPtnNoteModal() {
    if (!this.state.ptnNoteModal) {
      return;
    }
    let n = this.state.currOpenNote;
    return (
      <Modal
        isOpen={this.state.ptnNoteModal}
        toggle={this.togglePatientNoteModal}
      >
        <ModalBody>
          <div>
            <p>
              <b>Date: </b>
              {new Date(n.noteAddedOn).toLocaleDateString()}
            </p>
            <p>
              <b>Added By: </b>
              {n.noteAddedBy}
            </p>
            <p style={{ whiteSpace: "pre-line" }}>
              <b>Note: </b>
              {n.note || ""}
            </p>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  renderDeletePhoneButton(phone) {
    return (
      <Button
        color={"red"}
        floating
        size="sm"
        data-tip={"Delete Phone Number"}
        onClick={() => {
          if (
            window.confirm(
              "This will delete the phone number for this patient. Are you sure you wish to delete this entry?",
            )
          ) {
            if (phone.id) {
              patientPhoneService
                .deletePatientPhone(phone.id)
                .then((res) => {
                  this.getPatientPhones(this.state.id);
                })
                .catch((err) => {
                  console.log(err);
                });
              // this.getPatientPhones(this.state.id);
            } else {
              let data = this.state.phoneData,
                res = [];

              res = data.rows.filter((x) => {
                return (
                  x.contactName !== phone.contactName &&
                  x.phoneNumber !== phone.phoneNumber &&
                  x.id === null
                );
              });

              data.rows = res;
              this.setState({ phoneData: data });
            }
          }
        }}
      >
        <Fa size="1x" icon={"minus"}>
          {" "}
        </Fa>
      </Button>
    );
  }

  toggleCollapse = (collapseID) => () =>
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));

  renderSideTable() {
    let highlight = this.state.highlightedRow.id
      ? this.state.highlightedRow.id
      : this.state.highlightedRow.orderId;
    let style = {
      cursor: "pointer",
    };
    let highlightStyle = {
      backgroundColor: "#d4e6f7",
      cursor: "pointer",
    };
    const TableRow = ({ row, ...restProps }) => (
      <Table.Row
        {...restProps}
        onClick={() => {
          if (
            this.state.canEditBasicInfo ||
            this.state.canEditInsuranceInfo ||
            this.state.canEditClinicalInfo
          ) {
            this.setState({
              patientInfoRetrieved: false,
              canEditBasicInfo: false,
              canEditInsuranceInfo: false,
              canEditClinicalInfo: false,
            });
            return OrderService.getPatientById(this.state.id).then((data) => {
              this.setState({
                patientAge: moment(
                  data.deceased && data.dateOfDeath
                    ? data.dateOfDeath
                    : undefined,
                ).diff(data.dateOfBirth, "years", false),
                patient: data,
                ePatient: JSON.parse(JSON.stringify(data)),
                TabsOneActiveItem: "1",
                canEditBasicInfo: false,
                patientInfoRetrieved: true,
              });
              this.highlightOrderRow(row.id);
            });
          }
          this.highlightOrderRow(row.id);
        }}
        style={row.id === highlight ? highlightStyle : style}
      />
    );

    if (this.state.isLoaded === true) {
      return (
        <MUIThemeProvider theme={fixedLightMaterialUITheme}>
          <Grid
            href={"TEST"}
            className="sideCardOrderTableRow"
            style={{ maxWidth: "1800px !important" }}
            rows={this.state.sideCardGridData.rows}
            columns={this.state.sideCardGridData.columns}
            spacing={0}
          >
            <Table rowComponent={TableRow} />
          </Grid>
        </MUIThemeProvider>
      );
    } else {
      return <div />;
    }
  }

  setExpandedRowIds = (expandedRowIds) => {
    let value = expandedRowIds.length > 0 ? [expandedRowIds.pop()] : [];
    this.setState({ expandedRowIds: value });
  };

  checkForDefaultExpandedRow(rows) {
    if (this.state.firstLoad) {
      let val = rows.findIndex((x) => x.tickets.length > 0);
      if (val > -1) {
        this.setExpandedRowIds([val]);
        this.setState({ firstLoad: false });
        return [val];
      } else {
        this.setState({ firstLoad: false });
        return this.state.expandedRowIds;
      }
    } else {
      return this.state.expandedRowIds;
    }
  }

  renderStatusChip(row) {
    let r = row;
    if (r.status.toLowerCase() === "in process") {
      var chipColor = "#FFF5DE";
      var chipBorderColor = "#FBC02D51";
      var chipFontColor = "#75570D";
    } else if (r.status.toLowerCase() === "cancelled") {
      chipColor = "#FFE9E9";
      chipBorderColor = "#F9315432";
      chipFontColor = "#881A2D";
    } else if (r.status.toLowerCase() === "ready to deliver") {
      chipColor = "#E5F9E4";
      chipBorderColor = "#52B48F32";
      chipFontColor = "#195D17";
    } else if (r.status.toLowerCase() === "setup") {
      chipColor = "#F2f2f2";
      chipBorderColor = "#8D8D8D32";
      chipFontColor = "#5a5a5a";
    } else if (r.status.toLowerCase() === "new") {
      chipColor = "#E3EBFA";
      chipBorderColor = "#316BCF32";
      chipFontColor = "#316BCF";
    } else {
      chipColor = "#FFF";
      chipBorderColor = "#00032";
      chipFontColor = "#000";
    }
    return (
      <>
        <MDBCol className="statusChipPatientTable">
          {r.status.toLowerCase() === "setup" ? (
            <div
              className={"chipRow orderStatusReasonChip"}
              style={{
                backgroundColor: chipColor,
                color: chipFontColor,
                border: `1px solid ${chipBorderColor}`,
                cursor: "pointer",
              }}
            >
              {r.reason && r.reason !== null ? (
                <>
                  <p className="ticketStatusChipRow">
                    Delivered
                    {r.setupDate && r.setupDate !== null
                      ? ": " +
                        globalFunctions.format(r.setupDate, {
                          month: "2-digit",
                          day: "2-digit",
                          year: "2-digit",
                        })
                      : ""}
                  </p>
                  <br />
                  <p className="ticketReasonChipRow">{r.reason || ""}</p>
                </>
              ) : (
                <>
                  <p className="ticketStatusChipRow">
                    Delivered
                    {r.setupDate && r.setupDate !== null
                      ? ": " +
                        globalFunctions.format(r.setupDate, {
                          month: "2-digit",
                          day: "2-digit",
                          year: "2-digit",
                        })
                      : ""}
                  </p>
                </>
              )}
            </div>
          ) : (
            <div
              style={{
                cursor: "pointer",
                color: chipFontColor,
                backgroundColor: chipColor,
                border: `1px solid ${chipBorderColor}`,
              }}
              className={"chipRow orderStatusReasonChip"}
            >
              {r.reason && r.reason !== null ? (
                <>
                  <p className="ticketStatusChipRow">{r.status}</p>
                  <br />
                  <p className="ticketReasonChipRow">{r.reason || ""}</p>
                </>
              ) : (
                <p className="ticketStatusChipRow">{r.status}</p>
              )}
            </div>
          )}
        </MDBCol>
        <ReactTooltip />
      </>
    );
  }

  createTicketRowData(parentData, tickets) {
    let data = [];
    tickets.forEach((d) => {
      data.push({
        padding: null,
        blank: this.renderTicketStatusLabel(d),
        orderIdLink: d.id,
        orderId: d.id,
        id: d.id,
        statusChip: this.renderTicketStatusChip(d),
        category: d.category || "No Parts Added",
        points: null,
        setupDate:
          d.setupDate && d.setupDate !== null
            ? globalFunctions.format(d.setupDate, {
                month: "2-digit",
                day: "2-digit",
                year: "2-digit",
              })
            : null,
        lastNoteDate:
          d && d.lastNoteDate && d.lastNoteDate !== null
            ? moment(d.lastNoteDate).format("MM/DD/YY")
            : null,
        feedback: this.renderFeedbackChip(d, "ticket"),
        tickets: null,
        status: d.status,
        reason: d.reason,
        serial: d.serial,
        currentModel: parentData.product,
        serialNumber: parentData.serial,
        parentOrder: d.parentOrder,
        serviceReason: d.serviceReason,
        orderType: d.orderType,
        isApproved: d.isApproved,
        orderStatusReasonId: d.orderStatusReasonId,
        routingInformation: null,
      });
    });
    return data;
  }
  renderTicketStatusLabel(r) {
    return (
      <MDBCol>
        <MDBRow>
          <td className="serviceTicketLabel">{r.orderType}</td>
        </MDBRow>
        <MDBRow>
          <td className="serviceReasonLabel">{r.serviceReason}</td>
        </MDBRow>
      </MDBCol>
    );
  }
  renderTicketStatusChip(r) {
    if (r.status.toLowerCase() === "in process") {
      var chipColor = "#FFF5DE";
      var chipBorderColor = "#FBC02D51";
      var chipFontColor = "#75570D";
    } else if (r.status.toLowerCase() === "cancelled") {
      chipColor = "#FFE9E9";
      chipBorderColor = "#F9315432";
      chipFontColor = "#881A2D";
    } else if (r.status.toLowerCase() === "ready to deliver") {
      chipColor = "#E5F9E4";
      chipBorderColor = "#52B48F32";
      chipFontColor = "#195D17";
    } else if (r.status.toLowerCase() === "setup") {
      chipColor = "#F2f2f2";
      chipBorderColor = "#8D8D8D32";
      chipFontColor = "#5a5a5a";
    } else if (r.status.toLowerCase() === "new") {
      chipColor = "#E3EBFA";
      chipBorderColor = "#316BCF32";
      chipFontColor = "#316BCF";
    } else {
      chipColor = "#FFF";
      chipBorderColor = "#00032";
      chipFontColor = "#000";
    }
    return (
      <div className="ticketStatusChip">
        {r.status.toLowerCase() === "setup" ? (
          <div
            className={"chipRow ticketStatusReasonChip"}
            style={{
              backgroundColor: chipColor,
              color: chipFontColor,
              border: `1px solid ${chipBorderColor}`,
              cursor: "pointer",
            }}
          >
            {r.reason && r.reason !== null ? (
              <>
                <p className="ticketStatusChipRow">
                  Delivered
                  {r.setupDate && r.setupDate !== null
                    ? ": " +
                      globalFunctions.format(r.setupDate, {
                        month: "2-digit",
                        day: "2-digit",
                        year: "2-digit",
                      })
                    : ""}
                </p>
                <br />
                <p className="ticketReasonChipRow">{r.reason || ""}</p>
              </>
            ) : (
              <>
                <p className="ticketStatusChipRow">
                  Delivered
                  {r.setupDate && r.setupDate !== null
                    ? ": " +
                      globalFunctions.format(r.setupDate, {
                        month: "2-digit",
                        day: "2-digit",
                        year: "2-digit",
                      })
                    : ""}
                </p>
              </>
            )}
          </div>
        ) : (
          <div
            className="chipRow ticketStatusReasonChip"
            style={{
              cursor: "pointer",
              color: chipFontColor,
              backgroundColor: chipColor,
              border: `1px solid ${chipBorderColor}`,
            }}
          >
            {r.reason && r.reason !== null ? (
              <>
                <p className="ticketStatusChipRow">{r.status}</p>
                <br />
                <p className="ticketReasonChipRow">{r.reason || ""}</p>
              </>
            ) : (
              <p className="ticketStatusChipRow">{r.status}</p>
            )}
          </div>
        )}
      </div>
    );
  }
  renderTable() {
    if (this.state.isLoaded === true) {
      if (!this.state.patientEquipmentLoaded) {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <MDBSpinner></MDBSpinner>
          </div>
        );
      }
      let highlight = this.state.highlightedRow.orderId
        ? this.state.highlightedRow.orderId
        : this.state.highlightedRow.id;
      let rows = this.state.gridData.rows;
      let expandedRowIds = this.checkForDefaultExpandedRow(rows);
      let expandedOrderId =
        expandedRowIds.length > 0 ? rows[expandedRowIds[0]].orderId : null;
      let style = {};
      let highlightStyle = {
        backgroundColor: "#d4e6f7",
      };
      let pageSize = 10;
      let cols = [
        {
          title: "",
          name: "padding",
        },
      ];
      cols = cols.concat(this.state.gridData.columns);

      function findPage(current) {
        let index = rows.findIndex((x) => x.orderId === highlight);
        if (index < 0) {
          rows.forEach((row, idx) => {
            let tempIndex = row.tickets.findIndex(
              (x) => x.orderId === highlight,
            );
            if (tempIndex > -1) {
              index = idx;
            }
          });
        }

        if (highlight && index > -1) {
          return Math.ceil((index + 1) / pageSize) - 1;
        }
        return current;
      }
      let widthsForTicketTable = this.getWidths();
      widthsForTicketTable = widthsForTicketTable.concat([
        { columnName: "padding", width: 48 },
      ]);

      const TableRow = ({ row, ...restProps }) => (
        <Table.Row
          {...restProps}
          onClick={(e) => {
            if (
              (row.setupDate && row.setupDate !== null) ||
              (row.orderType && row.orderType.toLowerCase() === "service") ||
              (row.category &&
                row.category.props &&
                row.category.props.children &&
                row.category.props.children[0] === "Service")
            ) {
              this.toggleTicketDetailsModal(row, row.orderId);
              if (
                (row.orderType && row.orderType.toLowerCase() === "service") ||
                (row.category.props &&
                  row.category.props.children &&
                  row.category.props.children[0] === "Service")
              ) {
                this.setState({
                  isOrderDetails: false,
                });
              } else {
                this.setState({
                  isOrderDetails: true,
                });
              }
            }
          }}
          className="gridRowOrder"
          style={
            row.orderId === highlight || expandedOrderId === row.orderId
              ? highlightStyle
              : style
          }
          id={row.orderId.toString()}
        />
      );
      const TableTicketRow = ({ row, ...restProps }) => (
        <Table.Row
          {...restProps}
          onClick={() => this.toggleTicketDetailsModal(row, row.orderId)}
          className="gridRowTicket"
          style={
            row.orderId === highlight || expandedOrderId === row.orderId
              ? highlightStyle
              : style
          }
          id={row.orderId.toString()}
        />
      );
      const RowDetail = ({ row }) => (
        <MDBRow className="serviceTicketsTableRow">
          <MUIThemeProvider theme={fixedLightMaterialUITheme}>
            <Grid
              style={{ maxWidth: "600px !important" }}
              rows={row.ticketRows}
              columns={cols}
            >
              <Table rowComponent={TableTicketRow} />
              <TableColumnResizing columnWidths={widthsForTicketTable} />
            </Grid>
          </MUIThemeProvider>
        </MDBRow>
      );

      const ToggleCell = ({ expanded, onToggle, ...restProps }) => {
        const { row } = restProps;
        return row.tickets && !row.tickets.length > 0 ? (
          <Table.Cell
            {...restProps}
            onClick={() => this.toggleTicketDetailsModal(row, row.orderId)}
            style={{
              cursor: "pointer",
            }}
          />
        ) : (
          <TableRowDetail.ToggleCell
            {...restProps}
            onToggle={onToggle}
            expanded={expanded}
          />
        );
      };

      return (
        <MUIThemeProvider theme={fixedLightMaterialUITheme}>
          <Grid
            className="orderTableRow"
            style={{ maxWidth: "600px !important" }}
            rows={this.state.gridData.rows}
            columns={this.state.gridData.columns}
          >
            <RowDetailState
              expandedRowIds={expandedRowIds}
              onExpandedRowIdsChange={this.setExpandedRowIds}
            />
            <PagingState
              defaultCurrentPage={0}
              pageSize={pageSize}
              currentPage={findPage(this.currentPage)}
            />
            <IntegratedPaging />
            <Table rowComponent={TableRow} />
            <TableColumnResizing columnWidths={this.getWidths()} />
            <TableHeaderRow />
            <TableRowDetail
              id={"test"}
              className={"serviceTicketsTableRow"}
              contentComponent={RowDetail}
              toggleCellComponent={ToggleCell}
            />

            <PagingPanel />
          </Grid>
        </MUIThemeProvider>
      );
    } else {
      return <div />;
    }
  }

  renderGender() {
    let item = this.state.ePatient,
      types = ["Male", "Female", "Other"];

    return (
      <MDBCol size="4">
        <MUITextField
          select
          size="small"
          fullWidth
          label="Gender"
          value={item.gender || ""}
          disabled={this.state.canEditBasicInfo ? false : true}
          onChange={this.handleChange.bind(this, "gender")}
          variant="outlined"
        >
          {types.map((option, idx) => {
            return (
              <MUIMenuItem key={idx} value={types[idx]}>
                {option}
              </MUIMenuItem>
            );
          })}
        </MUITextField>
      </MDBCol>
    );
  }

  renderBasicInfo() {
    let item = this.state.ePatient,
      dob = item.dateOfBirth;

    if (dob) {
      dob = moment
        .utc(new Date(item.dateOfBirth), "MM-DD-YYYY")
        .format("MMMM DD, YYYY");
    }

    const isPediatric = (dob) => {
      const age = moment().diff(dob, "years");
      return age < 18;
    };

    return (
      <Card className="patientInformationCard ">
        <label style={{ paddingTop: "10px" }} className="cardLabel">
          Basic Info
        </label>
        <div className="cardContent">
          <MDBRow style={{ marginBottom: "1rem" }} gap={0.9}>
            <MDBCol size="3.9">
              <MDBInput
                label="First Name"
                fullWidth
                size="small"
                valueDefault={item.firstName || ""}
                className={
                  this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                }
                outline
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleChange.bind(this, "firstName")}
              />
            </MDBCol>
            <MDBCol size="3.9">
              <MDBInput
                label="Last Name"
                fullWidth
                size="small"
                className={
                  this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                }
                outline
                valueDefault={item.lastName || ""}
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleChange.bind(this, "lastName")}
              />
            </MDBCol>
            <MDBCol size="4" className=" uiDateOutline">
              <MUIDatePicker
                size="small"
                disabled={this.state.canEditBasicInfo ? false : true}
                label={
                  isPediatric(item.dateOfBirth)
                    ? "DOB - Pediatric"
                    : "Date of Birth"
                }
                value={item.dateOfBirth ? moment(item.dateOfBirth) : null}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    variant: "outlined",
                    InputLabelProps: {
                      shrink: true,
                    },
                  },
                }}
                onChange={(value) =>
                  this.handleDatePickerChange("dateOfBirth", value)
                }
                views={["year", "month", "day"]}
              />
            </MDBCol>
          </MDBRow>

          <MDBRow style={{ marginBottom: "1rem" }} gap={0.9}>
            <MDBCol size="3.9">
              <MDBInput
                size="small"
                fullWidth
                type="number"
                label="Height (Inches)"
                className={
                  this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                }
                outline
                valueDefault={item.height || ""}
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleChange.bind(this, "height")}
              />
            </MDBCol>
            <MDBCol size="3.9">
              <MDBInput
                size="small"
                fullWidth
                type="number"
                label="Weight (Pounds)"
                className={
                  this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                }
                outline
                valueDefault={item.weight || ""}
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleChange.bind(this, "weight")}
              />
            </MDBCol>
            {this.renderGender()}
          </MDBRow>

          <MDBRow style={{ marginBottom: "1rem" }}>
            <MDBCol size="12">
              <div className="geocoder addressInputContainer">
                <MDBInput
                  size="small"
                  fullWidth
                  id="txtAddress"
                  label="Address"
                  className={
                    this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                  }
                  outline
                  value={item.address || ""}
                  disabled={this.state.canEditBasicInfo ? false : true}
                  //valueDefault={item.address || ""}
                  onChange={this.addressTextChanged.bind(this)}
                />
                {this.renderGoogleSearchResult()}
              </div>
            </MDBCol>
          </MDBRow>

          <MDBRow style={{ marginBottom: "1rem" }} gap={0.9}>
            <MDBCol size="3.9">
              <MDBInput
                id="txtCity"
                label="City"
                size="small"
                fullWidth
                className={
                  this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                }
                outline
                value={item.city || ""}
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleChange.bind(this, "city")}
              />
            </MDBCol>
            <MDBCol size="3.9">
              <Select
                placeholder={item.state || "Select State..."}
                options={this.getStateList()}
                onChange={this.handleChange.bind(this, "state")}
                isDisabled={this.state.canEditBasicInfo ? false : true}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </MDBCol>
            <MDBCol size="4">
              <MDBInput
                size="small"
                fullWidth
                id="txtZip"
                label="ZIP Code"
                className={
                  this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                }
                outline
                value={item.zipCode || ""}
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleChange.bind(this, "zipCode")}
              />
            </MDBCol>
          </MDBRow>
          <Row>
            <Col size={"4"} className={"insuranceSelects deceasedCheckBox"}>
              <MDBInput
                className="deceasedCheckBoxInput"
                style={{ paddingLeft: 0 }}
                label="Deceased"
                value={item.deceased || false}
                checked={item.deceased || false}
                data-tip="Priority"
                type="checkbox"
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleCheckboxChange.bind(this, "deceased")}
                filled
                id="deceasedBox"
              />
            </Col>

            <MDBCol
              size="4"
              className="smallMargin uiDateOutline"
              style={{ paddingTop: 0 }}
            >
              {item.deceased ? (
                <MUIDatePicker
                  disabled={this.state.canEditBasicInfo ? false : true}
                  label={"Date of Death"}
                  value={item.dateOfDeath ? moment(item.dateOfDeath) : null}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      variant: "outlined",
                      InputLabelProps: {
                        shrink: true,
                      },
                    },
                  }}
                  onChange={(value) =>
                    this.handleDatePickerChange("dateOfDeath", value)
                  }
                  views={["year", "month", "day"]}
                />
              ) : (
                <></>
              )}
            </MDBCol>
          </Row>
        </div>
      </Card>
    );
  }

  renderPreferredContact() {
    let item = this.state.ePatient,
      types = ["SMS", "Call", "Email"];

    return (
      <MDBCol className="smallMargin">
        <MUITextField
          select
          size="small"
          fullWidth
          disabled={this.state.canEditBasicInfo ? false : true}
          label="Preferred Contact Method"
          value={item.preferredContactMethod || ""}
          onChange={this.handleChange.bind(this, "preferredContactMethod")}
          variant="outlined"
        >
          {types.map((option, idx) => {
            return (
              <MUIMenuItem key={idx} value={types[idx]}>
                {option}
              </MUIMenuItem>
            );
          })}
        </MUITextField>
      </MDBCol>
    );
  }

  renderEmergencyRelationship() {
    let item = this.state.ePatient,
      types = [
        "Spouse/Partner",
        "Sibling",
        "Child",
        "Parent",
        "Aunt/Uncle",
        "Other",
      ];

    return (
      <MUITooltip title={this.legacyContactInfoTooltip}>
        <span style={{ display: "block" }}>
          <MUITextField
            select
            size="small"
            fullWidth
            //disabled={this.state.canEditBasicInfo ? false : true}
            disabled={true}
            className={this.state.canEditBasicInfo ? "" : "basicInfoDisabled"}
            label="Emergency Contact Relationship"
            value={item.emergencyRelationship || ""}
            onChange={this.handleChange.bind(this, "emergencyRelationship")}
            variant="outlined"
          >
            {types.map((option, idx) => {
              return (
                <MUIMenuItem key={idx} value={types[idx]}>
                  {option}
                </MUIMenuItem>
              );
            })}
          </MUITextField>
        </span>
      </MUITooltip>
    );
  }
  renderMarketingPreferedContactType() {
    let item = this.state.ePatient,
      types = this.getContactTermList();

    return (
      <div style={{ marginTop: 0 }}>
        <MUITextField
          select
          size="small"
          fullWidth
          disabled={this.state.canEditBasicInfo ? false : true}
          className={this.state.canEditBasicInfo ? "" : "basicInfoDisabled"}
          label="Preferred Contact Method"
          value={item.marketingPreferredContactMethodTermId || ""}
          onChange={this.handleChange.bind(
            this,
            "marketingPreferredContactMethodTermId",
          )}
          variant="outlined"
        >
          {types.map((option, idx) => {
            return (
              <MUIMenuItem key={option.value} value={option.value}>
                {option.label}
              </MUIMenuItem>
            );
          })}
        </MUITextField>
      </div>
    );
  }

  renderContactInfo() {
    let item = this.state.ePatient;

    const wrapDisabledContactField = (child) => (
      <MUITooltip title={this.legacyContactInfoTooltip}>
        <span style={{ display: "block" }}>{child}</span>
      </MUITooltip>
    );

    return (
      <Card
        className="patientInformationCard"
        style={{ paddingBottom: "10px", width: "100%" }}
      >
        <div className="cardContent">
          <label
            style={{ paddingTop: "10px" }}
            className="cardLabel contactLabel"
          >
            Contact Info
          </label>
          <MDBRow gap={0.9}>
            <MDBCol md={3.9}>
              {wrapDisabledContactField(
                <MDBInput
                  size="small"
                  fullWidth
                  label="Phone Number"
                  valueDefault={item.phone || ""}
                  outline
                  // disabled={this.state.canEditBasicInfo ? false : true}
                  disabled={true}
                  className={
                    this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                  }
                  onChange={this.handleChange.bind(this, "phone")}
                />,
              )}
            </MDBCol>
            <MDBCol md={3.9}>
              {wrapDisabledContactField(
                <MDBInput
                  label="Alternative Phone"
                  size="small"
                  fullWidth
                  valueDefault={item.alternativePhone || ""}
                  outline
                  // disabled={this.state.canEditBasicInfo ? false : true}
                  disabled={true}
                  className={
                    this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                  }
                  onChange={this.handleChange.bind(this, "alternativePhone")}
                />,
              )}
            </MDBCol>
            <MDBCol md={4}>
              {wrapDisabledContactField(
                <MDBInput
                  label="Email Address"
                  size="small"
                  fullWidth
                  valueDefault={item.email || ""}
                  outline
                  //disabled={this.state.canEditBasicInfo ? false : true}
                  disabled={true}
                  className={
                    this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                  }
                  onChange={this.handleChange.bind(this, "email")}
                />,
              )}
            </MDBCol>

            <MDBCol md={12}>
              <MDBInput
                style={{ paddingLeft: 0 }}
                label="Enroll in order update text messages"
                value={item.smsMessages || false}
                checked={item.smsMessages || false}
                type="checkbox"
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleCheckboxChange.bind(this, "smsMessages")}
                filled
                id="smsMessages"
              />
            </MDBCol>

            <MDBCol md={3.9}>
              {wrapDisabledContactField(
                <MDBInput
                  label="Emergency Contact"
                  size="small"
                  fullWidth
                  valueDefault={item.emergencyContact || ""}
                  outline
                  // disabled={this.state.canEditBasicInfo ? false : true}
                  disabled={true}
                  className={
                    this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                  }
                  onChange={this.handleChange.bind(this, "emergencyContact")}
                />,
              )}
            </MDBCol>
            <MDBCol md={3.9}>
              {wrapDisabledContactField(
                <MDBInput
                  label="Emergency Contact Phone Number"
                  size="small"
                  fullWidth
                  valueDefault={item.emergencyContactPhone || ""}
                  outline
                  // disabled={this.state.canEditBasicInfo ? false : true}
                  disabled={true}
                  className={
                    this.state.canEditBasicInfo ? "" : "basicInfoDisabled"
                  }
                  onChange={this.handleChange.bind(
                    this,
                    "emergencyContactPhone",
                  )}
                />,
              )}
            </MDBCol>
            <MDBCol md={4} style={{ paddingTop: 0 }}>
              {this.renderEmergencyRelationship()}
            </MDBCol>
            <MDBCol md={12} style={{ paddingTop: 0 }}>
              <hr></hr>
              <div
                style={{
                  textTransform: "uppercase",
                  fontSize: "15px",
                  fontWeight: "bold",
                  marginBottom: 16,
                }}
              >
                Marketing
              </div>
            </MDBCol>
            <MDBCol md={6} style={{ paddingTop: 0 }}>
              {this.renderMarketingPreferedContactType()}
            </MDBCol>
            <MDBCol
              md={3}
              style={{ paddingTop: 0, paddingLeft: 10 }}
              className="doNotContact"
            >
              <MDBInput
                className="marketingDoNot"
                style={{ paddingLeft: 0 }}
                label="Do not contact"
                value={item.marketingDoNotContact || false}
                checked={item.marketingDoNotContact || false}
                data-tip="Priority"
                type="checkbox"
                disabled={this.state.canEditBasicInfo ? false : true}
                onChange={this.handleCheckboxChange.bind(
                  this,
                  "marketingDoNotContact",
                )}
                filled
                id="doNotContactBox"
              />
            </MDBCol>
          </MDBRow>
        </div>
      </Card>
    );
  }

  renderClinicalInformation() {
    const dataSource = this.state.curOrder
      ? this.state.eOrder
      : this.state.ePatient;

    return (
      <Card className="patientInformationCard ">
        <label style={{ paddingTop: "10px" }} className="cardLabel">
          Clinical Information
        </label>
        <div className="cardContent">
          {this.state.clinicalInformationLoading ? (
            <Progress />
          ) : (
            <MUIGrid container spacing={2} sx={{ pt: 1.5 }}>
              {this.renderOrderingProviderSection()}
              {dataSource.orderingProviderNotFound
                ? this.renderManualOrderingProviderSection()
                : null}
              {this.renderOrderingProviderDataSection()}
              {this.renderDiagnosisCodesSection()}
              {this.renderDiseaseSection()}
            </MUIGrid>
          )}
        </div>
      </Card>
    );
  }

  handleOmniSearch = (event, endpoint, stateKey, transformFn, searchIdKey) => {
    const searchId = this.state[searchIdKey] + 1;
    this.setState({ [searchIdKey]: searchId });

    if (event.target.value) {
      api
        .send("POST", endpoint, {
          omniSearchTerm: event.target.value,
          recordLimit: 20,
        })
        .then((data) => {
          if (this.state[searchIdKey] === searchId) {
            const transformedData = transformFn(data);
            this.setState({ [stateKey]: transformedData });
          }
        })
        .catch((error) => {
          console.error(error);
          if (this.state[searchIdKey] === searchId) {
            this.setState({ [stateKey]: [] });
          }
        });
    } else {
      this.setState({ [stateKey]: [] });
    }
  };

  transformProviders = (data) => {
    return data.providers.map((provider) => ({
      ...provider,
      title: (() => {
        const name = [provider.firstName, provider.lastName]
          .filter(Boolean)
          .join(" ");

        const credential = provider.credential?.trim();
        const nameWithCredential = credential ? `${name}, ${credential}` : name;

        const location = [provider.city, provider.state]
          .filter(Boolean)
          .join(", ");

        const parts = [
          nameWithCredential,
          location || null,
          provider.npi || null,
        ].filter(Boolean); // remove null or empty parts

        return parts.join(" - ");
      })(),
      value: provider.id,
    }));
  };

  transformDiagnosisCodes = (data) => {
    return data.diagnosisCodes.map((diagnosisCode) => ({
      title: `${DiagnosisCode.getDisplayName(diagnosisCode)} - ${diagnosisCode.descriptionShort}`,
      descriptionShort: diagnosisCode.descriptionShort,
      value: diagnosisCode.id,
    }));
  };

  handleSearchOrderingProviderChange = (event) => {
    if (!event) {
      this.setState({ providers: [] });
      return;
    }
    this.handleOmniSearch(
      event,
      "/search/omniSearch/Provider",
      "providers",
      this.transformProviders,
      "currentOrderingProviderSearchId",
    );
  };

  handleSearchDiagnosisCodeChange = (event) => {
    if (!event) {
      this.setState({ diagnosisCodes: [] });
      return;
    }
    this.handleOmniSearch(
      event,
      "/search/omniSearch/DiagnosisCode",
      "diagnosisCodes",
      this.transformDiagnosisCodes,
      "currentDiagnosisCodeSearchId",
    );
  };

  renderManualOrderingProviderSection() {
    const updateOnPatient = (property, value) => {
      let nPatient = this.state.ePatient;
      if (nPatient.orderingProviderNotFound) {
        let existingData = {};

        try {
          if (nPatient.jsonOrderingProviderNotFoundData) {
            existingData = JSON.parse(
              nPatient.jsonOrderingProviderNotFoundData,
            );
          }
        } catch (err) {
          console.warn(
            "Failed to parse jsonOrderingProviderNotFoundData:",
            err,
          );
          existingData = {};
        }
        if (value !== null && value !== undefined && value !== "") {
          existingData[property] = value;
        } else {
          delete existingData[property];
        }

        if (Object.keys(existingData).length > 0) {
          nPatient.jsonOrderingProviderNotFoundData =
            JSON.stringify(existingData);
        } else {
          delete nPatient.jsonOrderingProviderNotFoundData;
        }

        nPatient.orderingProviderData = existingData;
      }

      this.setState({ ePatient: nPatient });
    };

    const formatPhoneOrFaxNumber = (value) => {
      const cleaned = value.replace(/\D/g, "").slice(0, 10);
      const length = cleaned.length;

      if (length === 0) return "";
      if (length < 4) return `(${cleaned}`;
      if (length < 7) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    };

    const handlePhoneOrFaxNumberChange = (event, prop) => {
      const { value } = event.target;

      const formatted = formatPhoneOrFaxNumber(value);
      if (this.state.curOrder) {
        this.setAndUpdate(prop, formatted, true);
      } else {
        updateOnPatient(prop, formatted);
      }
    };

    const dataSource = this.state.curOrder
      ? this.state.eOrder
      : this.state.ePatient;

    let providerData = {};

    if (
      dataSource.orderingProviderNotFound &&
      dataSource.jsonOrderingProviderNotFoundData
    ) {
      providerData = JSON.parse(dataSource.jsonOrderingProviderNotFoundData);
    }

    return (
      <>
        <MUIGrid item xs={12} sm={12} md={6} lg={6}>
          <MUITextField
            value={providerData?.name || null}
            size="small"
            label="Name"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => {
              if (this.state.curOrder) {
                this.setAndUpdate("name", e ? e.target.value : null, true);
              } else {
                updateOnPatient("name", e ? e.target.value : null);
              }
            }}
            onBlur={(e) => {
              const trimmed = e?.target?.value?.trim() || null;
              if (this.state.curOrder) {
                this.setAndUpdate("name", trimmed, true);
              } else {
                updateOnPatient("name", trimmed);
              }
            }}
            required={true}
            error={this.state.validationIssues?.name}
            helperText={
              this.state.validationIssues?.name
                ? this.state.validationIssues?.name
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={6} lg={6}>
          <MUITextField
            value={providerData?.address || null}
            size="small"
            label="Address"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => {
              if (this.state.curOrder) {
                this.setAndUpdate("address", e ? e.target.value : null, true);
              } else {
                updateOnPatient("address", e ? e.target.value : null);
              }
            }}
            onBlur={(e) => {
              const trimmed = e?.target?.value?.trim() || null;
              if (this.state.curOrder) {
                this.setAndUpdate("address", trimmed, true);
              } else {
                updateOnPatient("address", trimmed);
              }
            }}
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={6} lg={4}>
          <MUITextField
            value={providerData?.city || null}
            size="small"
            label="City"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => {
              if (this.state.curOrder) {
                this.setAndUpdate("city", e ? e.target.value : null, true);
              } else {
                updateOnPatient("city", e ? e.target.value : null);
              }
            }}
            onBlur={(e) => {
              const trimmed = e?.target?.value?.trim() || null;
              if (this.state.curOrder) {
                this.setAndUpdate("city", trimmed, true);
              } else {
                updateOnPatient("city", trimmed);
              }
            }}
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={6} lg={4}>
          <MUITextField
            value={providerData?.state || null}
            size="small"
            label="State"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => {
              if (this.state.curOrder) {
                this.setAndUpdate("state", e ? e.target.value : null, true);
              } else {
                updateOnPatient("state", e ? e.target.value : null);
              }
            }}
            onBlur={(e) => {
              const trimmed = e?.target?.value?.trim() || null;
              if (this.state.curOrder) {
                this.setAndUpdate("state", trimmed, true);
              } else {
                updateOnPatient("state", trimmed);
              }
            }}
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={6} lg={4}>
          <MUITextField
            value={providerData?.postal_code || null}
            size="small"
            label="Postal Code"
            fullWidth={true}
            inputProps={{
              maxLength: 5,
              inputMode: "numeric",
            }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => {
              if (this.state.curOrder) {
                this.setAndUpdate(
                  "postal_code",
                  e ? e.target.value : null,
                  true,
                );
              } else {
                updateOnPatient("postal_code", e ? e.target.value : null);
              }
            }}
            onBlur={(e) => {
              const trimmed = e?.target?.value?.trim() || null;
              if (this.state.curOrder) {
                this.setAndUpdate("postal_code", trimmed, true);
              } else {
                updateOnPatient("postal_code", trimmed);
              }
            }}
            error={this.state.validationIssues?.postal_code}
            helperText={
              this.state.validationIssues?.postal_code
                ? this.state.validationIssues.postal_code
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={6} lg={4}>
          <MUITextField
            value={
              providerData && providerData.phone_number
                ? formatPhoneOrFaxNumber(providerData.phone_number)
                : ""
            }
            size="small"
            label="Phone #"
            fullWidth={true}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => {
              if (this.state.curOrder) {
                this.setAndUpdate(
                  "phone_number",
                  e.target.value
                    ? e.target.value.replace(/\D/g, "").slice(0, 10)
                    : null,
                );
              } else {
                updateOnPatient(
                  "phone_number",
                  e.target.value
                    ? e.target.value.replace(/\D/g, "").slice(0, 10)
                    : null,
                );
              }
            }}
            onChange={(e) => handlePhoneOrFaxNumberChange(e, "phone_number")}
            error={this.state.validationIssues?.phone_number}
            helperText={
              this.state.validationIssues?.phone_number
                ? this.state.validationIssues.phone_number
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={6} lg={4}>
          <MUITextField
            value={
              providerData && providerData.fax_number
                ? formatPhoneOrFaxNumber(providerData.fax_number)
                : ""
            }
            size="small"
            label="Fax #"
            fullWidth={true}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => {
              if (this.state.curOrder) {
                this.setAndUpdate(
                  "fax_number",
                  e.target.value
                    ? e.target.value.replace(/\D/g, "").slice(0, 10)
                    : null,
                );
              } else {
                updateOnPatient(
                  "fax_number",
                  e.target.value
                    ? e.target.value.replace(/\D/g, "").slice(0, 10)
                    : null,
                );
              }
            }}
            onChange={(e) => handlePhoneOrFaxNumberChange(e, "fax_number")}
            error={this.state.validationIssues?.fax_number}
            helperText={
              this.state.validationIssues?.fax_number
                ? this.state.validationIssues.fax_number
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={6} lg={4}>
          <MUITextField
            value={providerData?.npi || null}
            size="small"
            label="NPI"
            fullWidth={true}
            inputProps={{
              maxLength: 10,
              inputMode: "numeric",
            }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => {
              if (this.state.curOrder) {
                this.setAndUpdate("npi", e ? e.target.value : null, true);
              } else {
                updateOnPatient("npi", e ? e.target.value : null);
              }
            }}
            onBlur={(e) => {
              const trimmed = e?.target?.value?.trim() || null;
              if (this.state.curOrder) {
                this.setAndUpdate("npi", trimmed, true);
              } else {
                updateOnPatient("npi", trimmed);
              }
            }}
            required={dataSource === this.state.eOrder} // Only require on a ticket, not the patient
            error={this.state.validationIssues?.npi}
            helperText={
              this.state.validationIssues?.npi
                ? this.state.validationIssues.npi
                : ""
            }
          />
        </MUIGrid>
        <MUIGrid item xs={12}>
          <MUIDivider style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }} />
        </MUIGrid>
      </>
    );
  }

  renderOrderingProviderSection() {
    const selectedValue = this.state.curOrder
      ? this.state.selectedTicketProvider || null
      : this.state.selectedPatientProvider || null;

    const dataSource = this.state.curOrder
      ? this.state.eOrder
      : this.state.ePatient;

    return (
      <>
        <MUIGrid item xs={8}>
          <MUIAutoComplete
            disabled={dataSource.orderingProviderNotFound}
            options={this.state.providers}
            getOptionLabel={(option) => option.title || ""}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            filterOptions={(options, { inputValue }) => {
              const normalizedInput = inputValue.toLowerCase().trim();

              return options.filter((option) => {
                const title = option.title?.toLowerCase() || "";
                const npi = option.npi?.toLowerCase() || "";

                const fullName = option.title.split(",")[0]; // "FirstName LastName"
                const [firstName, lastName] = fullName.split(" ");

                const reversedName = `${lastName}, ${firstName}`.toLowerCase();

                return (
                  title.includes(normalizedInput) ||
                  npi.includes(normalizedInput) ||
                  reversedName.includes(normalizedInput)
                );
              });
            }}
            value={selectedValue}
            onChange={(e, value) => {
              if (this.state.curOrder) {
                this.setState({ selectedTicketProvider: value }, () => {
                  this.setAndUpdate(
                    "orderingProviderId",
                    value ? value.value : null,
                    true,
                  );
                });
              } else {
                this.setState({ selectedPatientProvider: value }, () => {
                  this.handleChange("orderingProviderId", value ? value : null);
                });
              }
            }}
            onInputChange={(event, value) => {
              if (!value) {
                this.setState({ providers: [] });
              } else {
                this.throttledHandleOrderingProviderSearch(event);
              }
            }}
            onKeyDown={(event) => {
              if (
                (event.key === "Tab" || event.key === "Enter") &&
                this.state.providers.length === 1
              ) {
                event.preventDefault();
                const singleOption = this.state.providers[0];
                if (this.state.curOrder) {
                  this.setState(
                    { selectedTicketProvider: singleOption },
                    () => {
                      this.setAndUpdate(
                        "orderingProviderId",
                        singleOption ? singleOption.value : null,
                        true,
                      );
                    },
                  );
                } else {
                  this.setState(
                    { selectedPatientProvider: singleOption },
                    () => {
                      this.handleChange(
                        "orderingProviderId",
                        singleOption ? singleOption : null,
                      );
                    },
                  );
                }

                const input = event.target
                  .closest(".MuiAutocomplete-root")
                  .querySelector("input");
                if (input) {
                  input.blur();
                }
              }
            }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                InputLabelProps={{ shrink: true }}
                size="small"
                variant="outlined"
                label="Ordering Provider"
                placeholder="Search by Name or NPI..."
                fullWidth
              />
            )}
          />
        </MUIGrid>
        <MUIGrid item xs={4}>
          <MUIFormControlLabel
            onChange={(e) => {
              const checked = e.target.checked;

              if (this.state.curOrder) {
                this.setAndUpdate(
                  "orderingProviderNotFound",
                  e.target.checked,
                  true,
                );
              } else {
                this.handleCheckboxChange("orderingProviderNotFound", e);
              }

              if (checked) {
                if (this.state.curOrder) {
                  this.setState({ selectedTicketProvider: null }, () => {
                    this.setAndUpdate("orderingProviderId", null, true);
                  });
                } else {
                  this.setState({ selectedPatientProvider: null }, () => {
                    this.handleChange("orderingProviderId", null);
                  });
                }
              }
            }}
            checked={dataSource.orderingProviderNotFound || false}
            value={dataSource.orderingProviderNotFound || false}
            control={<MUICheckbox size="small" />}
            label="Provider Not Found"
            sx={{ pl: 0.5 }}
          />
        </MUIGrid>
      </>
    );
  }

  renderOrderingProviderDataSection() {
    const formatPhoneOrFaxNumber = (value) => {
      if (!value) return "N/A";
      const cleaned = value.replace(/\D/g, "").slice(0, 10);
      const length = cleaned.length;

      if (length === 0) return "N/A";
      if (length < 4) return `(${cleaned}`;
      if (length < 7) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    };

    const providerInformation = this.state.curOrder
      ? this.state.selectedTicketProvider || null
      : this.state.selectedPatientProvider || null;

    if (!providerInformation) {
      return null;
    }

    return (
      <MUIGrid item xs={12} sx={{ pb: 1 }}>
        <MUIGrid container columnSpacing={8} rowSpacing={2}>
          <MUIGrid
            item
            sm={12}
            lg={"auto"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <MUIPlaceIcon color="error" fontSize="medium" sx={{ mr: 1 }} />
            {(() => {
              const isAddressEmpty =
                !providerInformation.address1 &&
                !providerInformation.address2 &&
                !providerInformation.city &&
                !providerInformation.state &&
                !providerInformation.postalCode;

              if (isAddressEmpty) {
                return "N/A";
              }

              return (
                <>
                  {providerInformation.address1 && (
                    <>
                      {providerInformation.address1}
                      <br />
                    </>
                  )}
                  {providerInformation.address2 && (
                    <>
                      {providerInformation.address2}
                      <br />
                    </>
                  )}
                  {(providerInformation.city ||
                    providerInformation.state ||
                    providerInformation.postalCode) && (
                    <>
                      {[providerInformation.city, providerInformation.state]
                        .filter(Boolean)
                        .join(", ")}
                      {providerInformation.postalCode &&
                        ` ${providerInformation.postalCode}`}
                    </>
                  )}
                </>
              );
            })()}
          </MUIGrid>
          <MUIGrid
            item
            sm={12}
            lg={"auto"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <MUISmartphoneIcon
              color="primary"
              fontSize="medium"
              sx={{ mr: 1 }}
            />
            {formatPhoneOrFaxNumber(providerInformation.phoneNumber)}
          </MUIGrid>
          <MUIGrid
            item
            sm={12}
            lg={"auto"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <MUIFaxIcon color="success" fontSize="medium" sx={{ mr: 1 }} />
            {formatPhoneOrFaxNumber(providerInformation.faxNumber)}
          </MUIGrid>
        </MUIGrid>
      </MUIGrid>
    );
  }

  renderDiagnosisCodesSection() {
    const stateString = this.state.curOrder
      ? "OrderActivityDiagnosisCodeSelected"
      : "PatientDiagnosisCodeSelected";

    return (
      <>
        {this.state.diagnosisCodeInputs.map((inputName, index) => (
          <MUIGrid item xs={12} sm={12} md={6} lg={6} key={index}>
            <MUIAutoComplete
              options={this.state.diagnosisCodes}
              getOptionLabel={(option) => option.title}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              filterOptions={(options, { inputValue }) => {
                return options.filter((option) => {
                  const title = option.title || "";
                  const descriptionShort = option.descriptionShort || "";

                  return (
                    title.toLowerCase().includes(inputValue.toLowerCase()) ||
                    descriptionShort
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  );
                });
              }}
              value={this.state[`${inputName}${stateString}`] || null}
              onChange={(e, value) => {
                this.setState(
                  {
                    [`${inputName}${stateString}`]: value || null,
                  },
                  () => {
                    if (this.state.curOrder) {
                      this.setAndUpdate(
                        `${inputName}DiagnosisCodeId`,
                        value ? value.value : null,
                        true,
                      );
                    } else {
                      this.handleChange(
                        `${inputName}DiagnosisCodeId`,
                        value ? value : null,
                      );
                    }
                  },
                );
              }}
              onInputChange={(event, value) => {
                if (!value) {
                  this.setState({ diagnosisCodes: [] });
                } else {
                  this.throttledHandleDiagnosisCodeSearch(event);
                }
              }}
              onKeyDown={(event) => {
                if (
                  (event.key === "Tab" || event.key === "Enter") &&
                  this.state.diagnosisCodes.length === 1
                ) {
                  event.preventDefault();
                  const singleOption = this.state.diagnosisCodes[0];
                  this.setState(
                    { [`${inputName}${stateString}`]: singleOption },
                    () => {
                      if (this.state.curOrder) {
                        this.setAndUpdate(
                          `${inputName}DiagnosisCodeId`,
                          singleOption ? singleOption.value : null,
                          true,
                        );
                      } else {
                        this.handleChange(
                          `${inputName}DiagnosisCodeId`,
                          singleOption ? singleOption : null,
                        );
                      }
                    },
                  );

                  const input = event.target
                    .closest(".MuiAutocomplete-root")
                    .querySelector("input");
                  if (input) {
                    input.blur();
                  }
                }
              }}
              renderInput={(params) => (
                <MUITextField
                  {...params}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  variant="outlined"
                  placeholder="Search by Code or Description..."
                  label={
                    inputName === "first"
                      ? "Primary Diagnosis Code"
                      : "Additional Diagnosis Code"
                  }
                  fullWidth
                />
              )}
            />
          </MUIGrid>
        ))}
      </>
    );
  }

  renderDiseaseSection() {
    return (
      <>
        <MUIGrid item xs={12} sm={12} md={6} lg={3}>
          <MUIFormControlLabel
            onChange={(e) => {
              this.handleCheckboxChange("hasInfectiousDisease", e);
            }}
            checked={this.state.ePatient.hasInfectiousDisease || false}
            value={this.state.ePatient.hasInfectiousDisease || false}
            control={<MUICheckbox size="small" />}
            label="Infectious Disease"
            sx={{ pl: 0.5 }}
          />
        </MUIGrid>
        <MUIGrid item xs={12} sm={12} md={6} lg={9}>
          <MUITextField
            value={this.state.ePatient.diseaseNotes || ""}
            size="small"
            label="Disease Notes"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => this.handleChange("diseaseNotes", e)}
          />
        </MUIGrid>
      </>
    );
  }

  renderPatientInformation() {
    if (this.state.TabsOneActiveItem !== "2") {
      return;
    }
    if (this.state.patientInfoRetrieved === false) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            minHeight: "100vh",
            paddingTop: "5vh",
          }}
        >
          <MDBSpinner></MDBSpinner>
        </div>
      );
    }
    return (
      <div
        style={
          this.state.canEditBasicInfo &&
          !this.state.createServiceTicketModalOpen
            ? { minHeight: "100vh" }
            : {}
        }
      >
        <div>{this.renderBasicInfo()}</div>
        <div style={{ display: "flex" }}>{this.renderContactInfo()}</div>
        <div style={{ padding: "1.5rem" }}>
          <MDBBtnGroup>
            <MDBBtn
              color="gray"
              style={{ marginRight: "1rem" }}
              onClick={() => {
                this.setState({ patientInfoRetrieved: false });
                return OrderService.getPatientById(this.state.id).then(
                  (data) => {
                    this.setState(
                      {
                        patientAge: moment(
                          data.deceased && data.dateOfDeath
                            ? data.dateOfDeath
                            : undefined,
                        ).diff(data.dateOfBirth, "years", false),
                        patient: data,
                        ePatient: JSON.parse(JSON.stringify(data)),
                        TabsOneActiveItem: "1",
                        canEditBasicInfo: false,
                        patientInfoRetrieved: true,
                      },
                      () => {
                        this.openOrder();
                      },
                    );
                  },
                );
              }}
            >
              Cancel
            </MDBBtn>
            <MUITooltip
              title={
                this.canEditPatientInfoInOldExperience()
                  ? ""
                  : "Please use new experience to update contact info"
              }
              placement="top"
            >
              <span>
                <MDBBtn
                  className="successButton"
                  onClick={this.savePatient.bind(this)}
                  disabled={!this.canEditPatientInfoInOldExperience()}
                >
                  Update
                </MDBBtn>
              </span>
            </MUITooltip>
          </MDBBtnGroup>
        </div>
      </div>
    );
  }

  refreshPatientData = async () => {
    this.setState({ patientInfoRetrieved: false });

    try {
      const data = await OrderService.getPatientById(this.state.id);
      this.setState(
        {
          patientAge: moment(
            data.deceased && data.dateOfDeath ? data.dateOfDeath : undefined,
          ).diff(data.dateOfBirth, "years", false),
          patient: data,
          ePatient: JSON.parse(JSON.stringify(data)),
          TabsOneActiveItem: "1",
          canEditClinicalInfo: false,
          patientInfoRetrieved: true,
        },
        () => {
          this.openOrder();
          this.loadPatientChart(this.state.ePatient.id);
        },
      );
    } catch (err) {
      console.error("Failed to retrieve patient data:", err);
      toast.error("Failed to retrieve patient information.");
      this.setState({ patientInfoRetrieved: true });
    }
  };

  validateProviderNotFoundInforamtion(openTicket) {
    const dataSource = this.state.curOrder
      ? this.state.eOrder
      : this.state.ePatient;

    let providerData = {};
    try {
      providerData = JSON.parse(
        dataSource.jsonOrderingProviderNotFoundData || "{}",
      );
    } catch (e) {
      console.error("Invalid JSON in jsonOrderingProviderNotFoundData", e);
    }

    const validationIssues = Validator.validate(providerData, {
      name: {
        required: true,
      },
      postal_code: {
        type: "zipCode",
      },
      phone_number: {
        type: "phone",
      },
      fax_number: {
        type: "phone",
      },
      npi: {
        required: dataSource === this.state.eOrder, // Only require on a ticket, not the patient
        type: "npi",
      },
    });

    this.setState({
      validationIssues: validationIssues,
    });

    if (Object.keys(validationIssues).length === 0) {
      this.updateOrderOrPatient(openTicket);
    } else {
      toast.error("Please correct the displayed issues.", { variant: "error" });
    }
  }

  updateOrderingProviderNotFoundJsonBlobOnPatient(property, value) {
    let nPatient = this.state.ePatient;
    if (
      this.state.patient.orderingProviderId === null &&
      this.state.patient?.orderingProviderNotFound === false
    ) {
      let existingData = {};

      try {
        if (nPatient.jsonOrderingProviderNotFoundData) {
          existingData = JSON.parse(nPatient.jsonOrderingProviderNotFoundData);
        }
      } catch (err) {
        console.warn("Failed to parse jsonOrderingProviderNotFoundData:", err);
        existingData = {};
      }
      if (value !== null && value !== undefined && value !== "") {
        existingData[property] = value;
      } else {
        delete existingData[property];
      }

      if (Object.keys(existingData).length > 0) {
        nPatient.jsonOrderingProviderNotFoundData =
          JSON.stringify(existingData);
      } else {
        delete nPatient.jsonOrderingProviderNotFoundData;
      }

      nPatient.orderingProviderData = existingData;
      nPatient.orderingProviderNotFound = true;
    }

    this.setState({ ePatient: nPatient });
  }

  async updateOrderOrPatient(openTicket) {
    if (openTicket) {
      const hasChanged =
        this.state.ePatient.hasInfectiousDisease !==
          this.state.patient.hasInfectiousDisease ||
        this.state.ePatient.diseaseNotes !== this.state.patient.diseaseNotes ||
        this.state.ePatient.orderingProviderId !==
          this.state.patient.orderingProviderId ||
        this.state.ePatient.orderingProviderNotFound !==
          this.state.patient.orderingProviderNotFound;

      const shouldSyncOrderingProviderFromTicket =
        this.state.patient &&
        this.state.patient.orderingProviderId === null &&
        this.state.patient.orderingProviderNotFound === false &&
        openTicket.orderingProviderId;

      const shouldSyncCustomOrderingProviderDataFromTicket = Boolean(
        this.state.patient &&
        this.state.patient.orderingProviderId === null &&
        this.state.patient.orderingProviderNotFound === false &&
        openTicket.orderingProviderNotFound === true &&
        openTicket.jsonOrderingProviderNotFoundData,
      );

      this.shiftDiagnosisCodes();

      try {
        if (openTicket) {
          this.shiftDiagnosisCodes();

          const res = await OrderService.updateOrder(openTicket);

          if (res.id === -1) {
            toast.error("Patient gender must be set before saving.");
            return;
          }
        }

        if (shouldSyncOrderingProviderFromTicket) {
          const updatedPatient = { ...this.state.ePatient };
          updatedPatient.orderingProviderId = openTicket.orderingProviderId;
          updatedPatient.orderingProviderNotFound = false;
          this.setState({ ePatient: updatedPatient });
        }

        if (shouldSyncCustomOrderingProviderDataFromTicket) {
          const orderLevelData = JSON.parse(
            openTicket.jsonOrderingProviderNotFoundData,
          );

          // Sync all fields manually to ensure patient data is updated
          const keys = [
            "name",
            "address",
            "city",
            "state",
            "postal_code",
            "phone_number",
            "fax_number",
            "npi",
          ];

          keys.forEach((key) => {
            const value = orderLevelData[key];
            this.updateOrderingProviderNotFoundJsonBlobOnPatient(key, value);
          });
        }

        if (
          hasChanged ||
          shouldSyncOrderingProviderFromTicket ||
          shouldSyncCustomOrderingProviderDataFromTicket
        ) {
          await OrderService.updatePatient(this.state.ePatient).then((data) => {
            this.setState(
              {
                patient: data,
                ePatient: JSON.parse(JSON.stringify(data)),
                canEditClinicalInfo: false,
              },
              () => {
                this.loadPatientChart(data.id);
              },
            );
          });
        }

        toast.success("Clinical Information saved successfully!");
        this.refreshPatientData();
      } catch (err) {
        console.error(err);
        toast.error("There was an error saving Clinical Information.");
      }
    } else {
      this.savePatient();
    }
  }

  renderEditClinicalInformationCard() {
    const openTicket =
      this.state.curOrder?.id === this.state.eOrder?.id
        ? this.state.eOrder
        : null;
    const dataSource = openTicket ? this.state.eOrder : this.state.ePatient;

    if (this.state.TabsOneActiveItem !== "5") {
      return;
    }
    if (this.state.patientInfoRetrieved === false) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            minHeight: "100vh",
            paddingTop: "5vh",
          }}
        >
          <MDBSpinner></MDBSpinner>
        </div>
      );
    }
    return (
      <div
        style={
          this.state.canEditClinicalInfo &&
          !this.state.createServiceTicketModalOpen
            ? { minHeight: "100vh" }
            : {}
        }
      >
        <div>{this.renderClinicalInformation()}</div>
        <div style={{ padding: "1.5rem" }}>
          <MDBBtnGroup>
            <MDBBtn
              color="gray"
              style={{ marginRight: "1rem" }}
              onClick={() => this.refreshPatientData()}
            >
              Cancel
            </MDBBtn>
            <MUITooltip
              title={
                this.canEditPatientInfoInOldExperience()
                  ? ""
                  : "Please use new experience to update clinical info"
              }
              placement="top"
            >
              <span>
                <MDBBtn
                  className="successButton"
                  disabled={!this.canEditPatientInfoInOldExperience()}
                  onClick={() => {
                    if (dataSource.orderingProviderNotFound) {
                      this.validateProviderNotFoundInforamtion(openTicket);
                    } else {
                      this.updateOrderOrPatient(openTicket);
                    }
                  }}
                >
                  Update
                </MDBBtn>
              </span>
            </MUITooltip>
          </MDBBtnGroup>
        </div>
      </div>
    );
  }

  renderPrimarySection() {
    let item = this.state.ePatient;
    const { insuranceTypes, insuranceSubTypes } = this.context;

    return (
      <div className="insuranceTypeContainer">
        <label className="insuranceTypeLabel">Primary Insurance</label>
        <Dropdown className={"insuranceDropdown"}>
          <DropdownToggle
            fullWidth
            style={{ display: "flex", justifyContent: "space-between" }}
            className={
              this.state.canEditInsuranceInfo
                ? "idDropdownToggle"
                : "idDropdownToggle basicInfoDisabled"
            }
            nav
            disabled={this.state.canEditInsuranceInfo ? false : true}
          >
            Payor Source
            <span>
              {item.insuranceType ? item.insuranceType.name : ""}
              &nbsp;
              <Fa icon={"angle-down"} />
            </span>
          </DropdownToggle>
          <DropdownMenu basic>
            <DropdownItem disabled>Select Payor Source</DropdownItem>
            <DropdownItem divider />
            {insuranceTypes.map((type, index) => {
              return (
                <DropdownItem
                  key={index}
                  onClick={this.changeInsuranceType.bind(this, type, false)}
                >
                  {type.name}
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </Dropdown>
        <Dropdown className={"insuranceDropdown"}>
          <DropdownToggle
            fullWidth
            style={{ display: "flex", justifyContent: "space-between" }}
            className={
              this.state.canEditInsuranceInfo
                ? "idDropdownToggle"
                : "idDropdownToggle basicInfoDisabled"
            }
            nav
            disabled={this.state.canEditInsuranceInfo ? false : true}
          >
            Insurance
            <span>
              {item.insuranceSubType ? item.insuranceSubType.name : ""}
              &nbsp;
              <Fa icon={"angle-down"} />
            </span>
          </DropdownToggle>
          <DropdownMenu basic>
            <DropdownItem disabled>Select Insurance</DropdownItem>
            <DropdownItem divider />
            {insuranceSubTypes.map((type, index) => {
              let ePatient = this.state.ePatient;
              if (
                ePatient.insuranceType &&
                type.insuranceType.id === ePatient.insuranceType.id
              ) {
                return (
                  <DropdownItem
                    key={index}
                    onClick={this.changeInsuranceSubType.bind(
                      this,
                      type,
                      false,
                    )}
                  >
                    {type.name}{" "}
                  </DropdownItem>
                );
              }
              return null;
            })}
          </DropdownMenu>
        </Dropdown>
        <MDBRow>
          <MDBCol
            size="12"
            style={{
              paddingTop: 10,
              display: "flex",
              flexDirection: "column",
              gap: ".5rem",
            }}
          >
            <Input
              size="small"
              fullWidth
              label={"Primary Policy Number"}
              outline
              className={
                this.state.canEditInsuranceInfo ? "" : "basicInfoDisabled"
              }
              value={item.insurancePolicy || ""}
              disabled={this.state.canEditInsuranceInfo ? false : true}
              onChange={this.handleChange.bind(this, "insurancePolicy")}
            />
            <Input
              size="small"
              fullWidth
              label={"Primary Group Number"}
              outline
              className={
                this.state.canEditInsuranceInfo ? "" : "basicInfoDisabled"
              }
              value={item.insuranceGroup || ""}
              disabled={this.state.canEditInsuranceInfo ? false : true}
              onChange={this.handleChange.bind(this, "insuranceGroup")}
            />
          </MDBCol>
        </MDBRow>
      </div>
    );
  }

  renderSecondarySection() {
    let item = this.state.ePatient;
    const { insuranceTypes, insuranceSubTypes } = this.context;

    const clearSelection = () => {
      this.setState({
        ePatient: {
          ...this.state.ePatient,
          secondaryInsuranceSubType: null, // Clear the selected subtype
          secondaryInsuranceSubTypeId: null,
        },
      });
    };

    return (
      <div className="insuranceTypeContainer">
        <label className="insuranceTypeLabel">Secondary Insurance</label>

        <Dropdown className={"insuranceDropdown"}>
          <DropdownToggle
            fullWidth
            style={{ display: "flex", justifyContent: "space-between" }}
            className={
              this.state.canEditInsuranceInfo
                ? "idDropdownToggle"
                : "idDropdownToggle basicInfoDisabled"
            }
            nav
            disabled={this.state.canEditInsuranceInfo ? false : true}
          >
            Secondary Payor Source
            <span>
              {item.secondaryInsuranceType
                ? item.secondaryInsuranceType.name
                : ""}
              &nbsp;
              <Fa icon={"angle-down"} />
            </span>
          </DropdownToggle>
          <DropdownMenu basic>
            <DropdownItem disabled>Secondary Payor Source</DropdownItem>
            <DropdownItem divider />
            {insuranceTypes.map((type, index) => {
              return (
                <DropdownItem
                  key={index}
                  onClick={this.changeInsuranceType.bind(this, type, true)}
                >
                  {type.name}{" "}
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </Dropdown>

        <Dropdown className={"insuranceDropdown"}>
          <DropdownToggle
            fullWidth
            style={{ display: "flex", justifyContent: "space-between" }}
            className={
              this.state.canEditInsuranceInfo
                ? "idDropdownToggle"
                : "idDropdownToggle basicInfoDisabled"
            }
            nav
            disabled={this.state.canEditInsuranceInfo ? false : true}
          >
            Secondary Insurance
            <span>
              {this.state.ePatient.secondaryInsuranceSubType
                ? this.state.ePatient.secondaryInsuranceSubType.name
                : "None"}
              {this.state.ePatient.secondaryInsuranceSubType && (
                <Fa
                  disabled={this.state.canEditInsuranceInfo ? false : true}
                  icon="times"
                  onClick={
                    this.state.canEditInsuranceInfo ? clearSelection : null
                  }
                  style={{ marginLeft: 8, marginRight: 8, cursor: "pointer" }}
                />
              )}
              &nbsp;
              <Fa icon={"angle-down"} />
            </span>
          </DropdownToggle>
          <DropdownMenu basic>
            <DropdownItem disabled>Secondary Insurance</DropdownItem>
            <DropdownItem divider />
            {insuranceSubTypes.map((type, index) => {
              let ePatient = this.state.ePatient;
              if (
                ePatient.secondaryInsuranceType &&
                type.insuranceType.id === ePatient.secondaryInsuranceType.id
              ) {
                return (
                  <DropdownItem
                    key={index}
                    onClick={this.changeInsuranceSubType.bind(this, type, true)}
                  >
                    {type.name}{" "}
                  </DropdownItem>
                );
              }
              return null;
            })}
          </DropdownMenu>
        </Dropdown>

        <MDBRow>
          <MDBCol
            size="12"
            style={{
              paddingTop: 10,
              display: "flex",
              flexDirection: "column",
              gap: ".5rem",
            }}
          >
            <Input
              size="small"
              fullWidth
              label={"Secondary Policy Number"}
              value={item.secondaryInsurancePolicy || ""}
              disabled={this.state.canEditInsuranceInfo ? false : true}
              outline
              className={
                this.state.canEditInsuranceInfo ? "" : "basicInfoDisabled"
              }
              onChange={this.handleChange.bind(
                this,
                "secondaryInsurancePolicy",
              )}
            />
            <Input
              size="small"
              fullWidth
              label={"Secondary Group Number"}
              value={item.secondaryInsuranceGroup || ""}
              disabled={this.state.canEditInsuranceInfo ? false : true}
              className={
                this.state.canEditInsuranceInfo ? "" : "basicInfoDisabled"
              }
              outline
              onChange={this.handleChange.bind(this, "secondaryInsuranceGroup")}
            />
          </MDBCol>
        </MDBRow>
      </div>
    );
  }

  openOrder() {
    let id = this.state.shouldOpenOrderId;
    if (!id) {
      return;
    }
    this.highlightOrderRow(id, "service");
  }
  renderInsuranceCard() {
    let openOrders = [];
    if (
      this.state.patientEquipmentLoaded &&
      this.state.openAndNotApproved &&
      this.state.openAndNotApproved !== null
    ) {
      this.state.openAndNotApproved.forEach((o) => openOrders.push(o));
      const sortByCurOrder = (open) => {
        const sorter = (a, b) => {
          if (
            a.id !== this.state.curOrderId &&
            b.id === this.state.curOrderId
          ) {
            return 1;
          }
          if (
            a.id === this.state.curOrderId &&
            b.id !== this.state.curOrderId
          ) {
            return -1;
          }
          return b["id"] - a["id"];
        };
        open.sort(sorter);
      };
      sortByCurOrder(openOrders);
    }

    if (
      !this.state.createServiceTicketModalOpen &&
      this.state.TabsOneActiveItem !== "3"
    ) {
      return <div />;
    }

    if (this.state.patientInfoRetrieved === false) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            minHeight: "100vh",
            paddingTop: "5vh",
          }}
        >
          <MDBSpinner></MDBSpinner>
        </div>
      );
    }

    let item = this.state.ePatient;

    return (
      <div
        style={
          !this.state.createServiceTicketModalOpen ? { minHeight: "100vh" } : {}
        }
      >
        <Card className="patientInformationCard ">
          <label style={{ paddingTop: "10px" }} className="cardLabel">
            Insurance
          </label>
          {this.state.canEditInsuranceInfo &&
          this.state.createServiceTicketModalOpen ? (
            <div className="insuranceContainer">
              <MDBRow>
                <MDBCol md="6" style={{ paddingBottom: "10px" }}>
                  {this.renderPrimarySection()}
                </MDBCol>
                <MDBCol md="6">{this.renderSecondarySection()}</MDBCol>
                <MDBCol md="5"></MDBCol>
              </MDBRow>
              {/*<MDBBtn*/}
              {/*    className="verifyBtn verifyBtnTicketModal"*/}
              {/*    data-tip="Submit to pVerify"*/}
              {/*    disabled={ disable }*/}
              {/*    onClick={ () => this.submitChangesToPverify() }*/}
              {/*>*/}
              {/*    Verify*/}
              {/*</MDBBtn>*/}
              <ReactTooltip />
            </div>
          ) : (
            <div className="insuranceContainer">
              {this.renderPrimarySection()}
              {this.renderSecondarySection()}
            </div>
          )}
        </Card>
        {this.state.createServiceTicketModalOpen ? null : (
          <div>
            <Card className="patientInformationCard">
              <div className="cardContent" style={{ paddingBottom: "1.25rem" }}>
                <label
                  style={{ paddingTop: "10px" }}
                  className="cardLabel mbiLabel"
                >
                  MBI
                </label>
                <Input
                  size="small"
                  fullWidth
                  maxLength={11}
                  style={{ textTransform: "uppercase" }}
                  label={"MBI"}
                  outline
                  disabled={this.state.canEditInsuranceInfo ? false : true}
                  className={
                    this.state.canEditInsuranceInfo ? "" : "basicInfoDisabled"
                  }
                  value={item.mbi || ""}
                  onChange={this.handleChange.bind(this, "mbi")}
                  onInput={(e) => {
                    const newValue = e.target.value.replace(
                      /[^a-zA-Z0-9]/g,
                      "",
                    ); // Letters and numbers only
                    e.target.value = newValue; // Update the input field directly
                  }}
                />
              </div>
            </Card>

            {this.state.curOrder && this.state.curOrder.isApproved === true ? (
              <MDBContainer>
                <MUIAlert
                  severity="warning"
                  sx={{ width: "100%", margin: "1.5rem 0rem 0rem" }}
                >
                  Ticket has been approved and insurance can no longer be
                  updated.
                </MUIAlert>
              </MDBContainer>
            ) : this.state.openAndNotApproved &&
              this.state.openAndNotApproved !== null &&
              this.state.openAndNotApproved.length > 0 &&
              this.state.openAndNotApproved &&
              this.state.openAndNotApproved !== null &&
              !this.state.createServiceTicketModalOpen ? (
              <MDBContainer>
                <MUIAlert
                  severity="info"
                  sx={{ width: "100%", margin: "1.5rem 0rem 0rem" }}
                >
                  <MUIAlertTitle>
                    Changes to the insurance will affect the following open
                    tickets:
                  </MUIAlertTitle>
                  {openOrders.map((o) => (
                    <span
                      style={
                        this.state.curOrderId && this.state.curOrderId === o.id
                          ? { color: MUILightBlueColor[700] }
                          : {}
                      }
                    >
                      #{o.id} ({o.orderType}) {o.status.props.label}
                      {o.reason ? ": " + o.reason : null}{" "}
                      {this.state.curOrderId &&
                      this.state.curOrderId === o.id ? (
                        <b>(Current Ticket)</b>
                      ) : (
                        ""
                      )}{" "}
                      <br />
                    </span>
                  ))}
                </MUIAlert>
              </MDBContainer>
            ) : null}

            <div style={{ padding: "1.5rem" }}>
              <MDBBtnGroup>
                <MDBBtn
                  color="gray"
                  style={{ marginRight: "1rem" }}
                  onClick={() => {
                    this.setState({ patientInfoRetrieved: false });
                    return OrderService.getPatientById(this.state.id).then(
                      (data) => {
                        this.setState(
                          {
                            patientAge: moment(
                              data.deceased && data.dateOfDeath
                                ? data.dateOfDeath
                                : undefined,
                            ).diff(data.dateOfBirth, "years", false),
                            patient: data,
                            ePatient: JSON.parse(JSON.stringify(data)),
                            TabsOneActiveItem: "1",
                            canEditInsuranceInfo: false,
                            patientInfoRetrieved: true,
                          },
                          () => {
                            this.openOrder();
                          },
                        );
                      },
                    );
                  }}
                >
                  Cancel
                </MDBBtn>
                <MUITooltip
                  title={
                    this.canEditPatientInfoInOldExperience()
                      ? ""
                      : "Please use new experience to update insurance info"
                  }
                  placement="top"
                >
                  <span>
                    <MDBBtn
                      style={{ marginRight: "1rem" }}
                      className="successButton"
                      disabled={
                        this.state.curOrder &&
                        this.state.curOrder.isApproved === true
                          ? true
                          : !this.canEditPatientInfoInOldExperience()
                      }
                      onClick={() => {
                        if (
                          this.state.openAndNotApproved &&
                          this.state.openAndNotApproved !== null &&
                          this.state.openAndNotApproved.length > 0
                        ) {
                          this.setState({
                            setDialogOpen: true,
                          });
                        } else {
                          this.savePatient(this);
                        }
                      }}
                    >
                      Update
                    </MDBBtn>
                  </span>
                </MUITooltip>
                <ReactTooltip />
              </MDBBtnGroup>
            </div>
          </div>
        )}
      </div>
    );
  }

  addABNProduct(row) {
    let o = this.state.eOrder;
    let r = row;
    let abn = o.abnProductOther;

    if (!abn) {
      abn = "";
    }

    let abnArr = abn ? abn.split(",") : "";
    let cat = r.product.replace(/,/g, ""),
      sub = r.equipment.replace(/,/g, "");
    let exIdx = abnArr.indexOf(cat + " " + sub);

    try {
      if (abn.length === 0) {
        o.abnProductOther = cat + " " + sub;
      } else if (exIdx > -1) {
        abnArr.splice(exIdx, 1);
        o.abnProductOther = abnArr.toString();
      } else {
        abnArr.push(cat + " " + sub);
        o.abnProductOther = abnArr.toString();
      }
    } catch (e) {
      o.abnProductOther = cat + " " + sub;
    }

    o.abnProductOther = o.abnProductOther.substring(0, 254);
    this.setState({
      eOrder: o,
    });
  }
  addABNProductNew(row) {
    let o = this.state.eOrder;
    let abn = o.abnProductOther;

    if (!abn) {
      abn = "";
    }

    let abnArr = abn ? abn.split(",") : "";
    // let cat = r.product.replace(/,/g, ""),
    //     sub = r.equipment.replace(/,/g, "");
    let exIdx = abnArr.indexOf(row.text);

    try {
      if (abn.length === 0) {
        o.abnProductOther = row.text;
      } else if (exIdx > -1) {
        abnArr.splice(exIdx, 1);
        o.abnProductOther = abnArr.toString();
      } else {
        abnArr.push(row.text);
        o.abnProductOther = abnArr.toString();
      }
    } catch (e) {
      o.abnProductOther = row.text;
    }
    this.setState({
      eOrder: o,
    });
  }
  turnPartsIntoABNList() {
    let products = this.state.serviceOrderProducts;
    let abnProductArray = [];
    products.forEach((prod, idx) => {
      let cat = prod.name.replace(/,/g, ""),
        sub = prod.hcpcs ? prod.hcpcs.replace(/,/g, "") : "";
      abnProductArray.push({
        text: cat + " " + sub,
        index: idx,
        abnRequired: this.checkForABNRequired(cat + " " + sub),
      });
    });
    return abnProductArray;
  }

  checkForABNRequired(prodName) {
    let o = this.state.eOrder;
    if (!o || !o.abnProductOther) {
      return false;
    }
    let abn = o.abnProductOther;
    let abnArr = abn ? abn.split(",") : "";
    let exIdx = abnArr.indexOf(prodName);
    if (exIdx > -1) {
      return true;
    }
    return false;
  }

  renderABNProductListAllParts() {
    if (this.state.abnModal) {
      let o = this.state.eOrder;
      if (!o.abnProductOther) {
        o.abnProductOther = "";
      }
      let arr = this.turnPartsIntoABNList();
      return arr.map((p, idx) => {
        return (
          <MDBRow>
            <MDBCol md={8} className="abnPatientInfoParts">
              {p.text}
            </MDBCol>
            <MDBCol md={4} className="abnPatientInfoCheckBoxCol">
              <MDBInput
                className="abnPatientInfoCheckBox"
                label="ABN Required"
                containerClass="smallMargin"
                value={this.checkForABNRequired(p.text)}
                checked={this.checkForABNRequired(p.text)}
                data-tip="ABN Required"
                type="checkbox"
                // disabled={this.state.canEditBasicInfo ? false : true}
                onChange={() => this.addABNProductNew(p)}
                filled
                id={"abnCheckBox" + idx}
              />
            </MDBCol>
          </MDBRow>
        );
      });
    }
  }
  renderABNProductList() {
    if (this.state.abnModal) {
      let o = this.state.eOrder;
      if (!o.abnProductOther) {
        o.abnProductOther = "";
      }
      let arr = o.abnProductOther.split(",");
      return arr.map((p) => {
        return (
          <MDBListGroupItem className="winter-neva-gradient">
            {p}
          </MDBListGroupItem>
        );
      });
    }
  }
  handleABNModalChange(property, e) {
    let o = this.state.eOrder;
    if (property === "abnAmount") {
      o[property] = parseFloat(e.target.value);
    } else {
      o.orderActivityApprovals[0].approvals[property] = e.target.value;
    }
    this.setState({
      eOrder: o,
    });
  }

  toggleABNModal = () => {
    this.setState({
      abnModal: !this.state.abnModal,
    });
  };

  renderAbnModal() {
    let o = this.state.eOrder;
    if (!this.state.abnModal) {
      return;
    }

    return (
      <MDBModal
        className="salesPilotModal"
        isOpen={this.state.abnModal}
        toggle={() => this.toggleABNModal()}
      >
        <MDBModalHeader>ABN</MDBModalHeader>
        <MDBModalBody>
          <div>
            {this.renderABNProductListAllParts()}
            <MDBInput
              className="abnAmount"
              type="number"
              label="ABN Amount"
              outline
              value={o.abnAmount === null ? "" : o.abnAmount.toString()}
              onChange={this.handleABNModalChange.bind(this, "abnAmount")}
            />
            <label className="grey-text">ABN Required Reason</label>
            <textarea
              id="abnreason"
              className="form-control"
              rows="3"
              value={
                o.orderActivityApprovals &&
                o.orderActivityApprovals.length > 0 &&
                o.orderActivityApprovals[0].approvals &&
                o.orderActivityApprovals[0].approvals.abnRequiredNote
                  ? o.orderActivityApprovals[0].approvals.abnRequiredNote
                  : ""
              }
              onChange={this.handleABNModalChange.bind(this, "abnRequiredNote")}
            />
          </div>
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="mdb-color" onClick={() => this.toggleABNModal()}>
            Close
          </MDBBtn>
          <MDBBtn className="successButton" onClick={() => this.saveABN()}>
            Save
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
    );
  }

  saveABN() {
    if (!this.state.eOrder.abnProductOther) {
      this.toggleABNModal();
      this.updateOrder(this.state.eOrder, true);
    } else {
      let abnNote =
          this.state.eOrder.orderActivityApprovals[0].approvals.abnRequiredNote,
        abnAmount = this.state.eOrder.abnAmount;
      if (abnNote && abnNote !== "" && abnAmount) {
        this.toggleABNModal();
        this.updateOrder(this.state.eOrder, true);
      } else {
        return toast.warn("ABN Amount And Note Required");
      }
    }
  }

  renderTabNav() {
    let breadCrumbs = [
      { title: "Home", path: "/dashboard" },
      { title: "Patients", path: "/patient/search" },
      {
        title: this.state.patient.firstName + " " + this.state.patient.lastName,
        path: "",
      },
    ];
    let arrayOfTabs = [];
    let arrayOfActionItems = [
      this.renderCancel(),
      this.renderAddAdditionalParts(),
      this.renderAddDeliveryNoteDropdown(),
      this.renderNewExperienceOption(),
      <MUITooltip
        title={"Please use the new experience for this action."}
        placement="left"
      >
        <span>
          <DropdownItem disabled={true} key={3}>
            Add New Order
          </DropdownItem>
        </span>
      </MUITooltip>,
      <MUITooltip
        title={"Please use the new experience for this action."}
        placement="left"
      >
        <span>
          <DropdownItem key={4} disabled={true}>
            Add A Patient Note
          </DropdownItem>
        </span>
      </MUITooltip>,
      this.state.TabsOneActiveItem === "4" ? null : (
        <MUITooltip
          title={"Please use the new experience for feedback."}
          placement="left"
        >
          <span>
            <DropdownItem key={5} disabled={true}>
              Add Patient Feedback
            </DropdownItem>
          </span>
        </MUITooltip>
      ),
      <MUITooltip
        title={"Please use the new experience for this action."}
        placement="left"
      >
        <span>
          <DropdownItem key={6} disabled={true}>
            Download Patient Feedback
          </DropdownItem>
        </span>
      </MUITooltip>,
      this.renderCreateBTOrderOption(),
      this.state.ticketRecords.length > 0
        ? this.renderReopenTicketOption()
        : null,
      this.state.ticketRecords.length > 0
        ? this.renderToggleTimelineOption()
        : null,
      this.renderPaymentInformationOption(),
      this.renderManualRouteDialogOption(),
    ];

    return (
      <PageHeader
        tabNames={arrayOfTabs}
        TabsOneActiveItem={this.state.TabsOneActiveItem}
        toggle={this.toggle}
        breadCrumbs={breadCrumbs}
        actionItems={arrayOfActionItems}
      ></PageHeader>
    );
  }

  toggleDeliveryNoteModal = () => {
    this.setState({
      deliveryNoteModalOpen: !this.state.deliveryNoteModalOpen,
    });
  };

  createDeliveryNote() {
    let o = this.state.eOrder;

    return OrderService.updateOrder(o)
      .then((res) => {
        if (res.id == -1) {
          toast.error("Patient gender must be set before saving.");
        } else {
          this.toggleDeliveryNoteModal();
          toast.success("Delivery note saved successfully!");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("There was an error saving delivery note.");
      });
  }

  setDeliveryNote(prop, val) {
    let eOrder = this.state.eOrder;

    if (eOrder.hasOwnProperty(prop)) {
      eOrder[prop] = val;
    }

    this.setState({ eOrder: eOrder });
  }

  renderDeliveryNoteModal() {
    if (!this.state.deliveryNoteModalOpen) {
      return;
    }
    let order = this.state.eOrder;
    let o = null;
    let deliveryNotes = null;

    if (this.state.orderRetrieved && order && order !== null) {
      o = order;
      if (o.deliveryNotes && o.deliveryNotes !== null) {
        deliveryNotes = o.deliveryNotes;
      }
    }

    return (
      <div>
        <MDBModal
          centered
          className="salesPilotModal"
          size={"lg"}
          isOpen={this.state.deliveryNoteModalOpen}
          toggle={() => this.toggleDeliveryNoteModal()}
        >
          <MDBModalHeader>Delivery Notes</MDBModalHeader>
          <MDBModalBody>
            <MDBInput
              id="newDeliveryNoteText"
              outline
              placeholder="Add delivery note text here."
              type={"textarea"}
              label={"Delivery Notes"}
              style={{ paddingTop: 8, minHeight: "20vh" }}
              valueDefault={deliveryNotes}
              onChange={(e) =>
                this.setDeliveryNote("deliveryNotes", e.target.value)
              }
            />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn
              size="sm"
              color="red"
              data-tip="Close"
              floating
              onClick={() => this.toggleDeliveryNoteModal()}
            >
              <MDBIcon icon="times" />
            </MDBBtn>
            <MDBBtn
              size="sm"
              floating
              color="green"
              onClick={() => this.updateOrder(o)}
            >
              <MDBIcon icon="check" />
            </MDBBtn>
          </MDBModalFooter>
          <ReactTooltip />
        </MDBModal>
      </div>
    );
  }

  renderCancel() {
    if (
      this.state.TabsOneActiveItem !== "4" ||
      this.state.isOrderDetails ||
      !this.state.curOrder
    ) {
      return null;
    }

    if (this.state.curOrder && this.state.curOrder !== null) {
      if (
        this.state.curOrder.status &&
        this.state.curOrder.status !== null &&
        this.state.curOrder.status.toLowerCase() === "cancelled"
      ) {
        return null;
      }
    }

    return (
      <MUITooltip
        title={"Please use the new experience for this action."}
        placement="left"
      >
        <span>
          <DropdownItem key={1} disabled={true}>
            Cancel Ticket
          </DropdownItem>
        </span>
      </MUITooltip>
    );
  }

  renderAddAdditionalParts() {
    if (
      this.state.TabsOneActiveItem !== "4" ||
      this.state.isOrderDetails ||
      !this.state.curOrder ||
      this.state.curOrder.orderType !== "Service" ||
      (this.state.curOrder.reason !== "Approval" &&
        this.state.curOrder.reason !== "Obtain Documentation" &&
        this.state.curOrder.reason !== "Service - Approval" &&
        this.state.curOrder.reason !== "Service - Obtain Documentation")
    ) {
      return null;
    }
    return (
      <MUITooltip
        title={
          this.canUseOldExperience()
            ? ""
            : "Please use new experience for this action."
        }
        placement="left"
      >
        <span>
          <DropdownItem
            key={2}
            disabled={!this.canUseOldExperience()}
            onClick={() => {
              this.setState({ addAdditionalPartsModal: true });
            }}
          >
            Add Additional Parts
          </DropdownItem>
        </span>
      </MUITooltip>
    );
  }

  renderAddDeliveryNoteDropdown() {
    const isTicketContext =
      this.state.TabsOneActiveItem === "4" &&
      !this.state.isOrderDetails &&
      !!this.state.curOrder;
    const isDisabled = !isTicketContext || !this.canUseOldExperience();

    return (
      <MUITooltip
        title={isDisabled ? "Please use new experience for this action." : ""}
        placement="left"
      >
        <span>
          <DropdownItem
            key={9}
            disabled={isDisabled}
            onClick={() => this.toggleDeliveryNoteModal()}
          >
            View Or Add Delivery Note
          </DropdownItem>
        </span>
      </MUITooltip>
    );
  }

  renderReopenTicketOption() {
    if (
      this.state.TabsOneActiveItem !== "4" ||
      this.state.isOrderDetails ||
      !this.state.curOrder
    ) {
      return null;
    }

    if (this.state.curOrder && this.state.curOrder !== null) {
      if (
        this.state.curOrder.status &&
        this.state.curOrder.status !== null &&
        this.state.curOrder.status.toLowerCase() !== "cancelled"
      ) {
        return null;
      }
    }
    return (
      <MUITooltip
        title={"Please use the new experience for this action."}
        placement="left"
      >
        <span>
          <DropdownItem key={12} disabled={true}>
            Re-Open Ticket
          </DropdownItem>
        </span>
      </MUITooltip>
    );
  }

  renderToggleTimelineOption() {
    if (
      this.state.TabsOneActiveItem !== "4" ||
      this.state.isOrderDetails ||
      !this.state.curOrder
    ) {
      return null;
    }

    return (
      <MUITooltip
        title={"Please use the new experience for this action."}
        placement="left"
      >
        <span>
          <DropdownItem key={14} disabled={true}>
            Toggle Timeline View
          </DropdownItem>
        </span>
      </MUITooltip>
    );
  }

  renderPaymentInformationOption() {
    if (
      this.state.TabsOneActiveItem !== "4" ||
      this.state.isOrderDetails ||
      !this.state.curOrder
    ) {
      return null;
    }
    return (
      <MUITooltip
        title={"Please use the new experience for this action."}
        placement="left"
      >
        <span>
          <DropdownItem key={13} disabled={true}>
            Payment Information
          </DropdownItem>
        </span>
      </MUITooltip>
    );
  }

  renderManualRouteDialog() {
    if (this.state.searchOrderStatusReasonDialogOpen) {
      const handleAdd = (orderStatusReason) => {
        this.statusChanged(orderStatusReason.orderStatus);
        this.updateReason(orderStatusReason.id);
        this.saveStatusReasonChange();
      };
      return (
        <DialogSearchOrderStatusReason
          open={this.state.searchOrderStatusReasonDialogOpen}
          onClose={() =>
            this.setState({ searchOrderStatusReasonDialogOpen: false })
          }
          onSelect={handleAdd}
        />
      );
    } else {
      return null;
    }
  }

  renderManualRouteDialogOption() {
    if (Security.hasPermission("order.manualRoute")) {
      return (
        <MUITooltip
          title={"Please use the new experience for this action."}
          placement="left"
        >
          <span>
            <DropdownItem key={16} disabled={true}>
              Manual Route
            </DropdownItem>
          </span>
        </MUITooltip>
      );
    }

    return null;
  }

  renderNewExperienceOption() {
    const isOnTicketTab = this.state.TabsOneActiveItem === "4";

    const chartPath = isOnTicketTab
      ? `/chart/${this.state?.patient?.id}/order/${this.state?.order?.id}`
      : `/chart/${this.state?.patient?.id}`;

    return (
      <DropdownItem
        key={18}
        onClick={(e) => {
          if (e.ctrlKey || e.metaKey) {
            window.open(chartPath, "_blank");
          } else {
            this.props.history.push(chartPath);
          }
        }}
      >
        Try New Experience
      </DropdownItem>
    );
  }

  renderCreateBTOrderOption() {
    // Legacy patient/order view Brightree sync is intentionally disabled.
    return null;
  }
  syncOrderWithBT(orderId) {
    OrderService.syncOrderWithBT(orderId)
      .then((data) => {
        toast.success("Patient Order Created in Brighttree");
        this.refreshTicket(true);
        return true;
      })
      .catch((err) => {
        toast.error(
          "Oh no! An error occurred while creating the order in Brighttree.",
        );
        return false;
      });
  }

  changeServiceLocation(loc) {
    let sl;

    if (loc == null) {
      sl = null;
    } else {
      sl = {
        id: loc.id,
        name: loc.name,
      };
    }
    this.setState({ serviceLocation: sl });
  }

  changeLocation(val, type) {
    let o = null;

    if (val) {
      o = {
        name: val.name,
        id: val.id,
      };
    }

    this.setState({ [type]: o });
  }

  changeByRef(prop, val) {
    let o = null;

    if (val) {
      o = {
        name: val.name,
        id: val.id,
      };
    }

    this.setAndUpdate(prop, o);
  }

  filterReps() {
    const { salesReps, userprofileLocationsIndexed } = this.context;
    const eOrder = this.state.eOrder;

    if (salesReps && salesReps.length > 0) {
      const filteredSalesReps = salesReps.filter((salesRep) => {
        return Object.values(userprofileLocationsIndexed).some(
          (userprofileLocation) => {
            return (
              userprofileLocation.userprofileId === salesRep.id &&
              userprofileLocation.locationsId === eOrder.salesLocationId
            );
          },
        );
      });

      let selectedSalesRep = salesReps.find((salesRep) => {
        return (
          salesRep.id === eOrder.activity.owner.id ||
          salesRep.id === eOrder.activity.ownerId
        );
      });

      if (selectedSalesRep && !filteredSalesReps.includes(selectedSalesRep)) {
        filteredSalesReps.push(selectedSalesRep);
      }

      if (!selectedSalesRep) {
        selectedSalesRep = eOrder.activity.owner;
        filteredSalesReps.push(selectedSalesRep);
      }

      this.setState({
        filteredReps: filteredSalesReps,
        selectedRep: selectedSalesRep,
        salesReps: salesReps,
      });
    } else {
      this.setState({
        filteredReps: [eOrder.activity.owner],
        selectedRep: eOrder.activity.owner,
      });
    }
  }

  renderTicketSalesLocationDropdown() {
    const { allLocations } = this.context;
    let eOrder = this.state.eOrder;

    let index = allLocations.find((loc) => {
      if (
        this.state.orderRetrieved &&
        eOrder &&
        eOrder !== null &&
        eOrder.salesLocation
      ) {
        return loc.id === eOrder.salesLocation.id;
      } else if (
        this.state.orderRetrieved &&
        eOrder &&
        eOrder !== null &&
        eOrder.salesLocationId
      ) {
        return loc.id === eOrder.salesLocationId;
      } else {
        return null;
      }
    });

    return (
      <MUIGrid item sm="6" xs="12">
        <MUITextField
          fullWidth
          select={true}
          label={"Sales Location"}
          InputLabelProps={{ shrink: true }}
          value={index ? index : ""}
          onChange={(e) => {
            this.changeByRef("salesLocation", e.target.value);
            this.setAndUpdate("salesLocationId", e.target.value.id);
            //this.getSalesRepsByLocation();
            this.filterReps();
          }}
          variant="standard"
        >
          {allLocations.map((option, idx) => {
            return (
              <MUIMenuItem key={idx} value={option}>
                {option.name}
              </MUIMenuItem>
            );
          })}
        </MUITextField>
      </MUIGrid>
    );
  }

  renderTicketBillingLocationDropdown() {
    const { allLocations } = this.context;
    let eOrder = this.state.eOrder;

    let index = allLocations.find((loc) => {
      if (
        this.state.orderRetrieved &&
        eOrder &&
        eOrder !== null &&
        eOrder.billingLocationId
      ) {
        return loc.id === eOrder.billingLocationId;
      }
    });

    return (
      <MUIGrid item sm="6" xs="12">
        <MUITextField
          fullWidth
          select={true}
          label="Billing Location"
          InputLabelProps={{ shrink: true }}
          value={index ? index : ""}
          onChange={(e) => {
            this.changeByRef("billingLocationId", e.target.value);
            this.setAndUpdate("billingLocationId", e.target.value.id);
          }}
          variant="standard"
        >
          {allLocations.map((option, idx) => {
            return (
              <MUIMenuItem key={idx} value={option}>
                {option.name}
              </MUIMenuItem>
            );
          })}
        </MUITextField>
      </MUIGrid>
    );
  }

  renderTicketServiceLocationDropdown() {
    const { allLocations } = this.context;
    let eOrder = this.state.eOrder;

    let index = allLocations.find((loc) => {
      if (
        this.state.orderRetrieved &&
        eOrder &&
        eOrder !== null &&
        eOrder.serviceLocation
      ) {
        return loc.id === eOrder.serviceLocation.id;
      } else if (
        this.state.orderRetrieved &&
        eOrder &&
        eOrder !== null &&
        eOrder.serviceLocationId
      ) {
        return loc.id === eOrder.serviceLocationId;
      } else {
        return null;
      }
    });

    return (
      <MUIGrid item sm="6" xs="12">
        <MUITextField
          fullWidth
          select={true}
          label="Service Location"
          InputLabelProps={{ shrink: true }}
          value={index ? index : ""}
          onChange={(e) => {
            this.changeByRef("serviceLocation", e.target.value);
            this.setAndUpdate("serviceLocationId", e.target.value.id);
          }}
          variant="standard"
        >
          {allLocations.map((option, idx) => {
            return (
              <MUIMenuItem key={idx} value={option}>
                {option.name}
              </MUIMenuItem>
            );
          })}
        </MUITextField>
      </MUIGrid>
    );
  }

  renderSalesLocationDropdown() {
    const { allLocations, salesReps, userprofileLocationsIndexed } =
      this.context;

    const salesRep =
      this.state.accountRecentSalesRep || this.state.accountOwner;

    let availableLocations = allLocations;
    let selectedLocation = null;

    const matchingSalesRep = salesReps.find((salesRepCandidate) => {
      return salesRepCandidate.id === salesRep.id;
    });

    if (matchingSalesRep) {
      const salesRepLocationIds = Object.values(userprofileLocationsIndexed)
        .filter((userprofileLocation) => {
          return userprofileLocation.userprofileId === matchingSalesRep.id;
        })
        .map((userprofileLocation) => userprofileLocation.locationsId);

      availableLocations = internalLocations.filter((location) => {
        return salesRepLocationIds.includes(location.id);
      });
    }

    if (this.state.salesLocation) {
      selectedLocation = availableLocations.find((location) => {
        return location.id === this.state.salesLocation.id;
      });
    }

    if (selectedLocation && !this.state.salesLocation) {
      this.changeLocation(selectedLocation, "salesLocation");
    }

    return (
      <Col size="6">
        <div className={"uiOutlines"}>
          <MUITextField
            id="Sales-Location"
            select
            size="small"
            fullWidth
            label="Sales Location"
            value={selectedLocation ? selectedLocation : ""}
            onChange={(event) => {
              this.changeLocation(event.target.value, "salesLocation");
            }}
            variant="outlined"
          >
            {availableLocations.map((locationOption, index) => {
              return (
                <MUIMenuItem key={index} value={locationOption}>
                  {locationOption.name}
                </MUIMenuItem>
              );
            })}
          </MUITextField>
        </div>
      </Col>
    );
  }

  renderServiceLocationDropdown() {
    const { allLocations, salesReps, userprofileLocationsIndexed } =
      this.context;

    const salesRep =
      this.state.accountRecentSalesRep || this.state.accountOwner;

    let availableLocations = allLocations;
    let currentServiceLocation = this.state.serviceLocation;
    let selectedLocation = null;

    const matchingSalesRep = salesReps.find((salesRepCandidate) => {
      return salesRepCandidate.id === salesRep.id;
    });

    if (currentServiceLocation) {
      selectedLocation = availableLocations.find((location) => {
        return location.id === currentServiceLocation.id;
      });
    } else if (matchingSalesRep) {
      const salesRepLocationIds = Object.values(userprofileLocationsIndexed)
        .filter((userprofileLocation) => {
          return userprofileLocation.userprofileId === matchingSalesRep.id;
        })
        .map((userprofileLocation) => {
          return userprofileLocation.locationsId;
        });

      selectedLocation = availableLocations.find((location) => {
        return salesRepLocationIds.includes(location.id);
      });
    }

    if (selectedLocation && !this.state.serviceLocation) {
      this.changeLocation(selectedLocation, "serviceLocation");
    }

    return (
      <Col size="6">
        <div className={"uiOutlines"}>
          <MUITextField
            id="Service-Location"
            select
            size="small"
            fullWidth
            label="Service Location"
            value={selectedLocation ? selectedLocation : ""}
            onChange={(event) => {
              this.changeLocation(event.target.value, "serviceLocation");
            }}
            variant="outlined"
          >
            {availableLocations.map((locationOption, index) => {
              return (
                <MUIMenuItem key={index} value={locationOption}>
                  {locationOption.name}
                </MUIMenuItem>
              );
            })}
          </MUITextField>
        </div>
      </Col>
    );
  }

  renderPatientProducts() {
    let st = this.state;
    let products = st.patientProducts;
    if (
      this.state.productsForOrderId &&
      this.state.productsForOrderId !== this.state.curOrder.id
    ) {
      this.sortPatientProductsForOrder(products);
    }
    if (!st.patientProductsLoaded) {
      this.getPatientProducts();
      return (
        <Col>
          <div style={{ margin: "auto", display: "table" }}>
            <p>{st.patient.firstName + " " + st.patient.lastName}'s Products</p>
            <div
              style={{ margin: "auto", display: "table" }}
              className="spinner-border text-primary"
              role="status"
            >
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </Col>
      );
    }
    return (
      <Col style={{ marginTop: "5%" }}>
        <label>Patient's Products</label>
        <MDBSelect
          outline
          color="default"
          style={{ maxHeight: "100px", marginTop: "1px" }}
          options={this.state.productsForOrder}
          label
          getValue={(e) => this.handleProductChange(e)}
        />
      </Col>
    );
  }

  sortPatientProductsForOrder(orders) {
    if (this.state.curOrder.id === this.state.productsForOrderId) {
      return;
    }
    let products = orders;
    let productsForOrder = [];

    products.forEach((prod) => {
      if (prod.orderId === this.state.curOrder.id) {
        productsForOrder.push(prod);
      }
    });
    if (productsForOrder.length < 1) {
      this.setState({
        productsForOrder: [],
        productsForOrderId: this.state.curOrderId,
      });
      return;
    }

    let highestPoints = productsForOrder.reduce(function (prev, current) {
      return prev && prev.points > current.points ? prev : current;
    });
    let defaultProd = productsForOrder.findIndex(
      (prod) => prod.value.id === highestPoints.value.id,
    );

    if (this.state.productsAddedList.length < 1) {
      this.setState({
        productsAddedList: [productsForOrder[defaultProd].value],
      });
    }
    productsForOrder[defaultProd].checked = true;
    this.setState({
      productsForOrder: productsForOrder,
      productsForOrderId: this.state.curOrderId,
    });
  }
  getPatientProducts() {
    if (this.state.patientProductsLoading) {
      return;
    }
    this.setState({ patientProductsLoading: true });
    let arr = [];
    return PatientOrders.getPatientOrders(this.state.id)
      .then((res) => {
        if (res.length > 0) {
          res.map((resp) => {
            if (
              resp.orderType === "New" &&
              resp.orderActivityProducts &&
              resp.orderActivityProducts.length > 0
            ) {
              resp.orderActivityProducts.map((pr) => {
                if (pr.products) {
                  let s = pr.products.serial ? " - " + pr.products.serial : "";
                  return arr.push({
                    text:
                      (pr.products.productType
                        ? pr.products.productType.name
                        : "") +
                      " - " +
                      (pr.products.productSubType
                        ? pr.products.productSubType.name
                        : "") +
                      s,
                    value: pr.products,
                    orderId: resp.id,
                    points: pr.products.points,
                  });
                }
                return null;
              });
            }

            return null;
          });
        } else {
          arr.push({
            text: "No products found",
            value: "product",
            disabled: true,
          });
          this.setState({
            patientProducts: arr,
            patientProductsLoaded: true,
          });
        }

        this.setState(
          {
            patientProducts: arr,
            patientProductsLoaded: true,
          },
          this.sortPatientProductsForOrder(arr),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleProductChange(product) {
    if (
      (!product || product.length === 0) &&
      this.state.productsAddedList.length === 0
    ) {
      return;
    }
    this.setState({
      productsAddedList: product,
    });
  }

  getCategoryList() {
    const { productTypes } = this.context;
    let a = [];

    productTypes.map((productType) => {
      return a.push({
        label: productType.name,
        value: productType.id,
      });
    });
    return a;
  }

  getProductList() {
    const { productSubTypes } = this.context;
    let a = [];
    let cc = this.state.chosenCategory;
    if (cc && Object.keys(cc).length !== 0) {
      productSubTypes.map((product) => {
        if (product.productType.name === cc.label) {
          let h = product.hcpcs !== null ? " | " + product.hcpcs : "";
          let l = product.name + h;
          return a.push({
            label: l,
            value: product,
          });
        }
        return null;
      });
    } else {
      productSubTypes.map((product) => {
        let h = product.hcpcs !== null ? " | " + product.hcpcs : "";
        let l = product.productType.name + " | " + product.name + h;
        return a.push({
          label: l,
          value: product,
        });
      });
    }
    return a;
  }

  handleProductSelectChange = (e, product) => {
    if (product) {
      delete product.value.deleted;
      delete product.value.deletedById;
      delete product.value.deletedAt;
      this.setState({
        productAdded: product.value,
      });
      this.addNewProduct(product.value);
    } else {
      this.setState({
        productAdded: null,
      });
      this.addNewProduct(null);
    }
  };

  addNewProduct = (productAdded) => {
    // if (!productAdded) {
    //     return this.state.nOrder.orderActivityProducts = []
    // }
    if (!productAdded) {
      let o = this.state.nOrder;
      o.orderActivityProducts = [];
      return this.setState({
        nOrder: o,
      });
    }
    const { currentUser, productTypes, productOverrides } = this.context;
    let o = this.state.nOrder,
      np = {
        abnRequired: false,
        approved: false,
        hcpcs: productAdded.hcpcs || "",
        productSubTypeId: productAdded.id,
        productSubType: productAdded,
        productTypeId: productAdded.productType.id,
        productType: {
          id: productAdded.productType.id,
          name: productAdded.productType.name,
        },
        points: 0.0,
        qty: 1,
        serial: "",
        amount: 0,
        updatedOn: new Date().toISOString(),
        updatedById: currentUser.id,
        updatedBy: { id: currentUser.id, name: currentUser.username },
      };

    let found = false,
      insuranceID = this.state.patient.insuranceType.id,
      insuranceMatrix = [],
      correctProduct;
    let productAddedID = productAdded.productType.id;

    for (let p of productTypes) {
      if (p.id === productAddedID) {
        correctProduct = p;
        break;
      }
    }

    if (
      productAdded &&
      productAdded.overridePoints &&
      productAdded.overridePoints.length > 0
    ) {
      let f = productOverrides.filter((pro) => {
        return (
          pro.insuranceTypeId === insuranceID &&
          pro.productSubTypeId === productAdded.id
        );
      });
      if (f.length > 0) {
        np.points = f[0].points;
        found = true;
      }
    }
    if (
      correctProduct &&
      found === false &&
      correctProduct.insuranceMatrixEntry &&
      correctProduct.insuranceMatrixEntry.length > 0
    ) {
      insuranceMatrix = correctProduct.insuranceMatrixEntry;
      for (let i of insuranceMatrix) {
        if (i.insuranceType.id === insuranceID) {
          np.points = i.points;
          break;
        }
      }
    }

    o.orderActivityProducts = [{ products: np }];
    this.setState({
      nOrder: o,
      productsAddedList: np,
    });
  };

  renderProductDropdown() {
    return (
      <Col size="6">
        <div className={"uiOutlines"}>
          <Select
            placeholder={"Product..."}
            options={this.getProductList()}
            onChange={this.handleProductSelectChange.bind(this)}
          />
        </div>
      </Col>
    );
  }

  handleCategoryChange = (e, category) => {
    if (category) {
      this.setState({
        chosenCategory: category,
      });
    } else {
      this.setState({
        chosenCategory: null,
      });
    }
  };

  renderCategoryDropdown() {
    return (
      <Col size="6">
        <div className={"uiOutlines"}>
          <Select
            placeholder={"Category..."}
            options={this.getCategoryList()}
            onChange={this.handleCategoryChange.bind(this)}
          />
        </div>
      </Col>
    );
  }

  renderCreateOrderRoute() {
    return (
      <Route
        render={({ history }) => (
          <div>
            <Button
              disabled={this.state.disableCreate}
              color={"success"}
              rounded
              size="sm"
              data-tip={"Create Order"}
              onClick={() => this.createOrder()}
            >
              <Fa size="2x" icon={"check"}>
                {" "}
              </Fa>
            </Button>
          </div>
        )}
      />
    );
  }

  removeProduct(idx) {
    let no = this.state.nOrder,
      op = no.orderActivityProducts;

    op.splice(idx, 1);
    this.setState({
      nOrder: no,
    });
  }

  renderOrderProductsList() {
    let op = this.state.nOrder.orderActivityProducts
      ? this.state.nOrder.orderActivityProducts.map((x) => x.products)
      : [];

    if (op.length === 0) {
      return;
    }

    return (
      <div style={{ paddingTop: 6 }}>
        <span style={{ fontWeight: "bold" }}> Products </span>

        <MDBRow>
          {op.map((p, idx) => {
            return (
              <MDBCol size={12} key={idx}>
                <span>{p.productType.name}</span> &nbsp; &nbsp;
                <span>{p.productSubType.name}</span>
                <MDBIcon
                  style={{ color: "red", float: "right" }}
                  icon={"trash"}
                  onClick={() => this.removeProduct(idx)}
                  data-tip={"Remove"}
                />
              </MDBCol>
            );
          })}
        </MDBRow>
        <ReactTooltip />
      </div>
    );
  }

  renderNewOrderStuff() {
    if (this.state.selectedOrderTypeRadio === 0) {
      return (
        <MDBRow>
          {this.renderCategoryDropdown()}
          {this.renderProductDropdown()}
        </MDBRow>
      );
    }
  }

  renderOrderProducts() {
    if (this.state.selectedOrderTypeRadio === 0) {
      return this.renderOrderProductsList();
    }
  }

  handleRadioChange = (value, type) => () => {
    let rb = this.state.radio;
    rb[type] = value;

    this.setState({
      radio: rb,
      radioBtnSelected: true,
    });
  };

  handleRadioChangeQueueRoute(value, type) {
    let rb = this.state.radio;
    rb[type] = value.id || value;

    rb.queueRoutingSubType = "";

    this.setState({
      radio: rb,
      radioBtnSelected: true,
      selectedSubTypeFromQueueRoute: null,
    });
  }

  handleRadioChangeSubType(value, type) {
    let rb = this.state.radio;
    if (rb[type] === value) {
      rb[type] = "";
    } else {
      rb[type] = value;
    }

    this.setState({
      radio: rb,
      radioBtnSelected: true,
      serviceReason: value,
      selectedSubTypeFromQueueRoute: value,
    });
  }

  setValue(value) {
    this.setState({
      createTicketNote: value.trimStart(),
    });
  }

  getIDs() {
    const { companyName } = this.context;
    if (companyName !== "corkmedical") {
      let arr = [];
      let products = this.state.serviceOrderProducts;
      if (products.length > 0) {
        products.forEach((product, index) => {
          arr.push(this.getProductsDetails(product, index));
        });
      }
    }
  }

  getOrderProductsList() {
    if (!this.state.curOrderId) {
      return;
    }
    if (this.state.servicePartsLoading || this.state.servicePartsLoaded) {
      return;
    }
    this.setState({
      servicePartsLoading: true,
    });
    OrderService.getOrderActivity(this.state.curOrderId)
      .then((ord) => {
        if (ord.id !== this.state.curOrderId) {
          return;
        }
        this.setState({
          orderActivityFull: ord,
          orderDetailProducts: ord.orderActivityProducts.map((x) => x.products),
        });
        this.getServiceQuoteByOrder(this.state.curOrderId);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getServiceQuoteByOrder() {
    if (this.state.curOrderId == null || this.state.curOrderId === "") {
      return;
    }

    partsService
      .getServiceOrderProductsByOrder(this.state.curOrderId)
      .then((r) => {
        partsService
          .getAllParts()
          .then((r) => {
            this.setState({
              allServiceParts:
                r && r.length > 0 ? r.filter((x) => x.deleted !== true) : [],
            });
          })
          .catch((e) => {
            console.log(e);
          });

        flushSync(() => {
          // PATCH
          this.setState({
            servicePartsLoading: false,
            serviceOrderProducts: r,
            orderRetrieved: true,
            servicePartsLoaded: true,
          });
        });
        this.getIDs();
        this.getApprovalsByOrder();
      })
      .catch((e) => {
        console.log(e);
        this.setState({});
      });
  }

  retrieveNotes(id) {
    let orderId = id ? id : this.state.curOrderId;
    this.setState({
      orderNotesLoading: true,
    });
    NoteService.getNotes(orderId)
      .then((notes) => {
        let no = notes;

        if (no === null || no.length === 0) {
          //we have no notes, return...BC
          this.setState({ orderNotes: [], orderNotesLoaded: true });
          return;
        }
        //copy the notes array...BC
        let con = no.slice();
        //sort the notes...BC
        con.sort((a, b) => {
          if (a.createdAt > b.createdAt) {
            return -1;
          } else {
            return 1;
          }
        });

        //set the state for notes...BC
        this.setState({
          orderNotes: con,
          orderNotesLoaded: true,
          orderNotesLoading: false,
        });
      })
      .catch(() => {});
  }

  getOrderProducts(id) {
    OrderService.getOrderProducts(id)
      .then((data) => {
        this.setState({
          orderProducts: data,
          orderApprovalsLoaded: true,
          orderApprovalsLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getApprovalsByOrder(id) {
    let orderId = id ? id : this.state.curOrderId;
    this.setState({
      orderApprovalsLoading: true,
    });
    if (!this.state.orderRetrieved) {
      if (!this.state.servicePartsLoading) {
        this.getOrderProductsList();
      }
      return this.renderLoadingSpinner();
    }

    let data = this.state.orderActivityFull;

    this.changeLocation(data.salesLocation, "salesLocation");
    this.changeLocation(data.serviceLocation, "serviceLocation");
    this.setState(
      {
        order: data,
        eOrder: JSON.parse(JSON.stringify(data)),
      },
      () => {
        this.getOrderProducts(orderId);
      },
    );
  }

  saveStatusReasonChange(addPart, noteToAdd) {
    if (addPart) {
      // this.addPartForDeliveryAndAuthorize(addPart);
    } else {
      let obj = this.state.eOrder;

      this.updateOrder(obj, null, noteToAdd);
    }
  }

  updateParentObject(obj) {
    this.setState({
      eOrder: obj,
    });
  }

  renderApprovalInformation() {
    if (
      !this.state.orderApprovalsLoading &&
      !this.state.orderApprovalsLoaded &&
      this.state.curOrderId
    ) {
      this.setState(
        {
          orderApprovalsLoading: true,
        },
        () => {
          this.getApprovalsByOrder();
        },
      );
    }
    if (!this.state.orderApprovalsLoaded) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MDBSpinner></MDBSpinner>
        </div>
      );
    }
    return (
      <ApprovalSummary
        order={this.state.eOrder}
        products={this.state.orderProducts}
      />
    );
  }

  addNoteUpdateOrderCloseModal(note, order) {}

  toggleNoteModalPopup() {
    let currentState = this.state.noteModalOpen;

    // this.setState({
    //     this.state.patient.account.owner
    // })
    this.setState({ noteModalOpen: !currentState });
    if (currentState === true) {
      this.setState({
        noteText: "",
        isUpdating: false,
      });
    }
  }

  toggleProcessing() {
    this.setState({
      saveProcessStarted: true,
    });
  }

  async handleNeedsRedelivery() {
    return new Promise((res, rej) => {
      this.setAndUpdate("needsRedelivery", true);
      this.setAndUpdate("scheduledDeliveryDate", null);
      this.setAndUpdate("setupDate", null);
      res(true);
    });
  }

  async addFollowupDate() {
    const selectedQueueRoute =
      this.context.queueRoutesIndexed?.[this.state.radio.queueRouting];

    let dt = new Date();
    if (selectedQueueRoute.toOrderStatusReasonId === 57) {
      // Service - Documentation Followup
      dt.setDate(dt.getDate() + 3);
    } else {
      dt.setDate(dt.getDate() + 7);
    }

    // Adjust for weekends
    if (dt.getDay() === 6) {
      dt.setDate(dt.getDate() + 1);
    }
    if (dt.getDay() === 0) {
      dt.setDate(dt.getDate() + 1);
    }
    return new Promise((res, rej) => {
      this.setAndUpdate("followUpDate", dt);
      res(true);
    });
  }

  async generateApprovalNote(fromPartAdd, order, fromPickup) {
    return new Promise((res, rej) => {
      const { currentUser, productTypes, productSubTypes } = this.context;

      let st = this.state,
        noteText = "",
        listForPickup = st.orderDetailProducts,
        list = st.orderProducts.filter((p) => {
          return p.approved;
        }),
        listService = st.serviceOrderProducts,
        cb = { id: currentUser.id, name: currentUser.username },
        currentNotes = st.notes,
        eOrder = st.eOrder,
        totalPoints = 0;

      if (order) {
        eOrder = order;
      }
      let appr = eOrder.orderActivityApprovals[0]
          ? eOrder.orderActivityApprovals[0].approvals
          : null,
        preAuth = appr.authNumber ? appr.authNumber.trim() : null;

      if (fromPartAdd) {
        noteText =
          currentUser.firstname +
          " " +
          currentUser.lastname +
          " approved order " +
          this.state.order.id +
          (preAuth
            ? " With Preauth : " + preAuth + " "
            : " (Pre-Auth not required) on  ") +
          moment().format("MMMM Do YYYY, h:mm a") +
          " for the following products : ";
        //TODO check if this was removed or ifit was forgotten
        eOrder.preAuthRequired = false;
      } else if (this.state.radio.preAuthAction === "approveWithoutAuth") {
        noteText =
          currentUser.firstname +
          " " +
          currentUser.lastname +
          " approved order " +
          this.state.order.id +
          " and sent to Pre-Auth follow up for authorization on " +
          moment().format("MMMM Do YYYY, h:mm a") +
          " for the following products : ";
        //   eOrder.preAuthRequired = true;
      } else if (
        this.state.radio.preAuthAction === "approveAuthNotRequired" ||
        fromPickup
      ) {
        noteText =
          currentUser.firstname +
          " " +
          currentUser.lastname +
          " approved order " +
          this.state.order.id +
          " (Pre-Auth not required) on " +
          moment().format("MMMM Do YYYY, h:mm a") +
          " for the following products : ";
      } else {
        noteText =
          currentUser.firstname +
          " " +
          currentUser.lastname +
          " approved order " +
          this.state.order.id +
          " with Auth Number " +
          preAuth +
          " on " +
          moment().format("MMMM Do YYYY, h:mm a") +
          " for the following products : ";
      }

      if (fromPartAdd && fromPartAdd.length > 0) {
        list = [];
        listService = [];
        list = fromPartAdd.map((product) => {
          return product.products ? product.products : product;
        });
      }
      list.forEach((product) => {
        var pt = product.productTypeId
          ? productTypes.filter((x) => x.id === product.productTypeId)[0]
              .name || ""
          : product.name
            ? product.name
            : "";
        var pst = product.productSubTypeId
          ? productSubTypes.filter((x) => x.id === product.productSubTypeId)[0]
              .name || ""
          : product.itemId
            ? product.itemId
            : "";
        totalPoints += parseFloat(product.points ? product.points : 0);
        noteText += product.qty + " " + pt + " " + pst + " | ";
      });
      if (this.state.order && this.state.order.orderType === "Pickup") {
        if (listForPickup.length > 0) {
          let products = [];
          eOrder.orderActivityProducts.forEach((product) => {
            product.products.approved = true;
            products.push(product);
          });
          eOrder.orderActivityProducts = products;
          listForPickup.forEach((product) => {
            var pt = product.productType ? product.productType.name || "" : "";
            var pst = product.productSubType
              ? product.productSubType.name || ""
              : "";
            totalPoints += parseFloat(product.points);
            noteText += product.qty + " " + pt + " " + pst + " | ";
          });
        }
      } else if (listService.length > 0) {
        listService.forEach((product) => {
          var pt = product.name ? product.name : "";
          var pst = product.itemId ? product.itemId : "";
          var hcpcs = product.hcpcs ? product.hcpcs : "";
          totalPoints += parseFloat(product.points);
          noteText +=
            product.qty + " " + pt + " " + pst + " - " + hcpcs + " | ";
        });
      }

      let note = {
        type: "ActivityNote",
        text: noteText,
        createdAt: GlobalFunctions.getUTCMoment(),
        account: eOrder.activity.account,
        accountId: eOrder.activity.accountId,
        task: false,
        completed: true,
        createdBy: cb,
        createdById: cb.id,
        patientName: eOrder.patientName,
        activityId: eOrder.id,
      };

      NoteService.createActivityNote(eOrder.id, note)
        .then((res) => {
          currentNotes.unshift(res);
        })
        .catch((err) => {
          console.log(err);
        });

      //TODO investigate why this was setting status reasons
      //    if (!fromPartAdd){
      //        eOrder.status = 2; //"ReadyToDeliver";
      //        eOrder.orderStatusReason = null;
      //        eOrder.orderStatusReasonId = null;
      //    }
      //    if (eOrder.orderType.toLowerCase() === "pickup") {
      //        eOrder.orderStatusReasonId = 41;
      //    }

      if (!eOrder.approvalDate) {
        eOrder.approvalDate = new Date();
      }

      eOrder.points = totalPoints;
      eOrder.isApproved = true;
      this.setState({ eOrder: eOrder });
      if (!fromPartAdd && this.state.approvalModalOpen) {
        this.handleSubmitRouteChange("fromNote");
        this.toggleApprovalModalPopup();
      }
      res(true);
    });
  }

  renderOrderDetailsNotes() {
    if (
      !this.state.orderNotesLoading &&
      !this.state.orderNotesLoaded &&
      this.state.curOrderId
    ) {
      this.retrieveNotes();
    }
    if (!this.state.orderNotesLoaded) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MDBSpinner></MDBSpinner>
        </div>
      );
    }

    if (this.state.orderNotes.length === 0) {
      return (
        <div>
          <MDBRow style={{ marginBottom: ".5rem", marginTop: ".5rem" }}>
            <MUITooltip
              title={
                this.canUseOldExperience()
                  ? ""
                  : "Please use new experience to add notes"
              }
              placement="top"
            >
              <span style={{ width: "100%" }}>
                <MDBBtn
                  size="large"
                  className="addNoteBtnFull"
                  disabled={!this.canUseOldExperience()}
                  onClick={() => {
                    this.setState({
                      isAutoVerification: false,
                      radio: {
                        approvalAction: "",
                        serviceTicketAction: "",
                        pickupTicketAction: { label: "", value: "" },
                      },
                    });
                    this.toggleNoteModalPopup();
                  }}
                >
                  Add Note
                </MDBBtn>
              </span>
            </MUITooltip>
          </MDBRow>
          <MDBRow>
            <MDBCol>
              <div
                style={{
                  display: "flex",
                  marginTop: ".5rem",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                No Data
              </div>
            </MDBCol>
          </MDBRow>
        </div>
      );
    }
    return (
      <MUIBox style={{ FullWidth: true }}>
        <MDBRow>
          <MUITooltip
            title={
              this.canUseOldExperience()
                ? ""
                : "Please use new experience to add notes"
            }
            placement="top"
          >
            <span
              style={{ width: "100%", marginTop: "1rem", marginBottom: "1rem" }}
            >
              <MDBBtn
                size="large"
                className="addNoteBtnFull"
                disabled={!this.state.eOrder || !this.canUseOldExperience()}
                onClick={() => {
                  this.setState({
                    isAutoVerification: false,
                    radio: {
                      approvalAction: "",
                      serviceTicketAction: "",
                      pickupTicketAction: { label: "", value: "" },
                    },
                  });
                  this.toggleNoteModalPopup();
                }}
              >
                Add Note
              </MDBBtn>
            </span>
          </MUITooltip>
        </MDBRow>
        <NotesTab
          getNotes={() => this.retrieveNotes(this.state.curOrderId)}
          allNotes={this.state.orderNotes}
          eOrder={this.state.eOrder}
          fullWidth={true}
          toggleNoteModalPopup={() => this.toggleNoteModalPopup()}
          isOrderDetails={true}
        />
      </MUIBox>
    );
  }

  renderAttachments() {
    if (
      !this.state.orderAttachmentsLoading &&
      !this.state.orderAttachmentsLoaded &&
      this.state.curOrderId
    ) {
      return (
        <AttachmentsTab
          minimal={true}
          disableDelete={true}
          disableAttachmentUpload={!this.canUseOldExperience()}
          eOrder={{
            patient: this.state.patient,
            id: this.state.curOrderId,
            activity: { files: null },
          }}
          curOrder={this.state.curOrder}
          isOrderDetails={true}
          updateParent={this.updateParentObject.bind(this)}
          savePatient={this.savePatient.bind(this)}
        />
      );
    }
    if (!this.state.orderAttachmentsLoaded) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MDBSpinner></MDBSpinner>
        </div>
      );
    }
  }

  togglePills = (type, tab) => (e) => {
    e.preventDefault();
    if (this.state.items[type] !== tab) {
      let items = { ...this.state.items };
      items[type] = tab;
      this.setState({
        items,
      });
    }
  };
  buildApprovedPartItem(partType) {
    const { currentUser } = this.context;
    let productSubTypeId = null;

    if (partType === "techSkilled") {
      productSubTypeId = 1963;
    } else if (partType === "30day") {
      productSubTypeId = 70;
    } else if (partType === "fieldService") {
      productSubTypeId = 1964;
    } else if (partType === "atp30day") {
      productSubTypeId = 2156;
    } else if (partType === "atpService") {
      productSubTypeId = 1041;
    }

    return {
      abnRequired: false,
      amount: 0,
      approved: true,
      hcpcs: partType ? "na" : "NB",
      isRental: false,
      orderActivityProducts: { orderActivityId: this.state.curOrder.id },
      points: 0,
      productSubTypeId,
      productTypeId: 27,
      qty: 1,
      serial: "",
      updatedById: currentUser.id,
      updatedOn: new Date().toISOString(),
    };
  }

  async addPartForDeliveryAndAuthorize(val) {
    return new Promise((resu, rej) => {
      const newItem = this.buildApprovedPartItem(val);

      OrderService.updateOrderProducts(this.state.curOrder.id, [newItem])
        .then((res) => {
          if (res) {
            let order = this.state.eOrder;
            OrderService.getOrderActivity(order.id)
              .then((res) => {
                order.orderActivityProducts = res.orderActivityProducts;
                this.generateApprovalNote(
                  res.orderActivityProducts,
                  order,
                ).then((result) => {
                  resu(result);
                });

                // this.updateOrder(order, true)
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            toast.warn("There was an issue updating the products.");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  setAndUpdate(prop, val, updateOrderOnly) {
    const isOrderCustomClinicalInformation = [
      "name",
      "address",
      "city",
      "state",
      "postal_code",
      "phone_number",
      "fax_number",
      "npi",
    ].includes(prop);

    if (val && val.toString() === "Invalid date") {
      val = null;
    }
    let eOrder = this.state.eOrder;

    if (eOrder.orderingProviderNotFound && isOrderCustomClinicalInformation) {
      let existingData = {};

      try {
        if (eOrder.jsonOrderingProviderNotFoundData) {
          existingData = JSON.parse(eOrder.jsonOrderingProviderNotFoundData);
        }
      } catch (err) {
        console.warn("Failed to parse jsonOrderingProviderNotFoundData:", err);
        existingData = {};
      }

      if (val !== null && val !== undefined && val !== "") {
        existingData[prop] = val;
      } else {
        delete existingData[prop];
      }

      if (Object.keys(existingData).length > 0) {
        eOrder.jsonOrderingProviderNotFoundData = JSON.stringify(existingData);
      } else {
        delete eOrder.jsonOrderingProviderNotFoundData;
      }

      eOrder.orderingProviderData = existingData;
    }

    if (eOrder.hasOwnProperty(prop)) {
      eOrder[prop] = val;
    }

    if (eOrder.activity.hasOwnProperty(prop)) {
      eOrder.activity[prop] = val;
    }

    if (!updateOrderOnly && eOrder.patient.hasOwnProperty(prop)) {
      eOrder.patient[prop] = val;
    }

    this.updateParentObject(eOrder);
  }

  updateReason(v) {
    const { reasons } = this.context;

    this.setState({
      statusOrReasonChange: true,
    });

    if (v) {
      let r = reasons.find((o) => {
        return v === o.id;
      });
      if (r) {
        let q = {
          id: r.id,
          description: r.description,
        };
        this.setAndUpdate("orderStatusReason", q);
        this.setAndUpdate("orderStatusReasonId", q.id);
      }
    } else {
      this.setAndUpdate("orderStatusReason", null);
      this.setAndUpdate("orderStatusReasonId", null);
    }
  }

  statusChanged(v) {
    this.setState({
      statusOrReasonChange: true,
    });

    let eOrder = this.state.eOrder;

    eOrder.orderStatusReason = null;
    eOrder.orderStatusReasonId = null;
    if (v === 3 && eOrder.setupDate === null) {
      eOrder.setupDate = new Date().toISOString();
    }

    this.setAndUpdate("status", v);
  }

  getProductsDetails(product, index) {
    const { companyName } = this.context;
    if (companyName !== "corkmedical") {
      let a = [];

      a.push({
        text: "N/A",
        value: "N/A",
      });

      if (product.hcpcs && product.hcpcs.length > 0) {
        BtProductService.getBtProductsByHcpcs(product.hcpcs)
          .then((res) => {
            res.map((t) => {
              return a.push({
                text: t,
                value: t,
                selected: res.length === 1,
              });
            });

            if (a.length < 1) {
              a[0].selected = true;
            }
            let productList = this.state.idNames;
            productList[index] = a;
            this.setState({
              idNames: productList,
            });
          })
          .catch((err) => {
            console.log(err);
            return a.push({
              text: "N/A",
              value: "N/A",
            });
          });
      } else {
        let productList = this.state.idNames;
        productList[index] = a;
        this.setState({
          idNames: productList,
        });
      }
    }
  }

  renderABNButton() {
    const orderStatusReasonId = this.state.curOrder?.orderStatusReasonId;
    const orderStatusReasonDescription =
      this.state.curOrder?.orderStatusReason?.description ||
      this.state.eOrder?.orderStatusReason?.description ||
      "";
    const billingIssueAccessoryAfterSale =
      (
        this.state.curOrder?.orderType ||
        this.state.eOrder?.orderType ||
        ""
      ).toLowerCase() === "billing issue" &&
      (
        this.state.curOrder?.serviceReason ||
        this.state.eOrder?.serviceReason ||
        this.state.curServiceOrderReason?.serviceReason ||
        ""
      )
        .trim()
        .toLowerCase() === "new accessory after the sale";
    const isQuoteWorkflowQueue =
      orderStatusReasonId === 72 ||
      /need part number/i.test(orderStatusReasonDescription || "") ||
      billingIssueAccessoryAfterSale;

    if (
      !isQuoteWorkflowQueue ||
      !this.state.serviceOrderProducts ||
      this.state.serviceOrderProducts.length < 1
    ) {
      return null;
    }

    return (
      <MDBRow style={{ padding: "0 1.6rem" }}>
        <MDBCol size={"3"}>
          <MDBBtn
            style={{ marginTop: "1rem" }}
            size="sm"
            className="addNoteBtnFull addPartsBtn"
            onClick={() =>
              this.setState({
                abnModal: !this.state.abnModal,
              })
            }
            disabled={
              this.state.servicePartsLoading ||
              (this.state.serviceOrderProducts &&
                this.state.serviceOrderProducts.length < 1)
            }
          >
            ABN Info
          </MDBBtn>
        </MDBCol>
      </MDBRow>
    );
  }

  renderAddServicePartButton() {
    const orderStatusReasonId = this.state.curOrder?.orderStatusReasonId;
    const orderStatusReasonDescription =
      this.state.curOrder?.orderStatusReason?.description ||
      this.state.eOrder?.orderStatusReason?.description ||
      "";
    const billingIssueAccessoryAfterSale =
      (
        this.state.curOrder?.orderType ||
        this.state.eOrder?.orderType ||
        ""
      ).toLowerCase() === "billing issue" &&
      (
        this.state.curOrder?.serviceReason ||
        this.state.eOrder?.serviceReason ||
        this.state.curServiceOrderReason?.serviceReason ||
        ""
      )
        .trim()
        .toLowerCase() === "new accessory after the sale";
    const isQuoteWorkflowQueue =
      orderStatusReasonId === 72 ||
      /need part number/i.test(orderStatusReasonDescription || "") ||
      billingIssueAccessoryAfterSale;
    if (!isQuoteWorkflowQueue) {
      return;
    }

    if (this.state.createQuoteSmall) {
      return (
        <MDBRow style={{ padding: "0 1.6rem" }}>
          <MDBCol size={"3"}>
            <MDBBtn
              style={{ marginTop: "1rem" }}
              size="sm"
              className="addNoteBtnFull addPartsBtn"
              onClick={() =>
                this.setState({
                  createQuoteSmall: !this.state.createQuoteSmall,
                })
              }
              disabled={this.state.servicePartsLoading}
            >
              Reopen Quote
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      );
    }

    const hasValidProvider = () => {
      if (this.state.eOrder?.orderingProviderId) {
        return true;
      }

      if (this.state.eOrder?.orderingProviderNotFound) {
        try {
          const providerData = JSON.parse(
            this.state.eOrder.jsonOrderingProviderNotFoundData,
          );
          const npi = providerData.npi;
          const providerName = providerData.name;
          const isValidNpi = npi?.length === 10 && /^\d+$/.test(npi);
          const isValidName = providerName.trim().length > 0;
          return isValidNpi && isValidName;
        } catch {
          return false;
        }
      }

      return false;
    };

    const getTooltipMessage = () => {
      if (!hasValidProvider()) {
        if (this.state.eOrder?.orderingProviderNotFound) {
          try {
            const providerData = JSON.parse(
              this.state.eOrder.jsonOrderingProviderNotFoundData,
            );
            const npi = providerData.npi;
            const isValidNpi = npi?.length === 10 && /^\d+$/.test(npi);

            if (!providerData.name?.trim() && !npi) {
              return "Provider name and valid NPI required before adding parts";
            }
            if (!providerData.name?.trim()) {
              return "Provider name required before adding parts";
            }
            if (!isValidNpi) {
              return "Valid NPI required before adding parts";
            }
          } catch {
            return "Provider name and valid NPI required before adding parts";
          }
        }
        return "Ordering provider required before adding parts";
      }
      return "";
    };

    const isDisabled =
      this.state.servicePartsLoading ||
      !this.state.baseUnitLoaded ||
      !hasValidProvider();

    return (
      <MDBRow style={{ padding: "0 1.6rem" }}>
        <MDBCol size={"10"}></MDBCol>
        <MDBCol>
          <MUITooltip title={getTooltipMessage()} placement="right">
            <span>
              <MDBBtn
                style={{ marginTop: "1rem" }}
                size="sm"
                className="addNoteBtnFull addPartsBtn"
                onClick={() => this.toggleAddServicePartsModal()}
                disabled={isDisabled}
              >
                Add Parts
              </MDBBtn>
            </span>
          </MUITooltip>
        </MDBCol>
      </MDBRow>
    );
  }

  renderServiceTicketParts() {
    if (
      this.state.curOrder &&
      this.state.curOrder.orderType &&
      this.state.curOrder.orderType.toLowerCase() === "pickup"
    ) {
      return;
    }

    if (!this.state.orderRetrieved) {
      if (!this.state.servicePartsLoading) {
        this.getOrderProductsList();
      }
      return this.renderLoadingSpinner();
    }
    return this.renderProductsList();
  }

  renderServiceTicketGenericParts() {
    if (!this.state.orderRetrieved) {
      return;
      // return this.renderLoadingSpinner()
    }
    return this.renderGenericParts();
  }

  getMaxBillableForLineItem(itemId) {
    if (!this.state.allServiceParts) {
      return 0;
    }
    if (itemId === 6128) {
      return 0;
    }
    // if (itemId === 1) { return 2 }
    let serviceParts = this.state.allServiceParts;
    let fullQuoteItems = [];

    let fullItem = serviceParts.find((part) => part.id === itemId);
    if (fullItem) {
      fullQuoteItems.push(fullItem);
    }
    let maxBillableLaborUnits = this.findMaxBillableUnits(fullQuoteItems);
    return maxBillableLaborUnits;
  }
  findMaxBillableUnits(items) {
    if (!items) {
      return;
    }

    const { productSubTypes } = this.context;
    let totalMaxBill = 0;
    let hcpcs = items.map((item) => {
      return item.hcpc.replace(/\s/g, "");
    });
    let pairedHcpcsLabor = [];
    productSubTypes.forEach((subtype) => {
      if (hcpcs.includes(subtype.hcpcs)) {
        pairedHcpcsLabor.push({
          hcpcs: subtype.hcpcs,
          laborUnits: subtype.maxBillableLaborUnits
            ? subtype.maxBillableLaborUnits
            : 0,
        });
      }
    });
    if (pairedHcpcsLabor.length < 1) {
      return 0;
    }

    let groupedHcpcs = Object.values(
      Object.groupBy(pairedHcpcsLabor, ({ hcpcs }) => hcpcs),
    );

    groupedHcpcs.forEach((group) => {
      let frequency = {},
        max = 0;
      for (var v in group) {
        frequency[group[v].laborUnits] =
          (frequency[group[v].laborUnits] || 0) + 1;
        if (frequency[group[v].laborUnits] > max) {
          max = frequency[group[v].laborUnits];
        }
      }
      totalMaxBill =
        totalMaxBill +
        parseInt(
          Object.keys(frequency).reduce((a, b) =>
            frequency[a] > frequency[b] ? a : b,
          ),
        );
    });

    return totalMaxBill;
  }
  checkIfLaborItem() {
    let p = this.state.serviceOrderProducts;
    let hasLabor = false;
    p.forEach((item) => {
      if (item.hcpcs === "K0739") {
        hasLabor = true;
      }
    });
    return hasLabor;
  }
  countLaborUnits() {
    let p = this.state.serviceOrderProducts;

    let labor = 0;
    p.forEach((item) => {
      labor = labor + this.getMaxBillableForLineItem(item.id);
    });
    return labor;
  }
  renderProductsList() {
    const { companyName } = this.context;

    let p = this.state.serviceOrderProducts;
    if (
      this.state.curOrder &&
      this.state.curOrder.orderType &&
      this.state.curOrder.orderType.toLowerCase() === "billing issue"
    ) {
      return (
        <div>
          <MUIAlert severity="info" sx={{ width: "100%", margin: "0 .8rem" }}>
            {" "}
            Paperwork from the original order will be re-signed and will include
            all of the equipment from the parent order
            {this.state.curOrder.parentOrder
              ? ", order number: " + this.state.curOrder.parentOrder
              : "."}
          </MUIAlert>
        </div>
      );
    }
    if (this.state.orderRetrieved && p && p.length > 0) {
      let hasLabor = this.checkIfLaborItem();
      let laborUnits = this.countLaborUnits();
      let displayLabor = 0;
      if (laborUnits < 2) {
        displayLabor = 2 - laborUnits;
      } else displayLabor = 0;
      return (
        <div>
          <MDBRow className="addedParts">ADDED PARTS</MDBRow>
          <MDBRow
            className="addedPartsHeaderRow"
            style={{ fontWeight: "bold" }}
          >
            <MDBCol
              className="addedPartsHeader partsHeaderNoPadding"
              size="3"
              sx={{ textAlign: "left" }}
            >
              {"Brightree Product"}{" "}
            </MDBCol>
            <MDBCol
              className="addedPartsHeader"
              size="1"
              sx={{ textAlign: "right" }}
            >
              {companyName !== "corkmedical" ? "MSRP" : ""}
            </MDBCol>
            <MDBCol className="addedPartsHeader partsHeaderNoPadding" size="1">
              {companyName !== "corkmedical" ? "HCPCS" : ""}
            </MDBCol>
            <MDBCol className="addedPartsHeader partsHeaderNoPadding" size="2">
              {companyName !== "corkmedical" ? "Reason" : ""}
            </MDBCol>
            <MDBCol className="addedPartsHeader partsHeaderNoPadding" size="2">
              {companyName !== "corkmedical" ? "Warranty" : ""}
            </MDBCol>
            <MDBCol className="addedPartsHeader partsHeaderNoPadding" size="1">
              {companyName !== "corkmedical" ? "30Day" : ""}
            </MDBCol>
            <MDBCol className="addedPartsHeader partsHeaderNoPadding" size="1">
              {companyName !== "corkmedical" ? "ABN" : ""}
            </MDBCol>
            <MDBCol className="addedPartsHeader" size="1">
              Qty{" "}
            </MDBCol>
          </MDBRow>

          {p.map((prod, idx) => {
            const msrp = this.state.allServiceParts?.find(
              (p) => p.id === prod.id,
            )?.msrp;

            if (prod.hcpcs === "K0739") {
              return false;
            }

            return (
              <MDBRow key={idx} className={"eqRow"}>
                <MDBCol size="3" className="partsHeaderNoPadding">
                  {this.state.servicePartsLoaded ? prod.name : ""}
                </MDBCol>
                <MDBCol
                  size="1"
                  className="partsHeaderNoPadding"
                  style={{ textAlign: "right" }}
                >
                  {msrp ? Format.currency(msrp) : ""}
                </MDBCol>

                <MDBCol size="1" className="partsHeaderNoPadding">
                  {prod.hcpcs ? prod.hcpcs : ""}
                </MDBCol>
                <MDBCol size="2" className="partsHeaderNoPadding">
                  {prod.reason ? prod.reason : ""}
                </MDBCol>
                <MDBCol size="2" className="partsHeaderNoPadding">
                  {prod.warranty ? "Yes" : ""}
                </MDBCol>
                <MDBCol size="2" className="partsHeaderNoPadding">
                  {prod.thirtyDayFit ? "Yes" : ""}
                </MDBCol>
                <MDBCol size="1" className="partsHeaderNoPadding">
                  {prod.name
                    ? this.checkForABNRequired(
                        prod.name.replace(/,/g, "") +
                          " " +
                          (prod.hcpcs ? prod.hcpcs.replace(/,/g, "") : ""),
                      )
                      ? "Yes"
                      : ""
                    : ""}
                </MDBCol>
                <MDBCol size="1" className="partsHeaderNoPadding">
                  {prod.qty}
                </MDBCol>
              </MDBRow>
            );
          })}
          {hasLabor ? (
            <>
              <MDBRow
                className="addedPartsHeaderRow"
                style={{ textDecoration: "underline", fontWeight: "bold" }}
              >
                <MDBCol
                  className="addedPartsHeader partsHeaderNoPadding"
                  size="5"
                >
                  {"Estimated Labor"}{" "}
                </MDBCol>
                <MDBCol
                  className="addedPartsHeader partsHeaderNoPadding"
                  size="2"
                >
                  {"Duration"}
                </MDBCol>
              </MDBRow>
              {p.map((prod, idx) => {
                if (prod.hcpcs !== "K0739") {
                  return false;
                }
                return (
                  <MDBRow key={idx} className={"eqRow"}>
                    <MDBCol size="5" className="partsHeaderNoPadding">
                      {this.state.servicePartsLoaded ? prod.name : ""}
                    </MDBCol>
                    <MDBCol size="2" className="partsHeaderNoPadding">
                      {this.state.servicePartsLoaded
                        ? displayLabor * 15 + " Minutes"
                        : ""}
                    </MDBCol>
                  </MDBRow>
                );
              })}
            </>
          ) : null}
        </div>
      );
    } else {
      return;
    }
  }

  renderGenericParts() {
    let curOrder = this.state.curOrder;
    let p = this.state.orderDetailProducts;
    if (this.state.orderRetrieved && p && p.length > 0) {
      return (
        <div>
          <MDBRow className="addedParts">GENERIC PARTS</MDBRow>
          <MDBRow
            className="addedPartsHeaderRow"
            style={{ fontWeight: "bold" }}
          >
            <MDBCol className="addedPartsHeader" size="5">
              {"Product"}{" "}
            </MDBCol>
            <MDBCol className="addedPartsHeader" size="4">
              {"HCPCS"}
            </MDBCol>
            <MDBCol className="addedPartsHeader" size="1">
              Qty{" "}
            </MDBCol>
            <MDBCol
              className="addedPartsHeader patientRemoveEquipmentButton"
              size="2"
            >
              {curOrder.orderType !== "Pickup" ? "Remove" : ""}{" "}
            </MDBCol>
          </MDBRow>

          {p.map((prod, idx) => {
            return (
              <MDBRow key={idx} className={"eqRow"}>
                <MDBCol size="5" className="centerAlignCol">
                  <MDBCol>
                    {this.state.servicePartsLoaded
                      ? (prod.productType ? prod.productType.name : "") +
                        " " +
                        (prod.productSubType ? prod.productSubType.name : "")
                      : ""}
                  </MDBCol>
                </MDBCol>
                <MDBCol size="4" className="centerAlignCol">
                  <MDBCol>{prod.hcpcs ? prod.hcpcs : "noname"}</MDBCol>
                </MDBCol>
                <MDBCol size="1" className="centerAlignCol">
                  <MDBCol className="patientRemoveEquipmentButton">
                    {prod.qty}
                  </MDBCol>
                </MDBCol>
                {curOrder.orderType !== "Pickup" ? (
                  <MDBCol size="2" className="centerAlignCol">
                    <MDBCol className="patientRemoveEquipmentButton">
                      {this.renderRemove(prod)}
                    </MDBCol>
                  </MDBCol>
                ) : null}
              </MDBRow>
            );
          })}
        </div>
      );
    } else {
      return;
    }
  }

  renderRemove(product) {
    return (
      <div>
        <MDBIcon
          icon={"times"}
          size="sm"
          style={{ color: "black" }}
          data-tip={"Remove this product"}
          onClick={() => this.handleProductRemove(product)}
        />
        <ReactTooltip />
      </div>
    );
  }

  handleProductRemove(product) {
    if (product.id && product.id > 0) {
      OrderService.removeOrderProduct(product.id)
        .then((res) => {
          if (res) {
            // Remove the product from the state
            this.setState({
              orderDetailProducts: this.state.orderDetailProducts.filter(
                (detailProduct) => {
                  return detailProduct.id !== product.id;
                },
              ),
            });
            toast.success("Product removed!");
          } else
            toast.error(
              "There was an issue deleting the product. If the issue persists, refresh the page and try again.",
            );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  toggleApprovalModalPopup = () => {
    let currentState = this.state.approvalModalOpen;
    this.setState({
      approvalModalOpen: !currentState,
      approveAgreement: false,
    });
  };
  triggerCreatePickup() {
    return new Promise((res, rej) => {
      let parentOrder = this.state.patientEquipmentTickets.find(
        (f) => this.state.curOrder.parentOrder === f.orderId,
      );

      this.setState({ createPickupFromRoute: parentOrder });
      res(true);
    });
  }

  checkBoxApprovedChange = (event) => {
    this.setState({ approveAgreement: event.target.checked });
  };

  renderApprovalModal() {
    if (!this.state.approvalModalOpen) {
      return;
    }
    let order = this.state.eOrder;
    let patient = this.state.patient;
    let o = null;
    let appr = null;
    let preAuth = null;

    if (this.state.orderRetrieved && order && order !== null) {
      o = order;
      appr = o.orderActivityApprovals[0]
        ? o.orderActivityApprovals[0].approvals
        : null;
      preAuth = appr.authNumber ? appr.authNumber.trim() : null;
    }

    if (!patient) {
      return;
    }

    return (
      <MDBModal
        className="salesPilotModal approvalModal"
        centered
        isOpen={this.state.approvalModalOpen}
        toggle={() => {
          return;
        }}
      >
        <MDBModalHeader
        // className="form-header text-center font-weight-bold blue-gradient"
        >
          <h3>Approve Order: {patient.firstName + " " + patient.lastName}</h3>
        </MDBModalHeader>
        <MDBModalBody>
          {appr && preAuth ? (
            <p style={{ marginLeft: "3px" }}>
              Pre-Auth Number: <b>{preAuth}</b>
            </p>
          ) : null}
          {appr && preAuth ? (
            <div align="left">
              <Input
                key={o.id}
                onChange={this.checkBoxApprovedChange.bind(this)}
                value={this.state.approveAgreement}
                label={`I approve this order with Auth Number: ${preAuth}`}
                type="checkbox"
                id="approveOrder"
              />
            </div>
          ) : null}

          {appr && !preAuth ? (
            <div align="left">
              <Input
                key={o.id}
                onClick={this.handleRadioChange(
                  "approveAuthNotRequired",
                  "preAuthAction",
                )}
                checked={
                  this.state.radio.preAuthAction === "approveAuthNotRequired"
                }
                label="I approve this order and Pre-Auth is Not Required"
                type="radio"
                id="approveAuthNotRequired"
              />
              <Input
                key={o.id}
                onClick={this.handleRadioChange(
                  "approveWithoutAuth",
                  "preAuthAction",
                )}
                checked={
                  this.state.radio.preAuthAction === "approveWithoutAuth"
                }
                label="I approve this order and send to Pre-Auth follow up for authorization"
                type="radio"
                id="approveOrderWithoutAuth"
              />
            </div>
          ) : null}
        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn
            color="mdb-color"
            onClick={() => {
              this.setState({
                isUpdating: false,
              });
              this.toggleApprovalModalPopup();
            }}
          >
            Close
          </MDBBtn>
          <MDBBtn
            disabled={
              this.state.approveAgreement ||
              this.state.radio.preAuthAction === "approveWithoutAuth" ||
              this.state.radio.preAuthAction === "approveAuthNotRequired"
                ? false
                : true
            }
            className="successButton"
            onClick={() => this.generateApprovalNote()}
          >
            Approve
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
    );
  }

  approvalAndUpdate(prop, val) {
    let eOrder = this.state.eOrder;

    eOrder.orderActivityApprovals[0].approvals[prop] = val;
    this.setState({ eOrder: eOrder });
    this.updateParentObject(eOrder);
  }

  handleDate(prop, e) {
    if (prop === "setupDate" || prop === "deliverByDate") {
      if (e) {
        e.set("hour", 12);
        e.set("minute", 0);
      }
    }

    let q = new moment.utc(e);
    let v = q.format("YYYY-MM-DDTHH:mm:ss");

    this.setAndUpdate(prop, v);
  }

  retrieveBaseUnit(id) {
    const { allBaseUnits, allVendors } = this.context;
    if (id == null) {
      this.setState({
        baseUnitLoaded: true,
      });
      return;
    }
    let baseUnit = allBaseUnits.find((b) => b.id === id);
    let vendor = allVendors.find((v) => v.id === baseUnit.vendorId);

    this.setState({
      currentBaseUnit: vendor.name + " " + baseUnit.name,
      baseUnitLoaded: true,
    });
  }

  checkForAddPart() {
    let subType = this.state.radio.queueRoutingSubType;

    if (!subType) {
      return null;
    }
    subType = subType.replace(/\s/g, "").toLowerCase();
    if (subType.includes("atp30dayfit4u")) {
      return "atp30day";
    } else if (subType.includes("atpservicerequest")) {
      return "atpService";
    } else if (subType.includes("30dayfit4u")) {
      return "30day";
    } else if (subType.includes("fieldservicediagnosis")) {
      return "fieldService";
    } else if (subType.includes("techskilledlabor")) {
      return "techSkilled";
    } else {
      return null;
    }
  }

  async addUnableToPickupNote() {
    const { currentUser } = this.context;
    let eOrder = this.state.eOrder;
    let cb = { id: currentUser.id, name: currentUser.username };
    let curOrder = this.state.curOrder;
    return new Promise((res, rej) => {
      let noteToAdd = {
        assignedToId: null,
        createdAt: globalFunctions.getUTCMoment(),
        createdBy: cb,
        createdById: cb.id,
        account: eOrder.account,
        accountId: eOrder.accountId,
        patientName: eOrder.patientName,
        type: "ActivityNote",
        activityId: curOrder.id,
        dueDate: null,
        completed: true,
        task: false,
        text: "Unable To Pick Up",
      };
      NoteService.createActivityNote(curOrder.id, noteToAdd)
        .then((result) => {
          if (result) {
            if (result.createdAt.indexOf("Z") > 0) {
              result.createdAt = result.createdAt.split("Z")[0];
            }
            this.retrieveNotes(curOrder.id);
            res(result);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }
  async routeBackToSender() {
    return new Promise((res, rej) => {
      const { reasons } = this.context;
      let orderStatuses = this.state.orderStatuses;
      let st = this.state;
      let reasonObj = null;
      let statusObj = null;
      let previousReason = st.ticketRecords;
      let curOrder = this.state.curOrder;

      let lastValidEntry = null;
      if (previousReason && previousReason.length > 0) {
        for (let i = 0; i < previousReason.length; i++) {
          if (
            previousReason[i].statusFrom &&
            previousReason[i].statusFrom.toLowerCase() !== "canceled" &&
            previousReason[i].reasonFrom !== curOrder.reason
          ) {
            lastValidEntry = previousReason[i];
            break;
          }
        }
      }
      if (lastValidEntry) {
        statusObj = orderStatuses.find(
          (orderStatus) =>
            orderStatus.label.toLowerCase().replace(/\s/g, "") ===
            lastValidEntry.statusFrom.toLowerCase().replace(/\s/g, ""),
        );

        if (statusObj) {
          this.statusChanged(statusObj.value);
        }

        reasonObj = reasons.find(
          (f) => f.description === lastValidEntry.reasonFrom,
        );
        if (reasonObj) {
          this.updateReason(reasonObj.id);
        } else {
          this.updateReason();
        }
      } else {
        this.updateReason();
      }

      this.saveStatusReasonChange();
      res(true);
    });
  }
  async checkForNonBillable() {
    return new Promise((res, rej) => {
      let serviceParts = this.state.serviceOrderProducts;
      let serviceReason = this.state.curOrder.serviceReason;
      let orderProducts = this.state.orderDetailProducts;
      let nonbillable = false;
      let nonbillableApproved = false;
      let nonBillableProductSubTypes = [70]; // 70: 30 Day Fit 4 U Adjustment
      let nonBillableServiceReasons = ["30 Day Fit 4 U"];
      let nonBillableApprovedProductSubTypes = [1963, 1964]; //1963: tech skilled labor, 1964: Field Service Diagnosis
      let nonBillableApprovedServiceReasons = [
        "Tech Skilled Labor",
        "Field Service Diagnosis",
      ];

      if (serviceParts.length < 1 && orderProducts.length === 1) {
        let productSubTypeId = orderProducts[0]?.productSubType?.id ?? null;
        let hcpcs = (orderProducts[0]?.hcpcs ?? "")
          .toString()
          .trim()
          .toUpperCase();

        if (productSubTypeId != null) {
          if (nonBillableApprovedProductSubTypes.includes(productSubTypeId)) {
            nonbillableApproved = true;
          } else if (nonBillableProductSubTypes.includes(productSubTypeId)) {
            nonbillable = true;
          }
        }
        if (!nonbillableApproved && hcpcs === "NB") {
          nonbillable = true;
        }
      } else if (serviceParts.length < 1 && orderProducts.length < 1) {
        if (nonBillableServiceReasons.includes(serviceReason)) {
          nonbillable = true;
        } else if (nonBillableApprovedServiceReasons.includes(serviceReason)) {
          nonbillableApproved = true;
        }
      }

      //83: non-billable, 56: non billable approved
      if (nonbillable) {
        this.statusChanged(3);
        this.updateReason(83);
        this.saveStatusReasonChange();
        NotistackEnqueueSnackbar("Order is non-billable; rerouted.", {
          variant: "info",
        });
        res("stop");
      } else if (nonbillableApproved) {
        this.statusChanged(3);
        this.updateReason(56);
        this.saveStatusReasonChange();
        NotistackEnqueueSnackbar(
          "Order is non-billable; rerouted (approved).",
          { variant: "info" },
        );
        res("stop");
      } else {
        res(true);
      }
    });
  }

  async handleQueueRouteTriggers(trigger, fromTrigger) {
    return new Promise((res, rej) => {
      if (fromTrigger === "fromNote") {
        res("continue");
        return;
      } else if (!trigger || fromTrigger) {
        res(false);
      } else if (trigger === "addPartAndAuthorization") {
        this.addPartAndAuthorization().then((result) => {
          res(result);
        });
      } else if (trigger === "addApprovedPart") {
        this.addApprovedPart().then((result) => {
          res(result);
        });
      } else if (trigger === "addFollowupDate") {
        this.addFollowupDate().then((result) => {
          res(result);
        });
      } else if (trigger === "needsRedelivery") {
        this.handleNeedsRedelivery().then((result) => {
          res(result);
        });
      } else if (trigger === "toggleCreateNoteModal") {
        this.toggleNoteModalPopup();
        res("stop");
      } else if (trigger === "togglePreAuthModal") {
        this.toggleApprovalModalPopup();
        res("stop");
      } else if (trigger === "createApprovalNote") {
        this.generateApprovalNote(this.state.serviceOrderProducts).then(
          (result) => {
            res(result);
          },
        );
      } else if (trigger === "addUnableToPickupNote") {
        this.addUnableToPickupNote().then((result) => {
          res(result);
        });
      } else if (trigger === "createPickup") {
        this.triggerCreatePickup().then((result) => {
          res(result);
        });
      } else if (trigger === "routeBackToSender") {
        this.routeBackToSender().then((result) => {
          res("stop");
        });
      } else if (trigger === "nonBillableCheck") {
        this.checkForNonBillable().then((result) => {
          res(result);
        });
      }
    });
  }
  async addPartAndAuthorization() {
    return new Promise((res, rej) => {
      let addPart = this.checkForAddPart();
      this.addPartForDeliveryAndAuthorize(addPart).then((result) => {
        res(result);
      });
    });
  }

  async addApprovedPart() {
    const addPart = this.checkForAddPart();
    const newItem = this.buildApprovedPartItem(addPart);

    return OrderService.updateOrderProducts(this.state.curOrder.id, [newItem]);
  }

  async handleSubmitRouteChange(fromTrigger) {
    let curOrder = this.state.curOrder;
    const { queueRoutesIndexed } = this.context;
    const { orderStatusReasonsIndexed } = this.context;
    if (this.state.patient.gender == "") {
      toast.warn("Patient must have gender set before saving");
      this.setState({
        isUpdating: false,
      });
      return;
    }

    let selectedRoute = queueRoutesIndexed[this.state.radio.queueRouting];
    let queueRoutingSubType = this.state.radio.queueRoutingSubType;
    let hasTrigger = selectedRoute.trigger;

    this.handleQueueRouteTriggers(hasTrigger, fromTrigger).then((res) => {
      if (res === "stop") {
        return;
      }

      this.statusChanged(
        orderStatusReasonsIndexed[selectedRoute.toOrderStatusReasonId]
          .orderStatus,
      );
      this.updateReason(selectedRoute.toOrderStatusReasonId);
      if (
        queueRoutingSubType &&
        queueRoutingSubType !== curOrder.serviceReason
      ) {
        this.updateServiceOrderReasonRecord(
          "serviceReason",
          queueRoutingSubType,
        );
      }
      this.saveStatusReasonChange();
    });
  }

  getRoutingInformation(order) {
    this.setState({
      loadingRoutingInformation: true,
    });
    let orderActivityTypeId = this.findOrderActivityTypeId(order.orderType);
    let orderStatusReasonId = this.findOrderStatusReasonId(order.reason);
    let queueRoutingOptions = this.findQueueRoutingOptions(
      orderActivityTypeId,
      orderStatusReasonId,
    );
    if (order.status === "Cancelled") {
      queueRoutingOptions = [];
    }

    order.routingInformation = {
      orderId: order.id,
      orderActivityTypeId: orderActivityTypeId,
      orderStatusReasonId: orderStatusReasonId,
      queueRoutingOptions: queueRoutingOptions,
    };
    this.setState({
      curOrder: order,
      loadingRoutingInformation: false,
    });
  }
  getNewTicketRoutingInformation(orderType) {
    this.setState({
      initialRoutingInformation: null,
      loadingInitialRoutingInformation: true,
    });
    let orderActivityTypeId = this.findOrderActivityTypeId(orderType);
    let orderStatusReasonId = null;
    let queueRoutingOptions = this.findQueueRoutingOptions(
      orderActivityTypeId,
      orderStatusReasonId,
    );

    let initialRoutingInformation = {
      orderActivityTypeId: orderActivityTypeId,
      orderStatusReasonId: orderStatusReasonId,
      queueRoutingOptions: queueRoutingOptions,
    };
    this.setState({
      initialRoutingInformation: initialRoutingInformation,
      loadingInitialRoutingInformation: false,
    });
  }

  findQueueRoutingOptions(orderActivityTypeId, orderStatusReasonId) {
    const { queueRoutesIndexed } = this.context;
    let queueRouting = Object.values(queueRoutesIndexed);
    let foundRoutes = [];
    queueRouting.forEach((queueRoute) => {
      if (
        queueRoute.orderActivityTypeId === orderActivityTypeId &&
        queueRoute.fromOrderStatusReasonId === orderStatusReasonId
      ) {
        foundRoutes.push(queueRoute);
      }
    });
    return foundRoutes;
  }

  findOrderStatusReasonId(orderReason) {
    const { orderStatusReasonsIndexed } = this.context;
    let result = Object.values(orderStatusReasonsIndexed);
    let index = result.find(
      (orderStatusReasonsIndexed) =>
        orderStatusReasonsIndexed.description === orderReason,
    );
    if (!index) {
      return null;
    }
    return index.id;
  }

  findOrderActivityTypeId(orderType) {
    const { orderActivityTypesIndexed } = this.context;
    let result = Object.values(orderActivityTypesIndexed);
    let index = result.find(
      (orderActivityType) => orderActivityType.name === orderType,
    );
    if (!index) {
      return null;
    }
    return index.id;
  }
  splitArrayIntoChunks(array, size) {
    if (array && size) {
      //Splittign the array into chunks of size 2 for rendering
      let splitArray = array.reduce((resultArray, chunk, index) => {
        const chunkIndex = Math.floor(index / size);
        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [];
        }
        resultArray[chunkIndex].push(chunk);
        return resultArray;
      }, []);
      return splitArray;
    }
    return [];
  }

  sortRoutingOptionsWithHeaders(options) {
    if (!options) {
      return;
    }
    let array = {};
    options.forEach((option) => {
      let header = option.name.substring(0, option.name.indexOf("-"));
      // let body = option.name.substring(option.name.indexOf("-"), option.name.length);
      if (!array[header]) {
        array[header] = [];
      }
      array[header].push(option);
    });
    let result = Object.keys(array).map((key) => [key, array[key]]);
    return result;
  }
  renderQueueRoutingOptionsInitialCreate(orderType) {
    const { orderActivityTypesIndexed } = this.context;

    if (
      (!this.state.initialRoutingInformation &&
        !this.state.loadingInitialRoutingInformation) ||
      orderActivityTypesIndexed[
        this.state.initialRoutingInformation.orderActivityTypeId
      ].name.toLowerCase() !== orderType.toLowerCase()
    ) {
      this.getNewTicketRoutingInformation(orderType);
    }
    let queueRoutingOptions = this.state.initialRoutingInformation
      ? this.state.initialRoutingInformation.queueRoutingOptions
      : null;
    let selectedQueueRoute = queueRoutingOptions
      ? queueRoutingOptions.find(
          (option) => option.id === this.state.radio.queueRouting,
        )
      : null;
    return (
      <>
        <Card className="patientInformationCard">
          <MUIBox sx={{ flexGrow: 1, padding: "1rem" }}>
            {queueRoutingOptions && queueRoutingOptions.length > 0 ? (
              <>
                <MUIFormControl>
                  <MUIFormLabel sx={{ marginBottom: "1rem" }}>
                    Routing
                  </MUIFormLabel>
                  <MUIGrid
                    container
                    spacing={2}
                    style={{ paddingLeft: ".5rem" }}
                  >
                    {queueRoutingOptions.map((o) => {
                      return (
                        <MUIGrid item lg={6} sm={12}>
                          <MUITooltip
                            placement="top"
                            title={OrderStatusReason.getDisplayName(
                              this.context.orderStatusReasonsIndexed[
                                o.toOrderStatusReasonId
                              ],
                            )}
                          >
                            <MUIFormControlLabel
                              sx={{ marginTop: 0, marginBottom: 0 }}
                              onChange={() =>
                                this.handleRadioChangeQueueRoute(
                                  o,
                                  "queueRouting",
                                )
                              }
                              checked={this.state.radio.queueRouting === o.id}
                              value={o.id}
                              control={<MUIRadio />}
                              label={o.name}
                            />
                          </MUITooltip>
                        </MUIGrid>
                      );
                    })}
                    {queueRoutingOptions.some(
                      (queueRoute) =>
                        queueRoute.id === this.state.radio.queueRouting,
                    )
                      ? this.renderSubTypeOptions(selectedQueueRoute)
                      : null}
                  </MUIGrid>
                </MUIFormControl>
              </>
            ) : (
              <EmptyState line1={"No routes available"} />
            )}
            {orderType.toLowerCase() === "pickup" ? (
              <Col>{this.renderPatientProducts()}</Col>
            ) : null}
            <div
              className={
                (this.state.typeOfTicketToCreate.toLowerCase() === "pickup" &&
                  this.state.productsAddedList.length > 0 &&
                  this.state.radioBtnSelected) ||
                (this.state.typeOfTicketToCreate.toLowerCase() !== "pickup" &&
                  this.state.radioBtnSelected)
                  ? "verifyInfoStep step3 infoVerifiedIndicator"
                  : "verifyInfoStep step3"
              }
            >
              {this.state.typeOfTicketToCreate.toLowerCase() !== "pickup"
                ? 3
                : 2}
            </div>
          </MUIBox>
        </Card>
      </>
    );
  }

  renderSubTypeOptions(queueRoutingOption) {
    if (
      !queueRoutingOption.jsonSubTypes ||
      !this.state.radio.queueRouting ||
      this.state.radio.queueRouting !== queueRoutingOption.id
    ) {
      return null;
    }
    let subTypes = queueRoutingOption.jsonSubTypes,
      count = subTypes.options.length,
      required = !!subTypes.required;
    if (count === 1 && required) {
      if (this.state.selectedSubTypeFromQueueRoute !== subTypes.options[0]) {
        this.setState({
          serviceReason: subTypes.options[0],
          selectedSubTypeFromQueueRoute: subTypes.options[0],
        });
      }
      return null;
    }

    return (
      <MUIBox sx={{ flexGrow: 1, padding: "1rem 1rem 0rem", width: "100%" }}>
        <MUITypography
          variant="body1"
          color={required ? MUIRedColor[500] : MUIBlueColor[700]}
          style={{ marginBottom: ".5rem" }}
        >
          {required ? "Select One (required):" : "Optional:"}
        </MUITypography>
        <MUIGrid container spacing={2}>
          {subTypes.options.map((subType, idx) => {
            if (required) {
              return (
                <MUIGrid item>
                  <MUIFormControlLabel
                    onChange={() =>
                      this.handleRadioChangeSubType(
                        subType,
                        "queueRoutingSubType",
                      )
                    }
                    checked={this.state.radio.queueRoutingSubType === subType}
                    value={subType}
                    control={<MUIRadio size="small" />}
                    label={subType}
                  />
                </MUIGrid>
              );
            } else {
              return (
                <MUIGrid item>
                  <MUIFormControlLabel
                    onChange={() =>
                      this.handleRadioChangeSubType(
                        subType,
                        "queueRoutingSubType",
                      )
                    }
                    checked={this.state.radio.queueRoutingSubType === subType}
                    value={subType}
                    control={<MUICheckbox size="small" />}
                    label={subType}
                  />
                </MUIGrid>
              );
            }
          })}
        </MUIGrid>
      </MUIBox>
    );
  }

  renderQueueRoutingOptions() {
    let submitButtonEnabled = true;
    const canRoute = this.canUseOldExperience();

    if (this.state.isOrderDetails && !this.state.curOrder.id) {
      return;
    }

    if (
      !this.state.curOrder.routingInformation &&
      !this.state.loadingRoutingInformation
    ) {
      this.getRoutingInformation(this.state.curOrder);
    }

    let curOrder = this.state.curOrder;
    let queueRoutingOptions = this.state.curOrder.routingInformation
      ? this.state.curOrder.routingInformation.queueRoutingOptions
      : null;
    let selectedQueueRoute = queueRoutingOptions
      ? queueRoutingOptions.find(
          (option) => option.id === this.state.radio.queueRouting,
        )
      : null;

    //Handle disable Submit button if subtype is required
    if (
      selectedQueueRoute &&
      selectedQueueRoute.jsonSubTypes &&
      selectedQueueRoute.jsonSubTypes.required === true
    ) {
      submitButtonEnabled = false;

      selectedQueueRoute.jsonSubTypes.options.forEach((o) => {
        if (this.state.selectedSubTypeFromQueueRoute === o) {
          submitButtonEnabled = true;
        }
      });
    }

    if (
      curOrder &&
      curOrder.orderType &&
      curOrder.orderType.toLowerCase().replace(/\s/g, "") !== "new"
    ) {
      return (
        <>
          <Card className="patientInformationCard">
            <MUIBox sx={{ padding: "1rem" }}>
              {queueRoutingOptions.length > 0 ? (
                <>
                  <MUIFormControl sx={{ minWidth: "100%" }}>
                    <MUIFormLabel>Routing</MUIFormLabel>
                    <MUIGrid container spacing={2}>
                      {queueRoutingOptions.map((o, index) => {
                        return (
                          <MUIGrid item lg={4} md={6} sm={12} key={index}>
                            <MUITooltip
                              placement="top"
                              title={OrderStatusReason.getDisplayName(
                                this.context.orderStatusReasonsIndexed[
                                  o.toOrderStatusReasonId
                                ],
                              )}
                            >
                              <MUIFormControlLabel
                                sx={{ marginTop: 0, marginBottom: 0 }}
                                onChange={() =>
                                  this.handleRadioChangeQueueRoute(
                                    o,
                                    "queueRouting",
                                  )
                                }
                                checked={this.state.radio.queueRouting === o.id}
                                value={o.id}
                                control={<MUIRadio />}
                                label={o.name}
                              />
                            </MUITooltip>
                          </MUIGrid>
                        );
                      })}
                      {queueRoutingOptions.some(
                        (queueRoute) =>
                          queueRoute.id === this.state.radio.queueRouting,
                      )
                        ? this.renderSubTypeOptions(selectedQueueRoute)
                        : null}
                    </MUIGrid>
                  </MUIFormControl>
                  <MUIContainer
                    disableGutters
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <MUITooltip
                      title={
                        this.canUseOldExperience()
                          ? ""
                          : "Please use new experience for routing."
                      }
                      placement="top"
                    >
                      <span>
                        <MUILoadingButton
                          disabled={
                            !this.canUseOldExperience() ||
                            !(
                              this.state.orderRetrieved &&
                              this.state.radio.queueRouting &&
                              submitButtonEnabled
                            )
                          }
                          loading={this.state.isUpdating}
                          component="label"
                          variant="contained"
                          endIcon={<MUIArrowForwardIcon />}
                          onClick={() => {
                            this.setState({ isUpdating: true });
                            this.handleSubmitRouteChange();
                          }}
                        >
                          Route
                        </MUILoadingButton>
                      </span>
                    </MUITooltip>
                  </MUIContainer>
                </>
              ) : (
                <EmptyState line1={"No routes available"} />
              )}
            </MUIBox>
          </Card>
        </>
      );
    }
  }

  renderTicketDetailsHeader() {
    let order = this.state.eOrder;
    let o = null;
    let r = this.state.curOrder;
    let statusIconColor = "#009FAF32";

    if (this.state.orderRetrieved && order && order !== null) {
      o = order;
    }

    if (r && r.status) {
      if (r.status.toLowerCase() === "in process") {
        statusIconColor = "#CEBD23";
      } else if (r.status.toLowerCase() === "cancelled") {
        statusIconColor = "#CE2323";
      } else if (r.status.toLowerCase() === "ready to deliver") {
        statusIconColor = "#02BD4D";
      } else if (r.status.toLowerCase() === "setup") {
        statusIconColor = "#C4C4C4";
      } else if (r.status.toLowerCase() === "new") {
        statusIconColor = "#2372CE";
      } else {
        statusIconColor = "#000";
      }
    }

    return (
      <MDBRow className="ticketDetailsHeader" id={"openDetailsHeader"}>
        <MDBCol
          size="md"
          className="ticketDetailsHeaderCol ticketDetailsHeaderIconCol"
        >
          <MDBIcon
            onClick={() => this.toggleTicketDetailsModal()}
            fas
            icon="arrow-left"
            className="backArrowIcon"
          />
        </MDBCol>
        <MDBCol
          size="md"
          className="ticketDetailsHeaderCol ticketDetailsColBorderRight"
        >
          <p className="ticketDetailsHeaderLabel">ID</p>
          <p className="ticketDetailsHeaderInfo">#{this.state.curOrderId}</p>
        </MDBCol>
        <MDBCol
          size="md"
          className="ticketDetailsHeaderCol ticketDetailsColBorderRight"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <div>
              <p className="ticketDetailsHeaderLabel">Brightree ID</p>
              {o && o.btSoId ? (
                <a
                  className="ticketDetailsHeaderInfo"
                  href={`https://brightree.net/F1/02200/OrbitMedical/OrderEntry/frmSOOrderRO.aspx?SalesOrderKey=${o.btSoId}`}
                  target="_blank"
                  style={{ textDecoration: "underline" }}
                >
                  {o.btSoId}
                </a>
              ) : (
                <p className="ticketDetailsHeaderInfo">N/A</p>
              )}
            </div>
            {false ? (
              <>
                <MUITooltip
                  title={"Please use the new experience to update Brightree ID"}
                  placement="top"
                >
                  <span>
                    <MUIIconButton size="small" disabled={true}>
                      <MUIEditIcon fontSize="small" />
                    </MUIIconButton>
                  </span>
                </MUITooltip>
                <DialogUpdateBrightreeExternalId
                  open={this.state.dialogUpdateBrightreeExternalIdOpen}
                  onClose={() =>
                    this.setState({
                      dialogUpdateBrightreeExternalIdOpen: false,
                    })
                  }
                  order={o}
                  onConfirm={(order) => this.updateOrder(order)}
                />
              </>
            ) : null}
          </div>
        </MDBCol>
        <MDBCol
          size="md"
          className="ticketDetailsHeaderCol ticketDetailsColBorderRight"
        >
          <p className="ticketDetailsHeaderLabel ">Type</p>
          <p className="ticketDetailsHeaderInfo">{r.orderType}</p>
          <p className="ticketDetailsHeaderInfo ticketDetailsHeaderSubtype">
            {r.serviceReason ? r.serviceReason : ""}
          </p>
        </MDBCol>
        <MDBCol
          size="md"
          className="ticketDetailsHeaderCol ticketDetailsColBorderRight"
        >
          <MDBRow className="ticketDetailsStatusRow">
            <MDBCol size="sm" className="ticketStatusHeaderIconCol">
              <MDBIcon
                style={{ color: statusIconColor, fontSize: "1.7rem" }}
                far
                icon="clock"
              />
            </MDBCol>
            <MDBCol size="sm" className="ticketDetailsHeaderCol">
              <p className="ticketDetailsHeaderLabel">Status</p>
              <p className="ticketDetailsHeaderInfo">
                {r.status && r.status.toLowerCase() === "setup"
                  ? "Delivered"
                  : r.status}
              </p>
            </MDBCol>
          </MDBRow>
        </MDBCol>
        <MDBCol
          size="md"
          className="ticketDetailsHeaderCol ticketDetailsColBorderRight"
        >
          <p className="ticketDetailsHeaderLabel">Reason</p>
          <p className="ticketDetailsHeaderInfo">
            {r.reason ? r.reason : "None"}
          </p>
        </MDBCol>

        <MDBCol size="md" className="ticketDetailsHeaderCol">
          <p className="ticketDetailsHeaderLabel">Created On</p>
          <p className="ticketDetailsHeaderInfo">
            {o && o !== null && o.activity && o.activity.startedAt
              ? GlobalFunctions.formatDateTime(o.activity.startedAt)
              : ""}
          </p>
        </MDBCol>
      </MDBRow>
    );
  }

  renderTicketDetailsInsurance() {
    let order = this.state.eOrder;
    let o = null;

    if (this.state.orderRetrieved && order && order !== null) {
      o = order;
    }

    if (
      this.state.curOrder &&
      this.state.curOrder !== null &&
      this.state.curOrder.orderType === "Pickup"
    ) {
      return;
    }

    return o && o !== null && o.isApproved === true ? (
      <div>
        <MDBRow className="ticketInfoLabelEditContainer ticketInsuranceHeaderRow">
          <h3 className="ticketInfoLabel">Insurance</h3>
          <MUIAlert
            severity="success"
            sx={{ width: "100%", margin: "0 .8rem" }}
          >
            Ticket has been approved and insurance can no longer be updated.
          </MUIAlert>
        </MDBRow>
        <MDBRow className="insuranceTileWrapper">
          {o && o !== null && o.insuranceType ? (
            <MDBCol md={6}>
              <MDBContainer className="insuranceTile">
                <MDBRow className="insuranceTileRow">
                  <MDBCol size="7" className="insuranceTileCol">
                    <h4 className="ticketInfoSubLabel">Primary Payor Source</h4>
                    <p className="ticketInfo">
                      {o &&
                      o !== null &&
                      o.insuranceType &&
                      o.insuranceType.name !== null
                        ? o.insuranceType.name
                        : ""}
                    </p>
                  </MDBCol>
                  <MDBCol className="insuranceTileCol">
                    <h4 className="ticketInfoSubLabel">Primary Insurance</h4>
                    <p className="ticketInfo">
                      {o &&
                      o !== null &&
                      o.insuranceSubType &&
                      o.insuranceSubType.name !== null
                        ? o.insuranceSubType.name
                        : ""}
                    </p>
                  </MDBCol>
                </MDBRow>
                <MDBRow className="insuranceTileRow">
                  <MDBCol size="7" className="insuranceTileCol">
                    <h4 className="ticketInfoSubLabel">Policy Number</h4>
                    <p className="ticketInfo">
                      {o &&
                      o !== null &&
                      o.insurancePolicy !== null &&
                      o.insurancePolicy !== ""
                        ? o.insurancePolicy
                        : "N/A"}
                    </p>
                  </MDBCol>
                  <MDBCol className="insuranceTileCol">
                    <h4 className="ticketInfoSubLabel">Group Number</h4>
                    <p className="ticketInfo">
                      {o &&
                      o !== null &&
                      o.insuranceGroup !== null &&
                      o.insuranceGroup !== ""
                        ? o.insuranceGroup
                        : "N/A"}
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
            </MDBCol>
          ) : null}

          {o && o !== null && o.secondaryInsuranceType ? (
            <MDBCol md={6}>
              <MDBContainer className="insuranceTile">
                <MDBRow className="insuranceTileRow">
                  <MDBCol size="7" className="insuranceTileCol">
                    <h4 className="ticketInfoSubLabel">
                      Secondary Payor Source
                    </h4>
                    <p className="ticketInfo">
                      {o &&
                      o !== null &&
                      o.secondaryInsuranceType &&
                      o.secondaryInsuranceType.name !== null
                        ? o.secondaryInsuranceType.name
                        : ""}
                    </p>
                  </MDBCol>
                  <MDBCol className="insuranceTileCol">
                    <h4 className="ticketInfoSubLabel">Secondary Insurance</h4>
                    <p className="ticketInfo">
                      {o &&
                      o !== null &&
                      o.secondaryInsuranceSubType &&
                      o.secondaryInsuranceSubType.name !== null
                        ? o.secondaryInsuranceSubType.name
                        : ""}
                    </p>
                  </MDBCol>
                </MDBRow>
                <MDBRow className="insuranceTileRow">
                  <MDBCol size="7" className="insuranceTileCol">
                    <h4 className="ticketInfoSubLabel">Policy Number</h4>
                    <p className="ticketInfo">
                      {o &&
                      o !== null &&
                      o.secondaryInsurancePolicy !== null &&
                      o.secondaryInsurancePolicy !== ""
                        ? o.secondaryInsurancePolicy
                        : "N/A"}
                    </p>
                  </MDBCol>
                  <MDBCol className="insuranceTileCol">
                    <h4 className="ticketInfoSubLabel">Group Number</h4>
                    <p className="ticketInfo">
                      {o &&
                      o !== null &&
                      o.secondaryInsuranceGroup !== null &&
                      o.secondaryInsuranceGroup !== ""
                        ? o.secondaryInsuranceGroup
                        : "N/A"}
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
            </MDBCol>
          ) : null}
        </MDBRow>
      </div>
    ) : null;
  }

  renderTicketDetailsInformation() {
    let order = this.state.eOrder;
    let o = null;

    if (!this.state.curOrder) {
      return;
    }

    if (
      !this.state.orderApprovalsLoading &&
      !this.state.orderApprovalsLoaded &&
      this.state.curOrderId
    ) {
      this.setState(
        {
          orderApprovalsLoading: true,
        },
        () => {
          this.getApprovalsByOrder();
        },
      );
    }

    if (this.state.orderRetrieved && order && order !== null) {
      if (this.state.orderRetrieved && order && order !== null) {
        o = order;
        let parentOrder = this.state.gridData.rows.find(
          (f) => this.state.curOrder.parentOrder === f.orderId,
        );

        if (!this.state.serviceReasonLoaded && !this.state.isOrderDetails) {
          this.retrieveServiceOrderReasonByTicketId(o.id);
        }

        if (!this.state.ticketRecordsLoaded) {
          this.retrieveTicketRecords(o);
          if (parentOrder && parentOrder !== null) {
            if (!(
              this.state.loadingParentProducts &&
              this.state.loadingParentProducts === parentOrder.orderId
            )) {
              this.setState({ loadingParentProducts: parentOrder.orderId });
              OrderService.getOrderProducts(parentOrder.orderId)
                .then((data) => {
                  const productsWithBaseUnit = data.filter((p) => p.baseUnitId);
                  const productsWithoutBaseUnit = data.filter(
                    (p) => !p.baseUnitId,
                  );

                  if (productsWithBaseUnit.length > 0) {
                    const sortedBaseUnits = productsWithBaseUnit.sort(
                      (a, b) => b.points - a.points,
                    );
                    const topBaseUnit = sortedBaseUnits[0];

                    this.setState({
                      baseUnitSerial: topBaseUnit.serial,
                      baseUnitHCPCS: topBaseUnit.hcpcs,
                    });

                    this.retrieveBaseUnit(topBaseUnit.baseUnitId);
                  } else {
                    // Check for valid serials if no base units are available
                    const validSerialProducts = productsWithoutBaseUnit
                      .filter((p) => p.serial)
                      .sort((a, b) => b.points - a.points);

                    if (validSerialProducts.length > 0) {
                      const firstSerialProduct = validSerialProducts[0];

                      this.setState({
                        baseUnitSerial: firstSerialProduct.serial,
                        baseUnitHCPCS: firstSerialProduct.hcpcs,
                        currentBaseUnit:
                          this.context.productSubTypesIndexed[
                            firstSerialProduct.productSubTypeId
                          ]?.name,
                      });
                    }

                    // Mark base unit as loaded if nothing to retrieve
                    this.setState({ baseUnitLoaded: true });
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          }
        }
      }
    }

    let parentOrder = this.state.curOrder?.parentOrder
      ? this.state.gridData?.rows?.find(
          (f) => f.orderId === this.state.curOrder.parentOrder,
        ) || null
      : null;

    return (
      <div className="ticketDetailsContainer">
        <div className="ticketInfoContainer">
          <h3 className="ticketInfoLabel">Equipment</h3>
          <div className="ticketDetailsWrapper">
            <div className="patientInfoCol1">
              <h4 className="ticketInfoSubLabel">Base Unit</h4>
              <p className="ticketInfo">
                {this.state.currentBaseUnit &&
                this.state.currentBaseUnit !== null
                  ? this.state.currentBaseUnit
                  : "N/A"}
              </p>
              <h4 className="ticketInfoSubLabel">Serial Number</h4>
              <p className="ticketInfo">
                {this.state.baseUnitSerial && this.state.baseUnitSerial !== null
                  ? this.state.baseUnitSerial
                  : "N/A"}
              </p>
              <h4 className="ticketInfoSubLabel">Setup Date</h4>
              <p className="ticketInfo">
                {parentOrder?.setupDate &&
                moment(parentOrder.setupDate).isValid()
                  ? moment(parentOrder.setupDate).format("M/D/YYYY")
                  : "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="ticketInfoContainer">
          <div className="ticketInfoLabelEditContainer">
            <h3 className="ticketInfoLabel">Location Information</h3>
            {this.state.orderRetrieved && order && order !== null ? (
              <div className="editBtnContainer">
                {this.state.curOrder &&
                this.state.curOrder.status == "Cancelled" ? null : (
                  <MUITooltip
                    title={
                      this.canUseOldExperience()
                        ? ""
                        : "Please use new experience to update location info"
                    }
                    placement="top"
                  >
                    <span>
                      <svg
                        onClick={() => {
                          if (!this.canUseOldExperience()) {
                            return;
                          }
                          this.setState({ editLocationInformationModal: true });
                        }}
                        className="detailHeaderEditBtn"
                        xmlns="http://www.w3.org/2000/svg"
                        width="17.341"
                        height="17.341"
                        viewBox="0 0 17.341 17.341"
                      >
                        <path
                          id="Path_square-edit-outline"
                          data-name="Path / square-edit-outline"
                          d="M4.927,3A1.92,1.92,0,0,0,3,4.927V18.414a1.927,1.927,0,0,0,1.927,1.927H18.414a1.927,1.927,0,0,0,1.927-1.927V11.67H18.414v6.744H4.927V4.927H11.67V3H4.927m12.312.963a.666.666,0,0,0-.462.193L15.6,5.322,18.009,7.73l1.175-1.166a.651.651,0,0,0,0-.915L17.692,4.156a.643.643,0,0,0-.453-.193M14.917,6.006l-7.1,7.11v2.408h2.408l7.1-7.11Z"
                          transform="translate(-3 -3)"
                          fill="#9c9c9c"
                        />
                      </svg>
                    </span>
                  </MUITooltip>
                )}
              </div>
            ) : null}
          </div>

          <div className="ticketDetailsWrapper">
            <div className="patientInfoCol1">
              <h4 className="ticketInfoSubLabel">Sales Location</h4>
              <p className="ticketInfo">
                {o &&
                o !== null &&
                this.state.order.salesLocation &&
                this.state.order.salesLocation.name
                  ? this.state.order.salesLocation.name
                  : "N/A"}
              </p>
              <h4 className="ticketInfoSubLabel">Service Location</h4>
              <p className="ticketInfo">
                {o &&
                o !== null &&
                this.state.order.serviceLocation &&
                this.state.order.serviceLocation.name
                  ? this.state.order.serviceLocation.name
                  : "N/A"}
              </p>
              <h4 className="ticketInfoSubLabel">Billing Location</h4>
              <p className="ticketInfo">
                {o && o !== null && this.state.order.billingLocationId
                  ? this.context.locationsIndexed[
                      this.state.order.billingLocationId
                    ]?.name
                  : "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div className="ticketInfoContainer">
          <div className="ticketInfoLabelEditContainer">
            <h3 className="ticketInfoLabel">General</h3>
            {this.state.orderRetrieved && order && order !== null ? (
              <div className="editBtnContainer">
                {this.state.curOrder &&
                this.state.curOrder.status == "Cancelled" ? null : (
                  <MUITooltip
                    title={
                      this.canUseOldExperience()
                        ? ""
                        : "Please use new experience to update general info"
                    }
                    placement="top"
                  >
                    <span>
                      <svg
                        onClick={() => {
                          if (!this.canUseOldExperience()) {
                            return;
                          }
                          this.setState({ editGeneralInformationModal: true });
                        }}
                        className="detailHeaderEditBtn"
                        xmlns="http://www.w3.org/2000/svg"
                        width="17.341"
                        height="17.341"
                        viewBox="0 0 17.341 17.341"
                      >
                        <path
                          id="Path_square-edit-outline"
                          data-name="Path / square-edit-outline"
                          d="M4.927,3A1.92,1.92,0,0,0,3,4.927V18.414a1.927,1.927,0,0,0,1.927,1.927H18.414a1.927,1.927,0,0,0,1.927-1.927V11.67H18.414v6.744H4.927V4.927H11.67V3H4.927m12.312.963a.666.666,0,0,0-.462.193L15.6,5.322,18.009,7.73l1.175-1.166a.651.651,0,0,0,0-.915L17.692,4.156a.643.643,0,0,0-.453-.193M14.917,6.006l-7.1,7.11v2.408h2.408l7.1-7.11Z"
                          transform="translate(-3 -3)"
                          fill="#9c9c9c"
                        />
                      </svg>
                    </span>
                  </MUITooltip>
                )}
              </div>
            ) : null}
          </div>
          <div className="ticketDetailsWrapper">
            <div className="patientInfoCol1">
              <h4 className="ticketInfoSubLabel">Auth Number</h4>
              <p className="ticketInfo">
                {o &&
                o !== null &&
                this.state.order.orderActivityApprovals[0] &&
                this.state.order.orderActivityApprovals[0].approvals.authNumber
                  ? this.state.order.orderActivityApprovals[0].approvals
                      .authNumber
                  : "N/A"}
              </p>
              <h4 className="ticketInfoSubLabel">Setup Date</h4>
              <p className="ticketInfo">
                {o &&
                o !== null &&
                this.state.order.setupDate &&
                this.state.order.setupDate !== null
                  ? globalFunctions.formatFlatDate(this.state.order.setupDate)
                  : "N/A"}
              </p>
              <h4 className="ticketInfoSubLabel">Scheduled Delivery Date</h4>
              <p className="ticketInfo">
                {o &&
                o !== null &&
                this.state.order.scheduledDeliveryDate &&
                this.state.order.scheduledDeliveryDate !== null
                  ? globalFunctions.formatFlatDate(
                      this.state.order.scheduledDeliveryDate,
                    )
                  : "N/A"}
              </p>
              <h4 className="ticketInfoNeedsDelivery">
                {" "}
                {o && o !== null && this.state.order.needsRedelivery
                  ? "Needs Redelivery"
                  : ""}{" "}
              </h4>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSpecialNotesForBillingSection() {
    const specialNotesForBilling = this.state?.orderNotes
      ?.filter((note) => note.noteTypeTermId === 88)
      ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    const handleAddBillingNote = () => {
      this.toggleNoteModalPopup();
      this.setState({
        isSpecialNoteForBilling: true,
      });
    };

    const renderBillingTable = () => (
      <MUITableContainer
        component={MUIPaper}
        elevation={0}
        sx={{ maxHeight: 300 }}
      >
        <MUITable size="small">
          <MUITableHead>
            <MUITableRow>
              <MUITableCell sx={{ width: "230px", whiteSpace: "nowrap" }}>
                Created By
              </MUITableCell>
              <MUITableCell sx={{ padding: "0 !important" }}>Note</MUITableCell>
            </MUITableRow>
          </MUITableHead>
          <MUITableBody>
            {specialNotesForBilling.map((note) => (
              <MUITableRow key={note.id}>
                <MUITableCell sx={{ width: "230px", whiteSpace: "nowrap" }}>
                  <div>
                    {User.getDisplayName(
                      this.context.usersIndexed[note.createdById],
                    )}
                  </div>
                  <div>
                    {moment
                      .utc(note.createdAt)
                      .local()
                      .format("M/D/YYYY h:mma")}
                  </div>
                </MUITableCell>
                <MUITableCell>{note.text}</MUITableCell>
              </MUITableRow>
            ))}
          </MUITableBody>
        </MUITable>
      </MUITableContainer>
    );

    // Show the list of notes in these queues, or if there are any.
    const showBillingNotes =
      (this.state.eOrder?.orderStatusReasonId === 74 || // Needs Billed
        this.state.eOrder?.orderStatusReasonId === 1 || // Billed
        this.state.eOrder?.orderStatusReasonId === 68) && // Service - Approval
      specialNotesForBilling?.length > 0;

    // Allow adding notes in these queues
    const showAddButton =
      this.state.eOrder?.orderStatusReasonId === 68 || // Service - Approval
      this.state.eOrder?.orderStatusReasonId === 72 || // Service - CST -  Need Part Number
      this.state.eOrder?.orderStatusReasonId === 57; // Service - Documentation Follow Up

    if (!showBillingNotes && !showAddButton) {
      return null;
    }

    return (
      <>
        <h3 className="ticketInfoLabel">Billing</h3>
        <MUIBox
          sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}
        >
          {specialNotesForBilling?.length > 0 && renderBillingTable()}
          {showAddButton && (
            <MUITooltip
              title={
                this.canUseOldExperience()
                  ? ""
                  : "Please use new experience to add billing notes"
              }
              placement="top"
            >
              <span>
                <MUIButton
                  sx={{ width: "fit-content", margin: "0 .8rem" }}
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<MUIAddIcon />}
                  disabled={!this.canUseOldExperience()}
                  onClick={handleAddBillingNote}
                >
                  Create Billing Note
                </MUIButton>
              </span>
            </MUITooltip>
          )}
        </MUIBox>
      </>
    );

    return null;
  }

  renderTicketDetailsBody() {
    if (this.state.isOrderDetails) {
      return;
    }
    return (
      <MUIBox>
        {this.renderSpecialNotesForBillingSection()}
        {this.renderTicketDetailsInsurance()}
        {this.renderTicketDetailsInformation()}
        {this.renderServiceTicketParts()}
        <MDBRow>
          {this.renderABNButton()}
          {this.renderAddServicePartButton()}
        </MDBRow>
        {this.renderServiceTicketGenericParts()}
      </MUIBox>
    );
  }

  renderTabContent() {
    return (
      <MDBTabContent
        activeItem={this.state.items["ticketDetails"]}
        style={{ paddingTop: "0rem !important" }}
        className={this.state.isOrderDetails ? "" : "tabContent"}
      >
        {this.state.isOrderDetails &&
        this.state.curOrder.setupDate &&
        this.state.curOrder.setupDate !== null ? (
          <MDBTabPane tabId="1">{this.renderApprovalInformation()}</MDBTabPane>
        ) : this.state.curOrder.parentOrder === null ? (
          <div
            style={{
              width: "min-content",
              margin: "0 auto",
              whiteSpace: "nowrap",
              color: "#A1A1A1",
            }}
          >
            No Approval Data (order still in process)
          </div>
        ) : null}
        <MDBTabPane tabId={this.state.isOrderDetails ? "3" : "2"}>
          {this.renderAttachments()}
        </MDBTabPane>
      </MDBTabContent>
    );
  }

  renderOrderDetailsCard() {
    if (this.state.TabsOneActiveItem !== "4") {
      return;
    }

    return (
      <MUIContainer style={{ minHeight: "100vh" }} id={"orderDetailsContainer"}>
        {/* HEADER */}
        {this.renderTicketDetailsHeader()}
        <MUIAlert severity="warning" variant="filled">
          <MUIAlertTitle>This view is deprecated</MUIAlertTitle>
          Please use the New Experience; this view will be removed from Sales
          Pilot soon.
        </MUIAlert>
        <MUIBox
          className={
            this.state.isOrderDetails &&
            this.state.curOrder.setupDate &&
            this.state.curOrder.setupDate !== null
              ? "approval-details-tab"
              : "ticketDetailsBody"
          }
          style={{ overflow: "hidden", paddingTop: "0" }}
        >
          {/* BODY */}
          {this.renderTabContent()}
          {this.renderTicketDetailsBody()}
          {/* FOOTER */}
          {this.renderQueueRoutingOptions()}
          <ReactTooltip />
        </MUIBox>
      </MUIContainer>
    );
  }

  handleEditBtnClick() {
    if (!this.canEditPatientInfoInOldExperience()) {
      toast.warn(this.legacyPatientInfoEditTooltip);
      return;
    }
    this.setState({
      ticketDetailsModalOpen: false,
      canEditBasicInfo: true,
      canEditInsuranceInfo: false,
      canEditClinicalInfo: false,
      TabsOneActiveItem: "2",
    });
    if (this.state.curOrder) {
      this.setState({
        shouldOpenOrderId:
          this.state.curOrder.id || this.state.curOrder.orderId,
      });
    } else {
      this.setState({ shouldOpenOrderId: null });
    }
  }

  handleEditInsuranceBtnClick() {
    if (!this.canEditPatientInfoInOldExperience()) {
      toast.warn(this.legacyPatientInfoEditTooltip);
      return;
    }
    this.setState({
      ticketDetailsModalOpen: false,
      canEditInsuranceInfo: true,
      canEditBasicInfo: false,
      canEditClinicalInfo: false,
      TabsOneActiveItem: "3",
    });
    if (this.state.curOrder) {
      this.setState({
        shouldOpenOrderId:
          this.state.curOrder.id || this.state.curOrder.orderId,
      });
      if (this.state.curOrder.isApproved === true) {
        this.setState({
          canEditInsuranceInfo: false,
        });
      }
    } else {
      this.setState({ shouldOpenOrderId: null });
    }
  }

  handleEditClinicalInformationButtonClicked() {
    if (!this.canEditPatientInfoInOldExperience()) {
      toast.warn(this.legacyPatientInfoEditTooltip);
      return;
    }
    this.setState({
      ticketDetailsModalOpen: false,
      canEditBasicInfo: false,
      canEditInsuranceInfo: false,
      canEditClinicalInfo: true,
      TabsOneActiveItem: "5",
    });
    if (this.state.curOrder) {
      this.setState({
        shouldOpenOrderId:
          this.state.curOrder.id || this.state.curOrder.orderId,
      });
    } else {
      this.setState({ shouldOpenOrderId: null });
    }
  }

  toggleEditBasicInfo() {
    this.setState({
      canEditBasicInfo: false,
      canEditInsuranceInfo: false,
      radioBtnSelected: false,
      radio: {
        serviceTicketAction: "",
        pickupTicketAction: { label: "", value: "" },
      },
    });
  }

  refreshTicket(dontToggle) {
    if (!dontToggle) {
      this.togglePills("rightMenu", "2");
    }
    let item = this.state.items;
    item.rightMenu = "2";
    this.setState(
      {
        orderRetrieved: false,
        items: item,
        orderAttachmentsLoading: true,
        servicePartsLoaded: false,
      },
      () => {
        this.getApprovalsByOrder();
      },
    );

    setTimeout(() => {
      this.setState({
        orderAttachmentsLoading: false,
      });
    }, 1);

    if (!dontToggle) {
      this.toggleAddServicePartsModal();
    }
  }

  renderAddPartCreateQuoteModal() {
    if (!this.state.addPartCreateQuoteModal) {
      return;
    }
    const { productTypes, productSubTypes } = this.context;

    let st = this.state;
    if (!st.addPartCreateQuoteModal) {
      return;
    }

    let baseUnitInfo = {
      makeModel: this.state.currentBaseUnit,
      serial: this.state.baseUnitSerial,
      hcpcs: this.state.baseUnitHCPCS,
    };

    if (!this.state.curOrder) {
      if (this.state.addPartCreateQuoteModal) {
        this.setState({
          addPartCreateQuoteModal: false,
        });
      }
      if (this.state.createQuoteSmall) {
        this.setState({
          createQuoteSmall: false,
        });
      }
      return;
    }

    let providerNotFoundData = null;

    if (
      this.state.eOrder.orderingProviderNotFound &&
      this.state.eOrder.jsonOrderingProviderNotFoundData
    ) {
      const provider =
        JSON.parse(this.state.eOrder.jsonOrderingProviderNotFoundData) || null;

      providerNotFoundData = (() => {
        const name = provider.name || "";

        const location = [provider.city, provider.state]
          .filter(Boolean)
          .join(", ");

        const npi = provider.npi || "";

        const titleParts = [name, location || null, npi || null].filter(
          Boolean,
        );

        return {
          title: titleParts.join(" - "),
          npi: npi,
        };
      })();
    }

    return (
      <CreateQuoteModalFromTicket
        baseUnitInfo={baseUnitInfo}
        refresh={this.refreshTicket.bind(this)}
        parentOrder={this.state.curOrder.parentOrder}
        // canNotMinimize={ true }
        history={this.props.history}
        serviceTicket={false}
        addParts={true}
        serviceProducts={this.state.serviceOrderProducts}
        order={this.state.curOrder}
        currentFullOrder={this.state.eOrder}
        products={this.state.orderProducts}
        productTypes={productTypes}
        productSubTypes={productSubTypes}
        saveOrder={(e) => this.savePatient.bind(null)}
        onToggle={() => {
          this.setState({
            addPartCreateQuoteModal: !this.state.addPartCreateQuoteModal,
          });
        }}
        patient={this.state.ePatient}
        onSmall={() => {
          this.createQuoteSmallToggle();
        }}
        small={this.state.createQuoteSmall}
        providerInformation={
          providerNotFoundData
            ? providerNotFoundData
            : this.state.selectedTicketProvider
        }
      />
    );
  }

  createQuoteSmallToggle() {
    toast.warn("Leaving this ticket will cause changes to quote to be lost");
    this.setState({
      createQuoteSmall: !this.state.createQuoteSmall,
    });
  }
  createNewTicket() {
    const { queueRoutesIndexed } = this.context;
    const { orderStatusReasonsIndexed } = this.context;
    const { orderActivityTypesIndexed } = this.context;

    let queueRoute = queueRoutesIndexed[this.state.radio.queueRouting];
    let orderActivityType =
      orderActivityTypesIndexed[queueRoute.orderActivityTypeId];
    let orderStatusReason =
      orderStatusReasonsIndexed[queueRoute.toOrderStatusReasonId];
    let ticket = {
      orderActivityType: orderActivityType,
      orderStatusReason: orderStatusReason,
    };

    this.createOrder(ticket);
  }

  handleSubtypeCheckbox(event) {
    let td = this.state.thirtyDayFit;
    td = event.target.checked;
    this.setState({
      thirtyDayFit: td,
    });
  }

  renderCreateServiceTicketModal() {
    if (!this.state.createServiceTicketModalOpen) {
      return;
    }
    if (
      !this.state.orderApprovalsLoading &&
      !this.state.orderApprovalsLoaded &&
      this.state.curOrderId
    ) {
      this.getApprovalsByOrder();
    }
    let typeOfTicketToCreate = this.state.typeOfTicketToCreate;

    return (
      <MDBModal
        className="serviceTicketModal"
        centered
        size="lg"
        isOpen={this.state.createServiceTicketModalOpen}
        toggle={() => {
          return;
        }}
      >
        {this.renderCreateTicketHeader(typeOfTicketToCreate)}
        {this.renderCreateTicketBody(typeOfTicketToCreate)}
        {this.renderCreateTicketFooter()}
      </MDBModal>
    );
  }
  renderCreateTicketHeader(ticketType) {
    let ticketTypeString = "Create " + ticketType + " Ticket - ";

    return (
      <MDBModalHeader className="serviceTicketHeader">
        <div style={{ fontWeight: "500", padding: ".5rem" }}>
          {this.state.canEditBasicInfo && this.state.canEditInsuranceInfo
            ? ticketTypeString + "Edit Basic Info"
            : ticketTypeString + "Confirm Basic Info"}
          <svg
            id="Group_206"
            onClick={() =>
              this.setState({
                canEditBasicInfo: !this.state.canEditBasicInfo,
                canEditInsuranceInfo: !this.state.canEditInsuranceInfo,
                basicInfoValidated: false,
                insuranceInfoValidated: false,
                createTicketNote: null,
              })
            }
            className={
              this.state.canEditBasicInfo
                ? "serviceTixModalEditBtn editBtnIsHidden"
                : "serviceTixModalEditBtn"
            }
            data-name="Group 206"
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 35.911 35.911"
          >
            <g id="Group_167" data-name="Group 167" transform="translate(0 0)">
              <g
                id="MDI_square-edit-outline"
                data-name="MDI / square-edit-outline"
                opacity="0.8"
              >
                <rect
                  id="Boundary"
                  width="35"
                  height="35"
                  fill="#9C9C9C"
                  opacity="0"
                />
                <path
                  id="Path_square-edit-outline"
                  data-name="Path / square-edit-outline"
                  d="M5.993,3A2.982,2.982,0,0,0,3,5.993V26.941a2.993,2.993,0,0,0,2.993,2.993H26.941a2.993,2.993,0,0,0,2.993-2.993V16.467H26.941V26.941H5.993V5.993H16.467V3H5.993M25.115,4.5a1.034,1.034,0,0,0-.718.3L22.572,6.606l3.741,3.741,1.825-1.811a1.012,1.012,0,0,0,0-1.421L25.819,4.8a1,1,0,0,0-.7-.3M21.509,7.668,10.482,18.711v3.741h3.741L25.25,11.409Z"
                  transform="translate(1.489 1.489)"
                  fill="#9C9C9C"
                />
              </g>
            </g>
          </svg>
          {this.state.canEditBasicInfo &&
          this.state.canEditInsuranceInfo ? null : (
            <svg
              onClick={() => {
                this.toggleCreateTicketModal();
                this.setState({
                  createTicketOrderId: null,
                });
              }}
              className="closeModalIcon closeCreateTicketModalIcon"
              id="MDI_window-close"
              data-name="MDI / window-close"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <g
                id="Boundary"
                fill="#9c9c9c"
                stroke="rgba(0,0,0,0)"
                stroke-width="1"
                opacity="0"
              >
                <rect width="32" height="32" stroke="none" />
                <rect x="0.5" y="0.5" width="32" height="32" fill="none" />
              </g>
              <path
                id="Path_window-close"
                data-name="Path / window-close"
                d="M15.653,13.814l6.976,6.976v1.838H20.79l-6.976-6.976L6.838,22.628H5V20.79l6.976-6.976L5,6.838V5H6.838l6.976,6.976L20.79,5h1.838V6.838Z"
                transform="translate(1.296 1.08)"
                fill="#9c9c9c"
              />
            </svg>
          )}
        </div>
      </MDBModalHeader>
    );
  }
  renderCreateTicketBody(ticketType) {
    return (
      <MDBModalBody
        style={{
          backgroundColor: "#F9F9F9",
          padding: "0rem 0rem 1.2rem",
          maxHeight: "65vh",
          overflowY: "auto",
        }}
      >
        {this.state.patientInfoRetrieved === false ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              minHeight: "100vh",
              paddingTop: "5vh",
            }}
          >
            <MDBSpinner></MDBSpinner>
          </div>
        ) : (
          <>
            {this.renderBasicInfo()}
            {!this.state.canEditBasicInfo ? (
              <>
                <div
                  className={
                    this.state.basicInfoValidated
                      ? "verifyInfoStep infoVerifiedIndicator"
                      : "verifyInfoStep"
                  }
                >
                  1
                </div>
                {this.state.basicInfoValidated ? null : (
                  <div className="validateButtonContainer ">
                    <button
                      className="validateButton"
                      onClick={() =>
                        this.setState({ basicInfoValidated: true })
                      }
                    >
                      Confirm
                    </button>
                  </div>
                )}
              </>
            ) : null}
            {ticketType.toLowerCase() !== "pickup" &&
            ticketType.toLowerCase() !== "billing issue"
              ? this.renderInsuranceCard()
              : null}
            {ticketType.toLowerCase() !== "pickup" &&
            ticketType.toLowerCase() !== "billing issue" ? (
              !this.state.canEditBasicInfo ? (
                <>
                  <div
                    className={
                      this.state.insuranceInfoValidated
                        ? "verifyInfoStep step2 infoVerifiedIndicator"
                        : "verifyInfoStep step2"
                    }
                  >
                    2
                  </div>
                  {this.state.insuranceInfoValidated ? null : (
                    <div className="validateButtonContainer validateButtonContainer2">
                      <button
                        onClick={() =>
                          this.setState({ insuranceInfoValidated: true })
                        }
                        className="validateButton"
                      >
                        Confirm
                      </button>
                    </div>
                  )}
                </>
              ) : null
            ) : null}
          </>
        )}
        {this.state.canEditBasicInfo ? null : (
          <>
            {this.renderQueueRoutingOptionsInitialCreate(ticketType)}
            {this.renderCreateTicketNoteSection()}
          </>
        )}
      </MDBModalBody>
    );
  }

  renderCreateTicketNoteSection() {
    return (
      <Card
        className="patientInformationCard"
        style={{ padding: ".5rem 1rem 1rem" }}
      >
        <label className="cardLabel addNoteCardLabel">Add Note</label>
        <textarea
          style={{ padding: ".5rem", borderRadius: "5px" }}
          placeholder={"Add note text here (required)"}
          type={"text"}
          id="createTicketNoteText"
          rows="2"
          value={this.state.createTicketNote || ""}
          onChange={(e) => {
            this.setValue(e.target.value);
          }}
        />
        <div
          className={
            this.state.createTicketNote
              ? "verifyInfoStep step4 infoVerifiedIndicator"
              : "verifyInfoStep step4"
          }
        >
          {this.state.typeOfTicketToCreate.toLowerCase() !== "pickup" ? 4 : 3}
        </div>
      </Card>
    );
  }

  renderCreateTicketFooter() {
    let disabledSubmit = false;

    return (
      <MDBModalFooter>
        {this.state.canEditBasicInfo && this.state.canEditInsuranceInfo ? (
          <>
            <MDBBtn
              color="gray"
              disabled={
                this.state.patientInfoRetrieved === false ? true : false
              }
              onClick={() => {
                this.setState({ patientInfoRetrieved: false });
                return OrderService.getPatientById(this.state.id).then(
                  (data) => {
                    this.setState({
                      patientAge: moment(
                        data.deceased && data.dateOfDeath
                          ? data.dateOfDeath
                          : undefined,
                      ).diff(data.dateOfBirth, "years", false),
                      patient: data,
                      ePatient: JSON.parse(JSON.stringify(data)),
                      canEditBasicInfo: false,
                      patientInfoRetrieved: true,
                    });
                    this.toggleEditBasicInfo();
                  },
                );
              }}
            >
              Cancel
            </MDBBtn>
            <MDBBtn
              disabled={
                this.state.patientInfoRetrieved === false ? true : false
              }
              onClick={this.savePatient.bind(this)}
              className="successButton"
            >
              Update
            </MDBBtn>
          </>
        ) : (
          <>
            <MDBBtn
              color="gray"
              onClick={() => {
                this.toggleCreateTicketModal();
                this.setState({ createTicketOrderId: null });
              }}
            >
              Close
            </MDBBtn>
            <MDBBtn
              disabled={
                disabledSubmit ||
                (this.state.typeOfTicketToCreate.toLowerCase() === "service" &&
                  (!this.state.basicInfoValidated ||
                    !this.state.insuranceInfoValidated ||
                    !this.state.radio.queueRouting ||
                    !this.state.createTicketNote)) ||
                (this.state.typeOfTicketToCreate.toLowerCase() === "pickup" &&
                  (!this.state.basicInfoValidated ||
                    !this.state.radio.queueRouting ||
                    !this.state.createTicketNote ||
                    this.state.productsAddedList.length === 0)) ||
                (this.state.typeOfTicketToCreate.toLowerCase() ===
                  "billing issue" &&
                  (!this.state.basicInfoValidated ||
                    !this.state.radio.queueRouting ||
                    !this.state.createTicketNote))
              }
              className="successButton"
              onClick={() => {
                disabledSubmit = true;
                this.setState({
                  patientEquipmentLoaded: false,
                  createServiceTicketModalOpen: false,
                });
                this.createNewTicket();
              }}
            >
              {"Create " + this.state.typeOfTicketToCreate}
            </MDBBtn>
          </>
        )}
      </MDBModalFooter>
    );
  }
  handleOrderStatusChange(status) {
    this.setState({
      createNewOrderStatus: status,
    });
    if (
      this.state.createNewOrderReason &&
      this.state.createNewOrderReason.orderStatus !== status.id
    ) {
      this.setState({
        createNewOrderReason: null,
      });
    }
  }

  handleOrderStatusReasonChange(reason) {
    this.setState({
      createNewOrderReason: reason,
    });
  }

  renderNewOrderModal() {
    if (!this.state.openDialogCreateNewOrder) {
      return;
    }

    return (
      <DialogCreateNewOrder
        header={"Create New Order"}
        open={this.state.openDialogCreateNewOrder}
        onClose={() =>
          this.setState({
            openDialogCreateNewOrder: false,
            createNewOrderReason: null,
            addedProduct: null,
            chosenCategory: null,
          })
        }
        selectedOrderTypeRadio={this.state.selectedOrderTypeRadio}
        accountRecentSalesRep={this.state.accountRecentSalesRep}
        accountOwner={this.state.accountOwner}
        salesLocation={this.state.salesLocation}
        serviceLocation={this.state.serviceLocation}
        orderActivityProducts={
          this.state.nOrder.orderActivityProducts
            ? this.state.nOrder.orderActivityProducts
            : []
        }
        orderStatus={this.state.createNewOrderStatus}
        addNewProduct={(product) => this.addNewProduct(product)}
        removeProduct={() => this.removeProduct()}
        categoryOptions={this.getCategoryList()}
        productOptions={this.getProductList()}
        onConfirm={() => this.createOrder()}
        onChangeLocation={(value, type) => this.changeLocation(value, type)}
        onRadioChange={(orderType) => this.getOrderType(orderType)}
        onCategoryChange={(e, value) => this.handleCategoryChange(e, value)}
        onProductChange={(e, value) => this.handleProductSelectChange(e, value)}
        onOrderStatusChange={(e) => this.handleOrderStatusChange(e)}
        onUpdateReasonChange={(e) => this.handleOrderStatusReasonChange(e)}
      />
    );
  }

  renderEditGeneralInformationModal() {
    if (!this.state.editGeneralInformationModal) {
      return;
    }
    let order = this.state.eOrder;
    let o = null;
    let preAuth = null;
    let setupDate = null;
    let orderStatus = null;

    if (this.state.orderRetrieved && order && order !== null) {
      o = order;
      let appr =
        o.orderActivityApprovals.length > 0 && o.orderActivityApprovals[0]
          ? o.orderActivityApprovals[0].approvals
          : null;
      preAuth = appr && appr.authNumber ? appr.authNumber.trim() : null;
      setupDate = o.setupDate;
      orderStatus = o.status;
    }

    return (
      <MUIDialog
        maxWidth="sm"
        fullWidth
        open={this.state.editGeneralInformationModal}
        onClose={() => {
          return;
        }}
      >
        <MUIDialogTitle variant="h6" color="textPrimary">
          {"Edit General Information"}
        </MUIDialogTitle>
        <MUIDialogContent>
          <MUIGrid container spacing={2}>
            <MUIGrid item sm="6" xs="12">
              <MUITextField
                fullWidth
                label={"Auth Number"}
                InputLabelProps={{ shrink: true }}
                value={preAuth ? preAuth : ""}
                onChange={(evt) =>
                  this.approvalAndUpdate("authNumber", evt.target.value)
                }
                variant="standard"
              />
            </MUIGrid>
            <MUIGrid item sm="6" xs="12">
              <MUIDatePicker
                className={
                  orderStatus === 3
                    ? "setupDatePicker"
                    : "setupDatePicker basicInfoDisabled"
                }
                disabled={orderStatus === 3 ? false : true}
                label={"Setup Date"}
                value={setupDate ? moment(setupDate) : null}
                slotProps={{
                  field: {
                    clearable: true,
                  },
                  textField: {
                    fullWidth: true,
                    size: "small",
                    variant: "standard",
                    InputLabelProps: {
                      shrink: true,
                    },
                  },
                }}
                onChange={(e) => this.handleDate("setupDate", e)}
                views={["year", "month", "day"]}
              />
            </MUIGrid>
          </MUIGrid>
        </MUIDialogContent>
        <MUIDialogActions>
          <MUIButton
            variant="text"
            onClick={() => {
              this.getApprovalsByOrder();
              this.setState({ editGeneralInformationModal: false });
            }}
          >
            Cancel
          </MUIButton>
          <MUILoadingButton
            variant="contained"
            loading={this.state.isUpdating}
            loadingPosition="center"
            onClick={() => {
              this.setState({
                isUpdating: true,
              });
              this.updateOrder(o);
            }}
          >
            Confirm
          </MUILoadingButton>
        </MUIDialogActions>
      </MUIDialog>
    );
  }

  renderEditLocationInformationModal() {
    if (!this.state.editLocationInformationModal) {
      return;
    }
    let o = this.state.eOrder;

    return (
      <MUIDialog
        maxWidth="sm"
        fullWidth
        open={this.state.editLocationInformationModal}
        onClose={() => {
          return;
        }}
      >
        <MUIDialogTitle variant="h6" color="textPrimary">
          {"Edit Location Information"}
        </MUIDialogTitle>
        <MUIDialogContent>
          <MUIGrid container spacing={2}>
            {this.renderTicketSalesLocationDropdown()}
            {this.renderTicketServiceLocationDropdown()}
            {this.renderTicketBillingLocationDropdown()}
          </MUIGrid>
        </MUIDialogContent>
        <MUIDialogActions>
          <MUIButton
            variant="text"
            onClick={() => {
              this.getApprovalsByOrder();
              this.setState({ editLocationInformationModal: false });
            }}
          >
            Cancel
          </MUIButton>
          <MUILoadingButton
            variant="contained"
            loading={this.state.isUpdating}
            loadingPosition="center"
            onClick={() => {
              this.setState({
                isUpdating: true,
              });
              this.updateOrder(o);
            }}
          >
            Confirm
          </MUILoadingButton>
        </MUIDialogActions>
      </MUIDialog>
    );
  }

  renderNewComplaintModal() {
    const handlePatientFeedbackSave = (patientFeedback) => {
      const validationIssues = Validator.validate(patientFeedback, {
        issueCategory: {
          required: true,
        },
        issueReason: {
          required: true,
        },
        complimentedUserId: {
          required:
            patientFeedback.issueCategory &&
            patientFeedback.issueCategory.id === 3
              ? true
              : false,
        },
        orderId: {
          required: !this.state.curOrderId ? true : false,
        },
        complaintDescription: {
          required: true,
        },
      });

      this.setState({
        validationIssues: validationIssues,
      });

      if (Object.keys(validationIssues).length === 0) {
        this.addPatientComplaint();
      } else {
        NotistackEnqueueSnackbar("Please correct the displayed issues.", {
          variant: "error",
        });
      }
    };

    const handleChange = (patientIssue) => {
      this.setState((prevState) => ({
        patientIssue: {
          ...prevState.patientIssue,
          ...patientIssue,
        },
      }));
    };

    const handleOnClose = () => {
      this.setState({
        patientIssueDialogOpen: false,
        validationIssues: {},
        patientIssue: {
          issueCategory: null,
          issueReason: null,
          complimentedUserId: null,
          orderId: null,
          complaintDescriptionh: null,
        },
      });
    };

    return (
      <DialogAddPatientFeedback
        open={this.state.patientIssueDialogOpen}
        onClose={() => handleOnClose()}
        patientIssue={this.state.patientIssue}
        orders={this.state.allOrdersNotSorted}
        showOrderDropdown={!this.state.curOrderId}
        onChange={handleChange.bind(this)}
        onConfirm={() => handlePatientFeedbackSave(this.state.patientIssue)}
        validationIssues={this.state.validationIssues}
        loading={this.state.createPatientFeedbackLoading}
      />
    );
  }

  renderNewPatientNoteModal() {
    if (!this.state.createPatientNoteModal) {
      return;
    }
    return (
      <MDBModal
        centered
        size="large"
        className="salesPilotModal"
        isOpen={this.state.createPatientNoteModal}
        toggle={() => {
          return;
        }}
      >
        <MDBModalHeader style={{ borderRadius: "8px" }}>
          <h3>Add Patient Note</h3>
        </MDBModalHeader>
        <MDBModalBody style={{ backgroundColor: "#FFFFFF" }}>
          <form className=" mx-3 grey-text">
            <textarea
              placeholder={"Add note text here"}
              onChange={this.handleNoteChange.bind(this)}
              style={{ width: "100%", height: "200px" }}
            ></textarea>
            <br />
          </form>
          <Col size="12">
            <hr />
          </Col>
        </MDBModalBody>
        <MDBModalFooter>
          <Button
            color={"success"}
            floating
            size="sm"
            data-tip={"Add Patient Note"}
            onClick={() => this.createPatientNote()}
          >
            <Fa size="2x" icon={"check"}>
              {" "}
            </Fa>
          </Button>
          <Button
            color={"red"}
            floating
            size="sm"
            data-tip={"Cancel"}
            onClick={() =>
              this.setState({ createPatientNoteModal: false, noteText: "" })
            }
          >
            <Fa size="2x" icon={"times"}>
              {" "}
            </Fa>
          </Button>
          <ReactTooltip />
        </MDBModalFooter>
      </MDBModal>
    );
  }

  renderNewPhoneModal() {
    if (!this.state.addPhoneModalOpen) {
      return;
    }
    let phone = this.state.newPhoneNumber;
    return (
      <Modal
        centered
        isOpen={this.state.addPhoneModalOpen}
        toggle={() => {
          this.toggleNewPhoneModal();
        }}
      >
        <ModalBody>
          <CardHeader
            style={{ borderRadius: "8px" }}
            className="form-header text-center font-weight-bold blue-gradient"
          >
            <h3>Add Patient Phone</h3>
          </CardHeader>
          <Row>
            <Col size="12">
              <Input
                label="Contact Name"
                value={phone.contactName}
                onChange={(e) => {
                  let n = this.state.newPhoneNumber;
                  n.contactName = e.target.value;
                  this.setState({ newPhoneNumber: n });
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col size="12">
              <Input
                label="Phone Number (dashes only)"
                value={phone.phoneNumber}
                onChange={(e) => {
                  let n = this.state.newPhoneNumber;
                  n.phoneNumber = e.target.value;
                  this.setState({ newPhoneNumber: n });
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col size="12">
              <label>Phone Type</label>
              <Select
                placeholder={"Phone Type"}
                options={this.state.phoneTypes}
                onChange={(val) => {
                  let o = this.state.newPhoneNumber;
                  o.phoneType = val.value;
                  this.setState({ newPhoneNumber: o });
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color={"success"}
            floating
            size="sm"
            data-tip={"Add Patient Phone"}
            onClick={() => this.createPatientPhone()}
          >
            <Fa size="2x" icon={"check"}>
              {" "}
            </Fa>
          </Button>
          <Button
            color={"red"}
            floating
            size="sm"
            data-tip={"Cancel"}
            onClick={() => this.setState({ addPhoneModalOpen: false })}
          >
            <Fa size="2x" icon={"times"}>
              {" "}
            </Fa>
          </Button>
          <ReactTooltip />
        </ModalFooter>
      </Modal>
    );
  }

  renderNewComplaintNoteModal() {
    if (!this.state.complaintNoteModal) {
      return;
    }
    return (
      <MDBModal
        className={"salesPilotModal"}
        centered
        size="large"
        isOpen={this.state.complaintNoteModal}
        toggle={() => {
          return;
        }}
      >
        <MDBModalHeader style={{ borderRadius: "8px" }}>
          <h3>Add New Feedback Note</h3>
        </MDBModalHeader>
        <MDBModalBody style={{ backgroundColor: "#FFFFFF" }}>
          <Input
            label={"Note Text"}
            value={this.state.complaintNoteText}
            onChange={(e) =>
              this.setState({ complaintNoteText: e.target.value })
            }
          />
        </MDBModalBody>
        <MDBModalFooter>
          <Button
            color={"success"}
            floating
            size="sm"
            data-tip={"Add Feedback Note"}
            onClick={() => this.createComplaintNote()}
          >
            <Fa size="2x" icon={"check"}>
              {" "}
            </Fa>
          </Button>

          <Button
            color={"red"}
            floating
            size="sm"
            data-tip={"Cancel"}
            onClick={() =>
              this.setState({
                currentComplaint: {},
                complaintNoteModal: false,
              })
            }
          >
            <Fa size="2x" icon={"times"}>
              {" "}
            </Fa>
          </Button>
          <ReactTooltip />
        </MDBModalFooter>
      </MDBModal>
    );
  }

  renderCancelTicketModal() {
    if (!this.state.cancelTicketModal) {
      return;
    }
    return (
      <MUIDialog
        maxWidth="md"
        open={this.state.cancelTicketModal}
        onClose={() => this.setState({ cancelTicketModal: false })}
      >
        <MUIDialogTitle variant="h6" color="textPrimary">
          {"Cancel Ticket?"}
        </MUIDialogTitle>
        <MUIDialogContent>
          <MUIDialogContentText variant="body1" color="textPrimary">
            Are you sure you want to cancel this ticket?
          </MUIDialogContentText>
        </MUIDialogContent>
        <MUIDialogActions>
          <MUIButton
            variant="text"
            onClick={() => this.setState({ cancelTicketModal: false })}
          >
            Cancel
          </MUIButton>
          <MUIButton
            variant="contained"
            onClick={() => {
              this.cancelTicket();
              this.setState({
                cancelTicketModal: false,
              });
            }}
            autoFocus
          >
            Confirm
          </MUIButton>
        </MUIDialogActions>
      </MUIDialog>
    );
  }

  reopenCancelledTicket(r) {
    const { reasons } = this.context;
    let orderStatuses = this.state.orderStatuses;
    let reasonObj = null;
    let statusObj = null;
    let lastStatusAndReason = null;

    if (r.length > 0) {
      lastStatusAndReason = r.find(
        (x) =>
          x.statusFrom &&
          x.statusFrom !== "Canceled" &&
          x.statusFrom !== "Cancelled" &&
          x.reasonFrom,
      );
    }
    if (lastStatusAndReason) {
      statusObj = orderStatuses.filter(
        (f) =>
          f.label.toLowerCase().replace(/\s/g, "") ===
          lastStatusAndReason.statusFrom.toLowerCase().replace(/\s/g, ""),
      );
      reasonObj = reasons.filter(
        (f) => f.description === lastStatusAndReason.reasonFrom,
      );
      this.statusChanged(statusObj[0].value);
      this.updateReason(reasonObj[0].id);
    }

    this.saveStatusReasonChange();

    this.setState({
      reopenCancelledTicketModal: false,
    });
  }

  renderPaymentInformationModal() {
    if (!this.state.paymentInformationModal) {
      return;
    }
    let order = this.state.eOrder;
    let o = null;
    let appr = {};
    let statusSetup = false;

    if (this.state.orderRetrieved && order && order !== null) {
      o = order;
      let hasApprovals =
        o.orderActivityApprovals && o.orderActivityApprovals.length > 0;
      appr = o.orderActivityApprovals[0]
        ? o.orderActivityApprovals[0].approvals
        : null;
      statusSetup = o.status === 3 || hasApprovals === false;
    }

    if (!this.state.paymentInformationModal) {
      return;
    }
    return (
      <MDBModal
        className={"salesPilotModal"}
        centered
        size="large"
        isOpen={this.state.paymentInformationModal}
        toggle={() => {
          this.setState({ paymentInformationModal: false });
        }}
      >
        <MDBModalHeader style={{ borderRadius: "8px" }}>
          <h3>Payment Information</h3>
        </MDBModalHeader>

        <MDBModalBody style={{ backgroundColor: "#FFFFFF" }}>
          <MDBRow>
            <MDBCol
              size={"6"}
              className={"insuranceSelects insuranceSelectsText"}
            >
              <MDBInput
                type={"number"}
                outline
                style={{ paddingTop: 8 }}
                label={"Deductible"}
                disabled={statusSetup}
                valueDefault={appr ? appr.deductible : ""}
                onChange={(evt) =>
                  this.approvalAndUpdate(
                    "deductible",
                    evt.target.value && evt.target.value.length > 0
                      ? parseFloat(evt.target.value)
                      : null,
                  )
                }
              />
            </MDBCol>

            <MDBCol
              size={"6"}
              className={"insuranceSelects insuranceSelectsText"}
            >
              <MDBInput
                type={"number"}
                outline
                style={{ paddingTop: 8 }}
                label={"Co-Insurance"}
                disabled={statusSetup}
                valueDefault={appr ? appr.coInsurance : ""}
                onChange={(evt) =>
                  this.approvalAndUpdate(
                    "coInsurance",
                    evt.target.value && evt.target.value.length > 0
                      ? parseFloat(evt.target.value)
                      : null,
                  )
                }
              />
            </MDBCol>

            <MDBCol
              size={"6"}
              className={"insuranceSelects insuranceSelectsText"}
            >
              <MDBInput
                type={"number"}
                outline
                style={{ paddingTop: 8 }}
                label={"Pt. Resp"}
                disabled={statusSetup}
                valueDefault={appr ? appr.patientResponsibility : ""}
                onChange={(evt) =>
                  this.approvalAndUpdate(
                    "patientResponsibility",
                    evt.target.value && evt.target.value.length > 0
                      ? parseFloat(evt.target.value)
                      : null,
                  )
                }
              />
            </MDBCol>

            <MDBCol
              size={"6"}
              className={"insuranceSelects insuranceSelectsText"}
            >
              <MDBInput
                type={"number"}
                outline
                style={{ paddingTop: 8 }}
                label={"State Sales Tax"}
                disabled={true}
                value={appr ? appr.stateSalesTax : ""}
                onChange={(evt) =>
                  this.approvalAndUpdate(
                    "stateSalesTax",
                    evt.target.value && evt.target.value.length > 0
                      ? parseFloat(evt.target.value)
                      : null,
                  )
                }
              />
            </MDBCol>

            <MDBCol
              size={"12"}
              className={"insuranceSelects insuranceSelectsText"}
            >
              <MDBInput
                type={"number"}
                outline
                style={{ paddingTop: 8 }}
                label={"Payment On Delivery"}
                disabled={statusSetup}
                valueDefault={appr ? appr.paymentOnDelivery : ""}
                onChange={(evt) =>
                  this.approvalAndUpdate(
                    "paymentOnDelivery",
                    evt.target.value && evt.target.value.length > 0
                      ? parseFloat(evt.target.value)
                      : null,
                  )
                }
              />
            </MDBCol>

            <MDBCol
              size={"12"}
              className={"insuranceSelects insuranceSelectsText"}
            >
              <MDBInput
                type={"number"}
                outline
                style={{ paddingTop: 8 }}
                label={"Payment Collected"}
                disabled={statusSetup}
                valueDefault={appr ? appr.paymentCollected : ""}
                onChange={(evt) =>
                  this.approvalAndUpdate(
                    "paymentCollected",
                    evt.target.value && evt.target.value.length > 0
                      ? parseFloat(evt.target.value)
                      : null,
                  )
                }
              />
            </MDBCol>

            {/* <MDBCol size={ "12" }>
                            <MDBBtn
                                disabled={ this.state.customerSuccessDisabled }
                                outline
                                onClick={ () => this.confirmCustomerSuccessDate() }
                            >
                                Customer Care Rep Called Patient{ " " }
                                { appr && appr.customerSuccessDate
                                    ? "on " + appr.customerSuccessDate
                                    : "" }
                            </MDBBtn>
                        </MDBCol> */}
          </MDBRow>
        </MDBModalBody>
        <MDBModalFooter>
          <Button
            color={"success"}
            floating
            disabled={statusSetup || this.state.isUpdating ? true : false}
            size="sm"
            data-tip={"Update"}
            onClick={() => {
              this.setState({
                isUpdating: true,
              });
              this.updateOrder(o);
            }}
          >
            <Fa size="2x" icon={"check"}>
              {" "}
            </Fa>
          </Button>
          <Button
            color={"red"}
            floating
            size="sm"
            data-tip={"Cancel"}
            onClick={() => {
              this.getApprovalsByOrder();
              this.setState({
                paymentInformationModal: false,
              });
            }}
          >
            <Fa size="2x" icon={"times"}>
              {" "}
            </Fa>
          </Button>
          <ReactTooltip />
        </MDBModalFooter>
      </MDBModal>
    );
  }

  toggleTimelineModalPopup() {
    let newState = !this.state.timelineModalOpen,
      order = this.state.eOrder;

    if (newState === false) {
      this.setState({
        timelineModalOpen: newState,
      });
    } else {
      OrderService.getOrderTimeline(order).then((records) => {
        this.setState({
          timelineModalOpen: newState,
          timelineModalOrder: order,
          timelineModalEntries: records,
        });
      });
    }
  }

  formatTimelineStatus(timelineEntry) {
    if (timelineEntry.status === "ReadyToDeliver") {
      return "Waiting for Delivery";
    } else if (timelineEntry.status === "InProcess") {
      if (timelineEntry.reason === "Verification") {
        return "Intake / Insurance Verification";
      } else {
        return "Insurance Review";
      }
    } else {
      return timelineEntry.status;
    }
  }

  formatStatus = (status) => {
    const statuses = this.state.orderStatuses;
    let i = statuses.findIndex((x) => x.value === status);
    if (statuses[i] !== undefined) {
      return statuses[i].label;
    }
  };

  generateTimelineEntry() {
    if (this.state.timelineModalEntries == null) {
      return;
    }
    let sorted = []
      .concat(this.state.timelineModalEntries)
      .sort(function (a, b) {
        return new Date(a.updatedOn) - new Date(b.updatedOn);
      });
    return sorted.map((att, idx) => {
      let v = true;
      if (idx === 0 || idx % 2 === 0) {
        v = false;
      }
      return (
        <TimelineStep
          color="red-gradient darken-4"
          href="#void"
          inverted={v}
          key={idx}
          icon="calendar-check-o"
        >
          <span style={{ fontSize: "0.88rem" }}>
            {GlobalFunctions.formatDateTime(att.updatedOn)}
            <br />
            {att.updatedBy}
          </span>
          <br />
          <label style={{ fontWeight: 400 }}>
            {this.formatTimelineStatus(att)}
          </label>
          <hr />
          <span>{att.reason}</span>
        </TimelineStep>
      );
    });
  }

  renderOrderTimeline() {
    return <Timeline>{this.generateTimelineEntry()}</Timeline>;
  }

  renderTimelineModal() {
    if (!this.state.timelineModalOpen) {
      return;
    }
    let order = this.state.eOrder;
    let o = null;
    let status = null;
    let lastUpdated = null;
    if (this.state.orderRetrieved && order && order !== null) {
      o = order;
      status = o.status;
      lastUpdated = o.lastUpdatedOn;
    }

    return (
      // <Timeline>{this.generateTimelineEntry()}</Timeline>
      <div className="overFlowFix">
        <Modal
          className={"extraWidth"}
          isOpen={this.state.timelineModalOpen}
          toggle={() => this.toggleTimelineModalPopup()}
          fullHeight
          position="left"
        >
          <ModalHeader
            style={{
              backgroundColor: "#1976D2",
              color: "white",
              borderBottom: "3px solid #145EA8",
            }}
          >
            <h5>
              {o && o !== null ? this.formatStatus(status) : ""} -- Updated:{" "}
              {GlobalFunctions.formatDateTime(
                o && o !== null ? lastUpdated : new Date(),
              )}
            </h5>
          </ModalHeader>
          <ModalBody
            className={"stepContainer"}
            style={{ backgroundColor: "#555" }}
          >
            {this.renderOrderTimeline()}
          </ModalBody>
        </Modal>
      </div>
    );
    // );
  }

  renderReopenTicketModal() {
    if (!this.state.reopenCancelledTicketModal) {
      return;
    }
    let st = this.state,
      order = st.eOrder,
      records = st.ticketRecords;

    let r = [];
    let curDate = new Date();
    let lastUpdatedOnDate = null;
    let differenceInTime = null;
    let differenceInDays = null;
    let voidReopen = null;

    if (this.state.orderRetrieved && order && order !== null) {
      r = records;
      if (this.state.ticketRecordsLoaded && r && r.length > 0) {
        lastUpdatedOnDate = new Date(r[0].updatedOn);
        differenceInTime = curDate.getTime() - lastUpdatedOnDate.getTime();
        differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));
        if (differenceInDays > 30) {
          voidReopen = true;
        } else {
          voidReopen = false;
        }
      }
    }

    if (!this.state.reopenCancelledTicketModal) {
      return;
    }

    return (
      <MUIDialog
        maxWidth="md"
        open={this.state.reopenCancelledTicketModal}
        onClose={() => this.setState({ reopenCancelledTicketModal: false })}
      >
        <MUIDialogTitle variant="h6" color="textPrimary">
          {"Re-Open Cancelled Ticket?"}
        </MUIDialogTitle>
        <MUIDialogContent>
          <MUIDialogContentText variant="body1" color="textPrimary">
            {!voidReopen ? (
              "Are you sure you want to re-open this ticket?"
            ) : (
              <>
                <span
                  style={{ display: "inline-block", paddingBottom: ".5rem" }}
                >
                  This ticket has been cancelled for more than 30 days and{" "}
                  <strong>may not</strong> be re-opened.
                </span>
                <br />
                <span
                  style={{ display: "inline-block", color: MUIRedColor[500] }}
                >
                  A new ticket is required.
                </span>
              </>
            )}
          </MUIDialogContentText>
        </MUIDialogContent>
        <MUIDialogActions>
          {!voidReopen ? (
            <>
              <MUIButton
                variant="text"
                onClick={() =>
                  this.setState({ reopenCancelledTicketModal: false })
                }
              >
                Cancel
              </MUIButton>
              <MUIButton
                variant="contained"
                onClick={() => {
                  this.reopenCancelledTicket(r);
                  this.setState({
                    reopenCancelledTicketModal: false,
                  });
                }}
                autoFocus
              >
                Confirm
              </MUIButton>
            </>
          ) : (
            <MUIButton
              variant="text"
              onClick={() =>
                this.setState({ reopenCancelledTicketModal: false })
              }
            >
              Cancel
            </MUIButton>
          )}
        </MUIDialogActions>
      </MUIDialog>
    );
  }

  renderAddAdditionalPartsModal() {
    if (!this.state.addAdditionalPartsModal) {
      return;
    }
    return (
      <MDBModal
        className={"salesPilotModal"}
        centered
        size="large"
        isOpen={this.state.addAdditionalPartsModal}
        toggle={() => {
          this.setState({ addAdditionalPartsModal: false });
        }}
      >
        <MDBModalHeader style={{ borderRadius: "8px" }}>
          <h3>Add Additional Parts</h3>
        </MDBModalHeader>

        <MDBModalBody style={{ backgroundColor: "#FFFFFF" }}>
          <Row>
            <Col>
              <label>
                Are you sure you want to move this ticket so additional parts
                can be added?
              </label>
            </Col>
          </Row>
        </MDBModalBody>
        <MDBModalFooter>
          <Button
            color={"success"}
            floating
            size="sm"
            data-tip={"Add Additional Parts"}
            onClick={() => {
              this.addAdditionalPArtsToTicket();
            }}
          >
            <Fa size="2x" icon={"check"}>
              {" "}
            </Fa>
          </Button>

          <Button
            color={"red"}
            floating
            size="sm"
            data-tip={"Close"}
            onClick={() =>
              this.setState({
                addAdditionalPartsModal: false,
              })
            }
          >
            <Fa size="2x" icon={"times"}>
              {" "}
            </Fa>
          </Button>
          <ReactTooltip />
        </MDBModalFooter>
      </MDBModal>
    );
  }

  renderCloseComplaintModal() {
    if (!this.state.closeComplaintModal) {
      return;
    }
    return (
      <MDBModal
        className={"salesPilotModal"}
        centered
        size="large"
        isOpen={this.state.closeComplaintModal}
        toggle={() => {
          this.setState({ closeComplaintModal: false });
        }}
      >
        <MDBModalHeader style={{ borderRadius: "8px" }}>
          <h3>Final Feedback Note</h3>
        </MDBModalHeader>

        <MDBModalBody style={{ backgroundColor: "#FFFFFF" }}>
          <textarea
            placeholder="Final feedback note text"
            onChange={(e) =>
              this.setState({ complaintNoteText: e.target.value })
            }
            style={{ width: "100%", height: "200px" }}
          ></textarea>
        </MDBModalBody>
        <MDBModalFooter>
          <Button
            color={"success"}
            floating
            size="sm"
            data-tip={"Create Final Note"}
            onClick={() => {
              this.createComplaintNote(this.closeComplaint.bind(this));
            }}
          >
            <Fa size="2x" icon={"check"}>
              {" "}
            </Fa>
          </Button>

          <Button
            color={"red"}
            floating
            size="sm"
            data-tip={"Cancel"}
            onClick={() =>
              this.setState({
                currentComplaint: {},
                closeComplaintModal: false,
              })
            }
          >
            <Fa size="2x" icon={"times"}>
              {" "}
            </Fa>
          </Button>
          <ReactTooltip />
        </MDBModalFooter>
      </MDBModal>
    );
  }

  renderPatientNameSideCard() {
    const { companyName } = this.context;
    let patient = this.state.patient;
    let st = this.state;

    function convertInches() {
      let feetFromInches = Math.floor(patient.height / 12);
      let inchesRemainder = patient.height % 12;
      let result = feetFromInches + "'" + inchesRemainder + '"';
      return result;
    }

    const dateParts = [];
    const dateOfBirthMoment = moment(patient.dateOfBirth);
    const dateOfDeathMoment = moment(patient.dateOfDeath);
    if (moment(patient.dateOfBirth).isValid()) {
      dateParts.push(dateOfBirthMoment.format("M/D/YYYY"));
    }
    if (patient.deceased) {
      if (moment(patient.dateOfDeath).isValid()) {
        dateParts.push(dateOfDeathMoment.format("M/D/YYYY"));
      } else {
        dateParts.push("? (Deceased)");
      }
    }

    return (
      <div>
        <MDBCardHeader
          className="patientNameSideCardHeader"
          style={{ paddingLeft: "0.5rem" }}
        >
          <div style={{ color: "#5881C1" }}>
            {patient.firstName + " " + patient.lastName}
          </div>
        </MDBCardHeader>
        <MDBCardBody className="patientSideCardBody">
          <MDBCol>
            <MDBRow>
              <td
                className={"patientSideCardInfoText patientSideCardDOBRow"}
                style={{ paddingRight: "10px" }}
              >
                {dateParts.join(" - ")}
              </td>

              <td
                className="patientSideCardInfoText patientSideCardDOBRow"
                style={{ paddingRight: "10px" }}
              >
                {patient.gender && patient.gender !== null
                  ? patient.gender.toLowerCase() !== "other"
                    ? "Age: " +
                      this.state.patientAge +
                      patient.gender.substring(0, 1)
                    : "Age: " + this.state.patientAge + "X"
                  : null}
              </td>

              {patient.weight && patient.weight !== null ? (
                <td
                  className="patientSideCardInfoText patientSideCardDOBRow"
                  style={{ paddingRight: "10px" }}
                >
                  {patient.weight + "lbs"}
                </td>
              ) : null}

              {patient.height && patient.height !== null ? (
                <td
                  className="patientSideCardInfoText patientSideCardDOBRow"
                  style={{ paddingRight: "10px" }}
                >
                  {convertInches()}
                </td>
              ) : null}
            </MDBRow>

            {patient && patient.brightreeExternalId ? (
              <MDBRow>
                <td className={"sideCardSmallFont"}>
                  {companyName !== "corkmedical" ? (
                    <a
                      className="ticketDetailsHeaderInfo"
                      href={`https://brightree.net/F1/02200/OrbitMedical/Patient/frmPatientSummary.aspx?PatientKey=${patient.brightreeExternalKey}&showAck=1`}
                      target="_blank"
                      style={{ textDecoration: "underline" }}
                    >
                      {`Brightree ID: ${patient.brightreeExternalId}`}
                    </a>
                  ) : (
                    ""
                  )}
                </td>
              </MDBRow>
            ) : null}

            {st.accountRecentSalesRep && st.accountRecentSalesRep !== null ? (
              <MDBRow className={"salesRepRow"}>
                <td style={{ minWidth: "8rem" }}>{"Sales Rep: "}</td>
                {st.accountRecentSalesRep ? (
                  <td>
                    {st.accountRecentSalesRep.firstname +
                      " " +
                      st.accountRecentSalesRep.lastname}
                  </td>
                ) : null}
                {/* <td>{st.accountRecentSalesRep.firstname + " " + st.accountRecentSalesRep.lastname}</td> */}

                {/* <td>{ patient.account.owner.firstname + " " + patient.account.owner.lastname }</td> */}
              </MDBRow>
            ) : (
              <MDBRow style={{ minHeight: "1.5rem" }}></MDBRow>
            )}

            {this.state.patientSalesLocation &&
            this.state.patientSalesLocation !== null ? (
              <MDBRow className={"salesLocationRow"}>
                <div>
                  <td style={{ minWidth: "8rem" }}>{"Sales Location: "}</td>
                  <td>
                    {this.state.patientSalesLocation
                      ? this.state.patientSalesLocation.name
                      : ""}
                  </td>
                </div>
              </MDBRow>
            ) : null}

            <MDBRow
              style={
                this.state.patientAge < 18 ||
                this.state.lastChartNotes ||
                this.state.mostRecentMedicareRx
                  ? { marginTop: "0.25rem" }
                  : {}
              }
            >
              {this.state.patientAge < 18 ? (
                <MUIChip
                  label={"Pediatric"}
                  size={"small"}
                  className={"chipRow"}
                  style={{ backgroundColor: "#5881C1", color: "white" }}
                />
              ) : (
                <div></div>
              )}
              {this.state.lastChartNotes ? (
                <MUIChip
                  label={"Chart Notes"}
                  size={"small"}
                  className="clickableChip"
                  style={{
                    backgroundColor: "#E3EBFA",
                    border: "1px solid #316BCF32",
                    color: "#316BCF",
                    borderRadius: "16px",
                  }}
                  onClick={() => {
                    OrderService.downloadDoc(this.state.lastChartNotes.id)
                      .then((res) => {
                        if (res) {
                          let file = new File(
                            [res],
                            this.state.lastChartNotes.filename,
                            null,
                          );
                          let url = window.URL.createObjectURL(file);
                          let temp = document.createElement("a");
                          temp.href = url;
                          temp.setAttribute(
                            "download",
                            this.state.lastChartNotes.filename,
                          );
                          temp.click();
                          window.URL.revokeObjectURL(url);
                        } else {
                          toast.warn(
                            "There was an issue downloading the file. It may not exist on the server yet.",
                          );
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        toast.error("There was an issue downloading the file.");
                      });
                  }}
                />
              ) : null}
              {this.state.mostRecentMedicareRx ? (
                <MUIChip
                  label={"Medicare Rx"}
                  size={"small"}
                  className="clickableChip"
                  style={{
                    margin: "0 .5rem",
                    backgroundColor: "#E3EBFA",
                    border: "1px solid #316BCF32",
                    color: "#316BCF",
                    borderRadius: "16px",
                  }}
                  onClick={() => {
                    OrderService.downloadDoc(this.state.mostRecentMedicareRx.id)
                      .then((res) => {
                        if (res) {
                          let file = new File(
                            [res],
                            this.state.mostRecentMedicareRx.filename,
                            null,
                          );
                          let url = window.URL.createObjectURL(file);
                          let temp = document.createElement("a");
                          temp.href = url;
                          temp.setAttribute(
                            "download",
                            this.state.mostRecentMedicareRx.filename,
                          );
                          temp.click();
                          window.URL.revokeObjectURL(url);
                        } else {
                          toast.warn(
                            "There was an issue downloading the file. It may not exist on the server yet.",
                          );
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        toast.error("There was an issue downloading the file.");
                      });
                  }}
                />
              ) : null}
            </MDBRow>
          </MDBCol>
          <MDBCol className={"sidebarAlertColumn summaryAlertColumn"}>
            {this.renderPatientIssueSummaryAlert()}
          </MDBCol>
        </MDBCardBody>
      </div>
    );
  }

  renderPatientContactSideCard() {
    let patient = this.state.patient;

    return (
      <div>
        <MDBCardHeader
          className={
            this.state.canEditBasicInfo &&
            !this.state.createServiceTicketModalOpen &&
            this.state.patientInfoRetrieved !== false
              ? "patientSideCardHeader canEdit"
              : "patientSideCardHeader"
          }
        >
          <div>Contact </div>
          {this.state.TabsOneActiveItem === "3" ||
          this.state.TabsOneActiveItem === "5" ||
          this.state.patientInfoRetrieved === false ? null : this.state
              .curOrder && this.state.curOrder.status == "Cancelled" ? null : (
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="sideCardEditBtn"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                aria-disabled={!this.canEditPatientInfoInOldExperience()}
                style={{
                  cursor: this.canEditPatientInfoInOldExperience()
                    ? "pointer"
                    : "not-allowed",
                  opacity: this.canEditPatientInfoInOldExperience() ? 1 : 0.5,
                }}
                onClick={() => this.handleEditBtnClick()}
              >
                <g
                  id="Group_206"
                  data-name="Group 206"
                  transform="translate(-4.422 -293.097)"
                >
                  <g
                    id="Group_167"
                    data-name="Group 167"
                    transform="translate(4.422 293.097)"
                  >
                    <g
                      id="MDI_square-edit-outline"
                      data-name="MDI / square-edit-outline"
                      transform="translate(0 0)"
                      opacity="0.8"
                    >
                      <rect
                        id="Boundary"
                        width="24"
                        height="24"
                        fill="#ffffff"
                        opacity="0"
                      />
                      <path
                        id="Path_square-edit-outline"
                        data-name="Path / square-edit-outline"
                        d="M5.25,3A2.242,2.242,0,0,0,3,5.25V21a2.25,2.25,0,0,0,2.25,2.25H21A2.25,2.25,0,0,0,23.25,21V13.125H21V21H5.25V5.25h7.875V3H5.25M19.628,4.125a.777.777,0,0,0-.54.225L17.715,5.711l2.813,2.812L21.9,7.162a.761.761,0,0,0,0-1.069L20.156,4.35a.751.751,0,0,0-.529-.225M16.916,6.51l-8.291,8.3v2.812h2.813l8.291-8.3Z"
                        transform="translate(0.375 0.375)"
                        fill="#ffffff"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          )}
        </MDBCardHeader>
        <MDBCardBody className={"patientSideCardBody"}>
          {!patient.address && !patient.phone && !patient.email ? (
            <MDBCol style={{ textAlign: "center", padding: "1rem 0" }}>
              No Data
            </MDBCol>
          ) : (
            <MDBCol>
              {patient.address && patient.address !== null ? (
                <MDBRow className="patientSideCardRow">
                  <MDBCol sm={"1"} className={"iconCol"}>
                    <MDBIcon
                      icon={"home"}
                      className={"sidePanelIcons"}
                    ></MDBIcon>
                  </MDBCol>
                  <MDBCol style={{ marginLeft: "1rem" }}>
                    <MDBRow>
                      <p className="sidePanelInfoSubheader subheaderWithIcon">
                        Address
                      </p>
                    </MDBRow>
                    <MDBRow>
                      {patient.address ? (
                        <td
                          className={
                            "patientSideCardInfoText subheaderWithIcon"
                          }
                        >
                          {" "}
                          {patient.address +
                            (patient.address.slice(-1) === "," ||
                            patient.address.slice(-1) === "."
                              ? " "
                              : ", ")}{" "}
                        </td>
                      ) : (
                        <td
                          className={
                            "patientSideCardInfoText subheaderWithIcon"
                          }
                        >
                          {" "}
                          No Address{" "}
                        </td>
                      )}
                    </MDBRow>
                    <MDBRow style={{ marginTop: "10px" }}>
                      <td
                        className={"patientSideCardInfoText subheaderWithIcon"}
                      >
                        {" "}
                        {(patient.city ? patient.city + ", " : "") +
                          (patient.state ? patient.state + ", " : "") +
                          (patient.zipCode ? patient.zipCode : "")}{" "}
                      </td>
                    </MDBRow>
                  </MDBCol>
                </MDBRow>
              ) : null}
              {patient.phone && patient.phone !== null ? (
                <MDBRow className="patientSideCardRow">
                  <MDBCol sm={"1"} className={"iconCol"}>
                    <MDBIcon
                      icon={"phone-alt"}
                      className={"sidePanelIcons"}
                    ></MDBIcon>
                  </MDBCol>
                  <MDBCol style={{ marginLeft: "1rem" }}>
                    <MDBRow>
                      <p className="sidePanelInfoSubheader subheaderWithIcon">
                        Home Phone
                      </p>
                    </MDBRow>
                    <MDBRow>
                      <td
                        className={"patientSideCardInfoText subheaderWithIcon"}
                      >
                        {" "}
                        {patient.phone}{" "}
                      </td>
                    </MDBRow>
                  </MDBCol>
                </MDBRow>
              ) : null}
              {patient.email && patient.email !== null ? (
                <MDBRow className="patientSideCardRow">
                  <MDBCol sm={"1"} className={"iconCol"}>
                    <MDBIcon
                      icon={"envelope"}
                      className={"sidePanelIcons"}
                    ></MDBIcon>
                  </MDBCol>
                  <MDBCol style={{ marginLeft: "1rem" }}>
                    <MDBRow>
                      <p className="sidePanelInfoSubheader subheaderWithIcon">
                        Email
                      </p>
                    </MDBRow>
                    <MDBRow>
                      <td
                        className={"patientSideCardInfoText subheaderWithIcon"}
                      >
                        {" "}
                        {patient.email}{" "}
                      </td>
                    </MDBRow>
                  </MDBCol>
                </MDBRow>
              ) : null}
            </MDBCol>
          )}
        </MDBCardBody>
      </div>
    );
  }
  checkForCurrentMonth(date) {
    let createDate = new Date(date);
    let today = new Date();
    return (
      createDate.getFullYear() === today.getFullYear() &&
      createDate.getMonth() === today.getMonth()
    );
  }

  checkApiResultForSuccess(type, stringResult) {
    let success = true;
    if (type === "primary") {
      if (
        stringResult.includes("Error Reason") ||
        !stringResult.includes('"ErrorDescription":null')
      ) {
        success = false;
      }
    }
    return success;
  }

  canSubmitInsurance() {
    let apiRes = this.state.verificationResults;
    let mostRecentInsuranceResults = {
      pvPrimary: null,
    };

    let pvPrimary = null;
    if (this.state.curOrderId) {
      pvPrimary =
        apiRes &&
        apiRes.length > 0 &&
        apiRes.filter(
          (x) =>
            x.resultType === "Primary" &&
            x.source === "pVerify" &&
            x.orderId === this.state.curOrderId,
        ).length > 0
          ? apiRes.filter(
              (x) =>
                x.resultType === "Primary" &&
                x.source === "pVerify" &&
                x.orderId === this.state.curOrderId,
            )
          : null;
    } else {
      pvPrimary =
        apiRes &&
        apiRes.length > 0 &&
        apiRes.filter(
          (x) => x.resultType === "Primary" && x.source === "pVerify",
        ).length > 0
          ? apiRes.filter(
              (x) => x.resultType === "Primary" && x.source === "pVerify",
            )
          : null;
    }
    if (pvPrimary && pvPrimary.length > 0) {
      if (pvPrimary.length > 1) {
        pvPrimary = pvPrimary.sort((a, b) => {
          if (new Date(a.createDate) > new Date(b.createDate)) return -1;
          else if (new Date(a.createDate) === new Date(b.createDate)) return 0;
          else return 1;
        });
      }
      if (pvPrimary[0].stringResult)
        mostRecentInsuranceResults.pvPrimary = pvPrimary[0] || null;
    }
    if (!mostRecentInsuranceResults.pvPrimary) {
      return true;
    }
    if (
      !this.checkForCurrentMonth(
        mostRecentInsuranceResults.pvPrimary.createDate,
      )
    ) {
      return true;
    } else if (
      !this.checkApiResultForSuccess(
        "primary",
        mostRecentInsuranceResults.pvPrimary.stringResult,
      )
    ) {
      return true;
    } else return false;
  }

  canUseOldExperience() {
    const orderStatusReasonId =
      this.state.curOrder?.orderStatusReasonId ??
      this.state.eOrder?.orderStatusReasonId;
    const serviceReason = (
      this.state.curOrder?.serviceReason ||
      this.state.eOrder?.serviceReason ||
      this.state.curServiceOrderReason?.serviceReason ||
      ""
    )
      .trim()
      .toLowerCase();

    return (
      orderStatusReasonId === 61 ||
      orderStatusReasonId === 72 ||
      serviceReason.includes("accessory after the sale")
    );
  }

  canEditPatientInfoInOldExperience() {
    return !!this.state.curOrderId && this.canUseOldExperience();
  }

  renderPatientInsuranceSideCard() {
    const { companyName } = this.context;
    let patient = this.state.patient;
    let canSubmit = this.canSubmitInsurance();
    const currentOrderStatusReasonId =
      this.state.curOrder?.orderStatusReasonId ??
      this.state.eOrder?.orderStatusReasonId;
    const allowLegacyInsuranceActions = [61, 72].includes(
      currentOrderStatusReasonId,
    );
    const forceDisableLegacyInsuranceActions = !allowLegacyInsuranceActions;
    const legacyInsuranceActionsDisabledMessage =
      forceDisableLegacyInsuranceActions
        ? "Please use the new experience to check and manage eligibility"
        : "";

    const buttons = [
      <MUITooltip
        key="one"
        title={legacyInsuranceActionsDisabledMessage}
        placement="top"
      >
        <span>
          <MUIButton
            disabled={forceDisableLegacyInsuranceActions}
            onClick={() =>
              this.setState({
                verificationModalOpen:
                  companyName !== "corkmedical" ? true : false,
              })
            }
          >
            Info
          </MUIButton>
        </span>
      </MUITooltip>,
      this.state.curOrderId ? (
        canSubmit ? (
          <MUITooltip
            title={legacyInsuranceActionsDisabledMessage}
            placement="top"
          >
            <span>
              <MUILoadingButton
                style={{ marginRight: "5px" }}
                key="two"
                disabled={
                  forceDisableLegacyInsuranceActions ||
                  (this.state.curOrder &&
                    this.state.curOrder.status == "Cancelled")
                }
                loading={this.state.submitToPverifyLoading}
                loadingPosition="center"
                onClick={() => this.submitChangesToPverify()}
              >
                {this.state.submitToPverifyLoading ? "" : "Verify"}
              </MUILoadingButton>
            </span>
          </MUITooltip>
        ) : (
          <MUITooltip
            title={legacyInsuranceActionsDisabledMessage}
            placement="top"
          >
            <span>
              <MUILoadingButton
                data-tip="tes2t"
                disabled={true}
                key="two"
                loading={this.state.submitToPverifyLoading}
                loadingPosition="center"
              >
                {this.state.submitToPverifyLoading ? "" : "Verify"}
              </MUILoadingButton>
            </span>
          </MUITooltip>
        )
      ) : null,
    ];
    return (
      <div>
        <MDBCardHeader
          className={
            this.state.canEditInsuranceInfo &&
            !this.state.createServiceTicketModalOpen &&
            this.state.patientInfoRetrieved !== false
              ? "patientSideCardHeader canEdit"
              : "patientSideCardHeader"
          }
        >
          <div>Insurance </div>
          {this.state.TabsOneActiveItem === "2" ||
          this.state.TabsOneActiveItem === "5" ||
          this.state.patientInfoRetrieved === false ? null : this.state
              .curOrder && this.state.curOrder.status == "Cancelled" ? null : (
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="sideCardEditBtn"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                aria-disabled={!this.canEditPatientInfoInOldExperience()}
                style={{
                  cursor: this.canEditPatientInfoInOldExperience()
                    ? "pointer"
                    : "not-allowed",
                  opacity: this.canEditPatientInfoInOldExperience() ? 1 : 0.5,
                }}
                onClick={() => this.handleEditInsuranceBtnClick()}
              >
                <g
                  id="Group_206"
                  data-name="Group 206"
                  transform="translate(-4.422 -293.097)"
                >
                  <g
                    id="Group_167"
                    data-name="Group 167"
                    transform="translate(4.422 293.097)"
                  >
                    <g
                      id="MDI_square-edit-outline"
                      data-name="MDI / square-edit-outline"
                      transform="translate(0 0)"
                      opacity="0.8"
                    >
                      <rect
                        id="Boundary"
                        width="24"
                        height="24"
                        fill="#ffffff"
                        opacity="0"
                      />
                      <path
                        id="Path_square-edit-outline"
                        data-name="Path / square-edit-outline"
                        d="M5.25,3A2.242,2.242,0,0,0,3,5.25V21a2.25,2.25,0,0,0,2.25,2.25H21A2.25,2.25,0,0,0,23.25,21V13.125H21V21H5.25V5.25h7.875V3H5.25M19.628,4.125a.777.777,0,0,0-.54.225L17.715,5.711l2.813,2.812L21.9,7.162a.761.761,0,0,0,0-1.069L20.156,4.35a.751.751,0,0,0-.529-.225M16.916,6.51l-8.291,8.3v2.812h2.813l8.291-8.3Z"
                        transform="translate(0.375 0.375)"
                        fill="#ffffff"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          )}
        </MDBCardHeader>
        <MDBCardBody className={"patientSideCardBody"}>
          {!patient.insuranceSubType && !patient.secondaryInsuranceType ? (
            <MDBCol style={{ textAlign: "center", padding: "1rem 0" }}>
              No Data
            </MDBCol>
          ) : (
            <>
              <MDBCol className={"sidebarAlertColumn"}>
                <MUIAlert
                  className="insuranceAlert"
                  severity={
                    this.state.insuranceVerification.insuranceVerified
                      ? "success"
                      : "error"
                  }
                  action={
                    <MUIButtonGroup
                      size="small"
                      variant="outlined"
                      color="inherit"
                    >
                      {buttons}
                    </MUIButtonGroup>
                  }
                >
                  {this.state.insuranceVerification.insuranceVerified
                    ? "Verified"
                    : "Not Verified"}
                </MUIAlert>
              </MDBCol>
              <MDBCol>
                {patient.insuranceSubType &&
                patient.insuranceSubType !== null ? (
                  <MDBRow className={"patientSideCardRow"}>
                    <MDBCol sm={"1"} className={"iconCol"}>
                      <MDBIcon
                        icon={"shield-alt"}
                        className={"sidePanelIcons"}
                      ></MDBIcon>
                    </MDBCol>
                    <MDBCol
                      sm={"4"}
                      style={{ marginLeft: "1rem", marginBottom: "1rem" }}
                    >
                      <MDBRow>
                        <p className="sidePanelInfoSubheader subheaderWithIcon">
                          Primary Insurance
                        </p>
                      </MDBRow>
                      <MDBRow>
                        <td
                          className={
                            "patientSideCardInfoText subheaderWithIcon"
                          }
                        >
                          {patient.insuranceSubType
                            ? patient.insuranceSubType.name
                            : ""}
                        </td>
                      </MDBRow>
                      <MDBRow className="patientSideCardPolicyGroupRow">
                        <MDBCol
                          md={"6"}
                          className={"patientSideCardPolicyGroupCol"}
                        >
                          <p className={"patientSideCardPolicyGroupText"}>
                            {patient.insurancePolicy
                              ? patient.insurancePolicy
                              : ""}
                          </p>
                        </MDBCol>
                        <MDBCol
                          md={"6"}
                          className={"patientSideCardPolicyGroupCol"}
                        >
                          <p className={"patientSideCardPolicyGroupText"}>
                            {patient.insuranceGroup
                              ? patient.insuranceGroup
                              : ""}
                          </p>
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                    <MDBCol sm={"3"} className={"borderedInsuranceCol"}>
                      <MDBRow>
                        <p className="sidePanelInfoSubheader">Start Date</p>
                      </MDBRow>
                      <MDBRow>
                        <small style={{ marginTop: "-10px" }}>
                          {this.state.insuranceVerification.start}{" "}
                        </small>
                      </MDBRow>
                    </MDBCol>
                    <MDBCol sm={"3"}>
                      <MDBRow>
                        <p p className="sidePanelInfoSubheader">
                          End Date
                        </p>
                      </MDBRow>
                      <MDBRow>
                        <small style={{ marginTop: "-10px" }}>
                          {this.state.insuranceVerification.end}{" "}
                        </small>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>
                ) : null}
                {patient.secondaryInsuranceType &&
                patient.secondaryInsuranceType !== null ? (
                  <MDBRow>
                    <MDBCol sm={"1"} className={"iconCol"}>
                      <MDBIcon
                        icon={"shield-alt"}
                        className={"sidePanelIcons"}
                      ></MDBIcon>
                    </MDBCol>
                    <MDBCol
                      sm={"4"}
                      style={{ marginLeft: "1rem", marginBottom: ".5rem" }}
                    >
                      <MDBRow>
                        <p className="sidePanelInfoSubheader subheaderWithIcon">
                          Secondary Insurance
                        </p>
                      </MDBRow>
                      <MDBRow>
                        <td
                          className={
                            "patientSideCardInfoText subheaderWithIcon"
                          }
                        >
                          {patient.secondaryInsuranceSubType
                            ? patient.secondaryInsuranceSubType.name
                            : ""}
                        </td>
                      </MDBRow>
                      <MDBRow className="patientSideCardPolicyGroupRow">
                        <MDBCol
                          md={"6"}
                          className={"patientSideCardPolicyGroupCol"}
                        >
                          <p className={"patientSideCardPolicyGroupText"}>
                            {patient.secondaryInsurancePolicy
                              ? patient.secondaryInsurancePolicy
                              : ""}
                          </p>
                        </MDBCol>
                        <MDBCol
                          md={"6"}
                          className={"patientSideCardPolicyGroupCol"}
                        >
                          <p className={"patientSideCardPolicyGroupText"}>
                            {patient.secondaryInsuranceGroup
                              ? patient.secondaryInsuranceGroup
                              : ""}
                          </p>
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>
                ) : null}
              </MDBCol>
            </>
          )}
          <ReactTooltip />
        </MDBCardBody>
      </div>
    );
  }

  renderClinicalSideCard() {
    const dataSource = this.state.curOrder
      ? this.state.eOrder
      : this.state.ePatient;
    const stateString = this.state.curOrder
      ? "OrderActivityDiagnosisCodeSelected"
      : "PatientDiagnosisCodeSelected";
    const provider = this.state.curOrder
      ? this.state.selectedTicketProvider
      : this.state.selectedPatientProvider;

    return (
      <div>
        <MDBCardHeader
          className={
            this.state.canEditClinicalInfo &&
            !this.state.createServiceTicketModalOpen &&
            this.state.patientInfoRetrieved !== false
              ? "patientSideCardHeader canEdit"
              : "patientSideCardHeader"
          }
        >
          <div>Clinical </div>
          {this.state.TabsOneActiveItem === "2" ||
          this.state.TabsOneActiveItem === "3" ||
          this.state.patientInfoRetrieved === false ? null : this.state
              .curOrder && this.state.curOrder.status == "Cancelled" ? null : (
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="sideCardEditBtn"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                aria-disabled={!this.canEditPatientInfoInOldExperience()}
                style={{
                  cursor: this.canEditPatientInfoInOldExperience()
                    ? "pointer"
                    : "not-allowed",
                  opacity: this.canEditPatientInfoInOldExperience() ? 1 : 0.5,
                }}
                onClick={() =>
                  this.handleEditClinicalInformationButtonClicked()
                }
              >
                <g
                  id="Group_206"
                  data-name="Group 206"
                  transform="translate(-4.422 -293.097)"
                >
                  <g
                    id="Group_167"
                    data-name="Group 167"
                    transform="translate(4.422 293.097)"
                  >
                    <g
                      id="MDI_square-edit-outline"
                      data-name="MDI / square-edit-outline"
                      transform="translate(0 0)"
                      opacity="0.8"
                    >
                      <rect
                        id="Boundary"
                        width="24"
                        height="24"
                        fill="#ffffff"
                        opacity="0"
                      />
                      <path
                        id="Path_square-edit-outline"
                        data-name="Path / square-edit-outline"
                        d="M5.25,3A2.242,2.242,0,0,0,3,5.25V21a2.25,2.25,0,0,0,2.25,2.25H21A2.25,2.25,0,0,0,23.25,21V13.125H21V21H5.25V5.25h7.875V3H5.25M19.628,4.125a.777.777,0,0,0-.54.225L17.715,5.711l2.813,2.812L21.9,7.162a.761.761,0,0,0,0-1.069L20.156,4.35a.751.751,0,0,0-.529-.225M16.916,6.51l-8.291,8.3v2.812h2.813l8.291-8.3Z"
                        transform="translate(0.375 0.375)"
                        fill="#ffffff"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          )}
        </MDBCardHeader>
        <MDBCardBody className={"patientSideCardBody"}>
          {![
            dataSource?.orderingProviderId,
            dataSource?.firstDiagnosisCodeId,
            dataSource?.secondDiagnosisCodeId,
            dataSource?.thirdDiagnosisCodeId,
            dataSource?.fourthDiagnosisCodeId,
            this.state.ePatient?.diseaseNotes,
            this.state.ePatient?.hasInfectiousDisease,
          ].some(Boolean) &&
          (dataSource?.orderingProviderNotFound === false ||
            (dataSource?.orderingProviderNotFound === true &&
              !dataSource?.jsonOrderingProviderNotFoundData)) ? (
            <MDBCol style={{ textAlign: "center", padding: "1rem 0" }}>
              No Data
            </MDBCol>
          ) : null}
          <MDBCol>
            {dataSource?.orderingProviderId ||
            (dataSource?.orderingProviderNotFound &&
              dataSource?.jsonOrderingProviderNotFoundData) ? (
              <MDBRow className={"patientSideCardRow"}>
                <MDBCol sm={"1"} className={"iconCol"}>
                  <MDBIcon
                    icon={"user-shield"}
                    className={"sidePanelIcons"}
                  ></MDBIcon>
                </MDBCol>
                <MDBCol
                  sm={"10"}
                  style={{ marginLeft: "1rem", marginBottom: "1rem" }}
                >
                  <MDBRow>
                    <p className="sidePanelInfoSubheader subheaderWithIcon">
                      Ordering Provider
                    </p>
                  </MDBRow>
                  <MDBRow>
                    {dataSource.orderingProviderNotFound ? (
                      (() => {
                        let provider = null;

                        if (dataSource.jsonOrderingProviderNotFoundData) {
                          provider =
                            JSON.parse(
                              dataSource.jsonOrderingProviderNotFoundData,
                            ) || null;

                          const providerInformation = (() => {
                            const name = [provider.name];

                            const location = [provider.city, provider.state]
                              .filter(Boolean)
                              .join(", ");

                            const parts = [
                              name,
                              location || null,
                              provider.npi || null,
                            ].filter(Boolean);

                            return parts.join(" - ");
                          })();

                          return (
                            <td className="patientSideCardInfoText subheaderWithIcon">
                              {providerInformation}
                            </td>
                          );
                        }

                        return null;
                      })()
                    ) : provider ? (
                      <td className="patientSideCardInfoText subheaderWithIcon">
                        {provider.title}
                      </td>
                    ) : null}
                  </MDBRow>
                </MDBCol>
              </MDBRow>
            ) : null}
            {dataSource?.firstDiagnosisCodeId ||
            dataSource?.secondDiagnosisCodeId ||
            dataSource?.thirdDiagnosisCodeId ||
            dataSource?.fourthDiagnosisCodeId ? (
              <MDBRow className={"patientSideCardRow"}>
                <MDBCol sm={"1"} className={"iconCol"}>
                  <MDBIcon
                    icon={"shield-virus"}
                    className={"sidePanelIcons"}
                  ></MDBIcon>
                </MDBCol>
                <MDBCol
                  sm={"10"}
                  style={{ marginLeft: "1rem", marginBottom: "1rem" }}
                >
                  <MDBRow>
                    <p className="sidePanelInfoSubheader subheaderWithIcon">
                      Diagnosis Codes
                    </p>
                  </MDBRow>
                  <MDBRow>
                    <td className={"patientSideCardInfoText subheaderWithIcon"}>
                      {[
                        this.state[`first${stateString}`]?.code,
                        this.state[`second${stateString}`]?.code,
                        this.state[`third${stateString}`]?.code,
                        this.state[`fourth${stateString}`]?.code,
                      ]
                        .filter(Boolean)
                        .join(" • ")}
                    </td>
                  </MDBRow>
                </MDBCol>
              </MDBRow>
            ) : null}
            {this.state.ePatient?.diseaseNotes ? (
              <MDBRow className={"patientSideCardRow"}>
                <MDBCol sm={"1"} className={"iconCol"}>
                  <MDBIcon
                    icon={"notes-medical"}
                    className={"sidePanelIcons"}
                  ></MDBIcon>
                </MDBCol>
                <MDBCol
                  sm={"10"}
                  style={{ marginLeft: "1rem", marginBottom: "1rem" }}
                >
                  <MDBRow>
                    <p className="sidePanelInfoSubheader subheaderWithIcon">
                      Disease Notes
                    </p>
                  </MDBRow>
                  <MDBRow>
                    <td className={"patientSideCardInfoText subheaderWithIcon"}>
                      {this.state.ePatient.diseaseNotes}
                    </td>
                  </MDBRow>
                </MDBCol>
              </MDBRow>
            ) : null}
            {this.state.ePatient?.hasInfectiousDisease ? (
              <MDBRow
                className={"patientSideCardRow"}
                style={{ paddingTop: 5 }}
              >
                <MDBCol md={5} style={{ padding: 0 }}>
                  <MUIChip
                    label={"Infectious Disease"}
                    color={
                      this.state.ePatient.hasInfectiousDisease
                        ? "success"
                        : undefined
                    }
                    icon={
                      this.state.ePatient.hasInfectiousDisease === true ? (
                        <MUICheckCircleIcon />
                      ) : this.state.ePatient.hasInfectiousDisease === false ? (
                        <MUICancelIcon />
                      ) : (
                        <MUIHelpOutlineIcon />
                      )
                    }
                    size="small"
                  />
                </MDBCol>
              </MDBRow>
            ) : null}
          </MDBCol>
        </MDBCardBody>
      </div>
    );
  }

  renderOpenOrdersSideCard() {
    return (
      <div className={"sideCardOrderHeightDiv"}>
        <MDBCardHeader
          className={"patientSideCardHeader"}
          style={{ marginBottom: 0 }}
        >
          {" "}
          Open Orders / Tickets{" "}
        </MDBCardHeader>
        <div className={"sideCardDataGird"}>
          <MDBCardBody className={"patientSideCardBody sideCardOrderList"}>
            {this.renderSideTable()}
          </MDBCardBody>
        </div>
      </div>
    );
  }
  renderSideCard() {
    return (
      <MDBCard className={"patientSideCard"}>
        {this.renderPatientNameSideCard()}
        {this.renderPatientContactSideCard()}
        {this.renderPatientInsuranceSideCard()}
        {this.renderClinicalSideCard()}
        {this.renderOpenOrdersSideCard()}
      </MDBCard>
    );
  }

  renderContent() {
    if (this.state.isLoaded === false) {
      return this.renderLoadingSpinner();
    }

    return (
      <div>
        <ToastContainer
          hideProgressBar={false}
          newestOnTop={true}
          autoClose={5000}
        />
        {this.renderTabNav()}
        {this.renderTimelineModal()}
        <Container fluid style={{ minWidth: "100%", padding: 0 }}>
          <Row className="patientInformationRow">
            <Col className={"patientInformationCol sideBarColumn leftCol"}>
              {this.renderSideCard()}
            </Col>
            <Col
              className={"patientInformationCol  middleCol"}
              id={"middleCol"}
            >
              {this.state.TabsOneActiveItem === "4" ? null : (
                <MUIAlert severity="warning" variant="filled">
                  <MUIAlertTitle>This view is deprecated</MUIAlertTitle>
                  Please use the New Experience; this view will be removed from
                  Sales Pilot soon.
                </MUIAlert>
              )}
              <TabContent
                className="card patientInformationTabContent"
                activeItem={this.state.TabsOneActiveItem}
              >
                <TabPane tabId="1" role="tabpanel">
                  {this.renderOrdersCard()}
                </TabPane>
                <TabPane tabId="2" role="tabpanel">
                  {this.renderPatientInformation()}
                </TabPane>
                <TabPane tabId="3" role="tabpanel">
                  {this.renderInsuranceCard()}
                </TabPane>
                <TabPane tabId="4" role="tabpanel">
                  {this.renderOrderDetailsCard()}
                </TabPane>
                <TabPane tabId="5" role="tabpanel">
                  {this.renderEditClinicalInformationCard()}
                </TabPane>
              </TabContent>
            </Col>
            <Col className={"patientInformationCol rightCol"}>
              {this.renderRightCard()}
            </Col>
          </Row>
        </Container>
        {this.renderDialog()}
        {this.renderNewOrderModal()}
        {this.renderCreateServiceTicketModal()}
        {this.renderNewComplaintModal()}
        {this.renderEditLocationInformationModal()}
        {this.renderEditGeneralInformationModal()}
        {this.renderNewComplaintNoteModal()}
        {this.renderCloseComplaintModal()}
        {this.renderCancelTicketModal()}
        {this.renderAddAdditionalPartsModal()}
        {this.renderNewPatientNoteModal()}
        {this.renderPtnNoteModal()}
        {this.renderNewPhoneModal()}
        {this.renderAddPartCreateQuoteModal()}
        {this.renderApprovalModal()}
        {this.renderDeliveryNoteModal()}
        {this.renderReopenTicketModal()}
        {this.renderPaymentInformationModal()}
        {this.renderAbnModal()}
        {this.renderManualRouteDialog()}
        {this.renderDialogPatientIssueAlert()}
        {this.state.noteModalOpen ? (
          <DialogAddNote
            open={this.state.noteModalOpen}
            onClose={() => {
              this.toggleNoteModalPopup();
              this.setState({
                isSpecialNoteForBilling: false,
              });
            }}
            getNotes={() => this.retrieveNotes(this.state.curOrderId)}
            eOrder={this.state.eOrder}
            allNotes={this.state.notes}
            toggleNoteModal={this.toggleNoteModalPopup.bind(this)}
            addNoteUpdateOrderCloseModal={this.addNoteUpdateOrderCloseModal.bind(
              this,
            )}
            noteAssignedTo={this.state.patient.accountId}
            text={this.state.noteText}
            toggleProcessing={this.toggleProcessing.bind(this)}
            isOrderDetails={this.state.verificationNoteActivityId === null}
            handleRouting={this.handleSubmitRouteChange.bind(this)}
            approvalAction={this.state.radio.approvalAction}
            queueRoute={this.state.radio.queueRouting}
            verificationNoteActivityId={this.state.verificationNoteActivityId}
            isAutoVerification={this.state.isAutoVerification}
            isSpecialNoteForBilling={this.state.isSpecialNoteForBilling}
          />
        ) : null}

        <PverifyModal
          patientId={this.state.id}
          toggleInsuranceModal={() =>
            this.setState({
              verificationModalOpen: !this.state.verificationModalOpen,
            })
          }
          insuranceModal={this.state.verificationModalOpen}
          routeToVerification={() => {
            return;
            var o = this.state.eOrder;
            o.status = 1;
            o.orderStatusReasonId = 15;
            this.updateOrder(o);
            this.setState({
              verificationModalOpen: !this.state.verificationModalOpen,
            });
          }}
          results={
            this.state.curOrderId
              ? this.state.verificationResults.filter(
                  (result) => result.orderId === this.state.curOrderId,
                )
              : this.state.verificationResults
          }
          eOrder={this.state.eOrder}
          toggleNoteModal={(e, id) => {
            this.setState(
              {
                verificationNoteActivityId: id,
                noteText: e,
              },
              this.toggleNoteModalPopup(),
            );
          }}
          handleOnClick={() =>
            this.setState({
              isAutoVerification: true,
              verificationModalOpen: !this.state.verificationModalOpen,
            })
          }
        />
        <ReactTooltip />
      </div>
    );
  }
}
